/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export namespace ApiSchema {
  export interface AcceptFrameworkAndBuildDto {
    /** @format int32 */
    frameworkId: number;
  }

  export interface AcceptFrameworkAndBuildResultDto {
    /** @format int32 */
    projectId: number;
  }

  export interface AcceptInvitationDto {
    email: string;
    newPassword: string;
    token: string;
    acceptTerms: boolean;
    /** @format int32 */
    inviteId: number;
  }

  export interface AcceptInvitationResponse {
    user: UserDto;
    accessToken: AccessTokenDto;
  }

  export interface AcceptLinkInviteShareJobPayload {
    /** @format uuid */
    inviteIdentifier: string;
    /** @format int32 */
    teamId: number;
  }

  export interface AccessTokenDto {
    accessToken: string;
    /** @format int32 */
    expiresIn: number;
    idToken: string;
  }

  export interface AddAiBatchItemsDto {
    inputs: string[];
  }

  export interface AddQuestionTemplateJobPayload {
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    questionId: number;
  }

  export interface AddScheduleDto {
    projectDemographicIds: number[];
    questionCode: string;
    syncPriceSensitivities: boolean;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    regionIdToReplace?: number | null;
    /** @format int32 */
    runCount: number;
    isCustomerPanel?: boolean | null;
    /** @format int32 */
    sampleSize?: number | null;
    customScheduleDates?: string[] | null;
  }

  export interface AddUserMessageDto {
    message: string;
  }

  export interface AdditionalContextMetadata {
    typename: "AdditionalContextMetadata";
    additionalContext: AiMessageAdditionalContext[];
  }

  export type AdditionalContextType = "File" | "Text" | "FrameworkSelected";

  export type AddressFamily =
    | "Unspecified"
    | "Unix"
    | "InterNetwork"
    | "ImpLink"
    | "Pup"
    | "Chaos"
    | "NS"
    | "Iso"
    | "Ecma"
    | "DataKit"
    | "Ccitt"
    | "Sna"
    | "DecNet"
    | "DataLink"
    | "Lat"
    | "HyperChannel"
    | "AppleTalk"
    | "NetBios"
    | "VoiceView"
    | "FireFox"
    | "Banyan"
    | "Atm"
    | "InterNetworkV6"
    | "Cluster"
    | "Ieee12844"
    | "Irda"
    | "NetworkDesigners"
    | "Max"
    | "Packet"
    | "ControllerAreaNetwork"
    | "Unknown";

  export interface AdminAddDemographicTranslationsDto {
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    systemQuestionId: number;
    translatedSystemQuestionText: string;
    translatedSystemQuestionOptionTexts: Record<string, string>;
  }

  export interface AdminEditProjectDto {
    projectName?: string | null;
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    splitCellQuota?: number | null;
    researcherApproved?: boolean | null;
    questions: AdminEditQuestionDto[];
    testOptions: AdminEditTestOptionDto[];
    testOptionCells: AdminEditTestOptionCellDto[];
    newSchedules?: NewScheduleDto;
    researchNote?: string | null;
    internalResearchNote?: string | null;
    researchObjectives?: string | null;
    /** @format int32 */
    pricingSensitivityVersion?: number | null;
    randomiseConceptOrder?: boolean | null;
  }

  export interface AdminEditQuestionDto {
    /** @format int32 */
    id: number;
    questionTitle?: string | null;
  }

  export interface AdminEditTestOptionCellDto {
    /** @format int32 */
    key: number;
    /** @format int32 */
    numTestOptionsShown?: number | null;
  }

  export interface AdminEditTestOptionDto {
    /** @format int32 */
    id: number;
    conceptText?: string | null;
    /** @format int32 */
    testOptionCellKey?: number | null;
  }

  export interface AdminFilteredTranslationResult {
    /** @format int32 */
    id: number;
    translation: string;
    originalText: string;
    regionName: string;
    language?: string | null;
    entityType: TranslatableEntityTypes;
    /** @format int32 */
    entityId: number;
  }

  export interface AdminFilteredTranslationResultFilters {
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    projectId?: number | null;
    entityType: TranslatableEntityTypes;
    /** @format int32 */
    entityId?: number | null;
  }

  export interface AdminUpdateClientDto {
    name: string | null;
    active?: boolean | null;
    hsCompanyId?: string | null;
    ideallyOwned?: boolean | null;
    /** @format int32 */
    enterpriseId?: number | null;
  }

  export interface AdminUserCreateDto {
    email: string;
    /** @format int32 */
    roleId: number;
    clients: Record<string, UserAndClientsDto>;
  }

  export interface AdminUserUpdateDto {
    /** @format int32 */
    roleId: number;
    clients: Record<string, UserAndClientsDto>;
  }

  export interface AgentDto {
    /** @format int32 */
    aiModelDefinitionId: number;
    agentService: AiServiceLookup;
    reasoningEffort?: ReasoningEffort;
    executor: string;
    description?: string | null;
    tools?: string[] | null;
    instructions?: string | null;
    documentVersionIds?: number[] | null;
    /** @format float */
    temperature?: number | null;
    /** @format int32 */
    seed?: number | null;
    useWebSearch?: boolean | null;
    useCodeInterpreter: boolean;
    /** @format int32 */
    imageGenerationAiModelDefinitionId?: number | null;
    outputSchemaDescriptions?: Record<string, string>;
    typename: string;
  }

  export interface AgentExecutionDto {
    executorId: string;
    /** @format date-time */
    timestamp: string;
    messages: AiChatContent[];
  }

  export interface AgentExecutorInfoDto {
    executorId: string;
    schemaFields: ExecutorSchemaFieldDto[];
  }

  export interface AiArgument {
    key: string;
    value: string;
  }

  export interface AiBatch {
    /** @format int32 */
    id: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    name: string;
    /** @format int32 */
    promptId: number;
    /** @format int32 */
    batchGroupId?: number | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    aiBatchItems: AiBatchItem[];
    aiBatchRuns: AiBatchRun[];
    batchGroup?: AiBatchGroup;
    deletedByNavigation?: User;
    prompt: Prompt;
    prompts: Prompt[];
  }

  export interface AiBatchGroup {
    /** @format int32 */
    id: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    name: string;
    /** @format date-time */
    notificationSentAt?: string | null;
    aiBatches: AiBatch[];
    projectsAiBatchGroups: ProjectsAiBatchGroup[];
  }

  export interface AiBatchGroupSingleResult {
    queryable?: AiBatchGroup[] | null;
  }

  export interface AiBatchItem {
    /** @format int32 */
    id: number;
    serialisedInput?: string | null;
    /** @format int32 */
    aiBatchId: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    aiBatch: AiBatch;
    aiBatchRunItems: AiBatchRunItem[];
  }

  export interface AiBatchItemSingleResult {
    queryable?: AiBatchItem[] | null;
  }

  export interface AiBatchRun {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiBatchId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format int32 */
    promptVersionId: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    aiBatch: AiBatch;
    aiBatchRunItems: AiBatchRunItem[];
    createdByNavigation: User;
    deletedByNavigation?: User;
    promptVersion: PromptVersion;
    aiBatchRunScoresView?: AiBatchRunScoresView;
  }

  export interface AiBatchRunItem {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiBatchRunId: number;
    /** @format int32 */
    aiBatchItemId: number;
    /** @format int32 */
    aiConversationId: number;
    aiBatchItem: AiBatchItem;
    aiBatchRun: AiBatchRun;
    aiConversation: AiConversation;
  }

  export interface AiBatchRunItemSingleResult {
    queryable?: AiBatchRunItem[] | null;
  }

  export interface AiBatchRunScoresView {
    /** @format int32 */
    aiBatchRunId?: number | null;
    /** @format int32 */
    aiBatchId?: number | null;
    /** @format int32 */
    promptVersionId?: number | null;
    /** @format int64 */
    totalItems?: number | null;
    /** @format int64 */
    completedItems?: number | null;
    /** @format double */
    averageScore?: number | null;
    /** @format int64 */
    passCount?: number | null;
    /** @format int64 */
    totalEvaluations?: number | null;
    /** @format double */
    passRate?: number | null;
    status?: string | null;
    evaluationStatsByKey?: string | null;
    aiBatchRun: AiBatchRun;
  }

  export interface AiBatchRunSingleResult {
    queryable?: AiBatchRun[] | null;
  }

  export interface AiBatchSingleResult {
    queryable?: AiBatch[] | null;
  }

  export interface AiChatContent {
    mimeType?: string | null;
    metadata?: Record<string, any>;
    typename: "AiChatContent";
    items: Item[];
    role: Role;
    modelId?: string | null;
    authorName?: string | null;
  }

  export interface AiConversation {
    /** @format int32 */
    id: number;
    /** @format int32 */
    userId?: number | null;
    /** @format date-time */
    completedAt?: string | null;
    /** @format float */
    estimatedCost?: number | null;
    /** @format int32 */
    inputTokens?: number | null;
    /** @format int32 */
    outputTokens?: number | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format date-time */
    startedAt?: string | null;
    serialisedOutput?: string | null;
    /** @format date-time */
    createdAt: string;
    promptContent: string;
    /** @format int32 */
    promptVersionId: number;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    projectGroupId?: number | null;
    snapshot?: string | null;
    serialisedInput?: string | null;
    /** @format int32 */
    surveySessionId?: number | null;
    aiBatchRunItems: AiBatchRunItem[];
    aiConversationEvaluations: AiConversationEvaluation[];
    aiConversationS3Files: AiConversationS3File[];
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    aiProjectSummaries: AiProjectSummary[];
    aiThread?: AiThread;
    project?: Project;
    projectEmailSummaries: ProjectEmailSummary[];
    projectGroup?: ProjectGroup;
    promptVersion: PromptVersion;
    surveySession?: SurveySession;
    user?: User;
  }

  export interface AiConversationContentsResponse {
    messages: AiChatContent[];
    workflowRuns: WorkflowRunDto[];
  }

  export interface AiConversationETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface AiConversationEvaluation {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiConversationId: number;
    /** @format date-time */
    createdAt: string;
    key: string;
    details: string;
    /** @format int32 */
    aiEvaluationResultId: number;
    /** @format double */
    score: number;
    aiConversation: AiConversation;
    aiEvaluationResult: AiEvaluationResult;
  }

  export interface AiConversationEvaluationSingleResult {
    queryable?: AiConversationEvaluation[] | null;
  }

  export interface AiConversationS3File {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiConversationId: number;
    /** @format int32 */
    s3FileId: number;
    referenceId: string;
    aiConversation: AiConversation;
    s3File: S3File;
  }

  export interface AiConversationSingleResult {
    queryable?: AiConversation[] | null;
  }

  export interface AiEvaluationResult {
    /** @format int32 */
    id: number;
    name: string;
    aiConversationEvaluations: AiConversationEvaluation[];
  }

  export interface AiHostedFile {
    /** @format int32 */
    s3FileId: number;
    /** @format int32 */
    aiProviderId: number;
    hostedFileId: string;
    aiProvider: AiProvider;
    s3File: S3File;
  }

  export interface AiMessage {
    /** @format int32 */
    id: number;
    content?: string | null;
    /** @format int32 */
    aiRoleId: number;
    /** @format int32 */
    feedbackId?: number | null;
    metadata?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format int32 */
    aiThreadId: number;
    /** @format int32 */
    aiMessageTypeId: number;
    aiMessageType: AiMessageType;
    aiRole: AiRole;
    aiThread: AiThread;
    createdByNavigation: User;
    feedback?: Feedback;
    feedbackLookup?: FeedbackLookup;
    aiRoleLookup: AiRoleLookup;
    aiMessageTypeLookup: AiMessageTypeLookup;
    metadataObject: AiMessageMetadata;
  }

  export interface AiMessageAdditionalContext {
    type: AdditionalContextType;
    key: string;
    contextValue: string;
    displayValue?: string | null;
  }

  export type AiMessageMetadata = BaseAiMessageMetadata &
    (
      | BaseAiMessageMetadataTypenameMapping<"ResultMetadata", ResultMetadata>
      | BaseAiMessageMetadataTypenameMapping<"EmptyMetadata", EmptyMetadata>
      | BaseAiMessageMetadataTypenameMapping<"ExceptionMetadata", ExceptionMetadata>
      | BaseAiMessageMetadataTypenameMapping<"ResearchBuilderMetadata", ResearchBuilderMetadata>
      | BaseAiMessageMetadataTypenameMapping<
          "ResearchBuilderFrameworkMetadata",
          ResearchBuilderFrameworkMetadata
        >
      | BaseAiMessageMetadataTypenameMapping<"AdditionalContextMetadata", AdditionalContextMetadata>
      | BaseAiMessageMetadataTypenameMapping<"SectionUpdateMetadata", SectionUpdateMetadata>
      | BaseAiMessageMetadataTypenameMapping<"RefetchProjectMetadata", RefetchProjectMetadata>
      | BaseAiMessageMetadataTypenameMapping<
          "ResearchBuilderProgressMetadata",
          ResearchBuilderProgressMetadata
        >
      | BaseAiMessageMetadataTypenameMapping<
          "RespondentsCsvEditProposalMetadata",
          RespondentsCsvEditProposalMetadata
        >
    );

  export interface AiMessageSingleResult {
    queryable?: AiMessage[] | null;
  }

  export interface AiMessageType {
    /** @format int32 */
    id: number;
    name: string;
    aiMessages: AiMessage[];
  }

  export type AiMessageTypeLookup =
    | "Conversation"
    | "Result"
    | "Reasoning"
    | "Exception"
    | "FrontendTool"
    | "Progress";

  export type AiModelCapability = "Text" | "ImageGeneration";

  export interface AiModelDefinition {
    /** @format int32 */
    id: number;
    name: string;
    modelId: string;
    isFoundational: boolean;
    /** @format int32 */
    maxOutputTokens: number;
    isDeprecated: boolean;
    /** @format int32 */
    aiProviderId: number;
    reasoningOptions?: number[] | null;
    pricing?: number[] | null;
    capabilities: number[];
    aiProvider: AiProvider;
    promptsPromptEvaluations: PromptsPromptEvaluation[];
    aiServices: AiService[];
    aiProviderLookup: AiProviderLookup;
    aiServiceLookups: AiServiceLookup[];
    reasoningOptionsLookup?: ReasoningEffort[] | null;
    capabilitiesLookup: AiModelCapability[];
  }

  export interface AiModelDefinitionDto {
    /** @format int32 */
    definitionId: number;
    name: string;
    modelId: string;
    isFoundational: boolean;
    /** @format int32 */
    maxOutputTokens: number;
    provider: AiProviderLookup;
    services: AiServiceLookup[];
    reasoningOptions: ReasoningEffort[];
    capabilities: AiModelCapability[];
    isDeprecated: boolean;
  }

  export interface AiModelDefinitionSingleResult {
    queryable?: AiModelDefinition[] | null;
  }

  export interface AiProjectGroupSummary {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiProjectGroupSummaryTypeId: number;
    /** @format int32 */
    userId: number;
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    aiConversationId?: number | null;
    serialisedInput: string;
    serialisedOutput?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    completedAt?: string | null;
    /** @format int32 */
    estimatedDurationSec?: number | null;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int32 */
    projectGroupSegmentId?: number | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format int32 */
    questionOptionId?: number | null;
    /** @format int32 */
    demandZoneId?: number | null;
    aiConversation?: AiConversation;
    aiProjectGroupSummaryType: AiProjectGroupSummaryType;
    deletedByNavigation?: User;
    demandZone?: DemandZone;
    projectGroup: ProjectGroup;
    projectGroupSegment?: ProjectGroupSegment;
    question?: Question;
    questionOption?: QuestionOption;
    region?: Region;
    user: User;
    summaryOutput?: SummaryOutput;
  }

  export interface AiProjectGroupSummarySingleResult {
    queryable?: AiProjectGroupSummary[] | null;
  }

  export interface AiProjectGroupSummaryType {
    /** @format int32 */
    id: number;
    name: string;
    aiProjectGroupSummaries: AiProjectGroupSummary[];
  }

  export type AiProjectGroupSummaryTypes =
    | "SegmentOverview"
    | "OccasionBySegment"
    | "UandAByOccasion"
    | "OccasionsOverview"
    | "UandABySegment"
    | "UandAByDemandZone";

  export interface AiProjectSummary {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiSummaryTypeId: number;
    /** @format int32 */
    userId: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    aiConversationId?: number | null;
    /** @format int32 */
    week?: number | null;
    serialisedInput: string;
    serialisedOutput?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    benchmarkTypeId?: number | null;
    /** @format int32 */
    themeId?: number | null;
    /** @format date-time */
    completedAt?: string | null;
    /** @format int32 */
    estimatedDurationSec?: number | null;
    /** @format date-time */
    startedAt?: string | null;
    /** @format int32 */
    segmentId?: number | null;
    /** @format int32 */
    projectObjectiveId?: number | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    comparisonDisplayMode?: string | null;
    aiConversation?: AiConversation;
    aiSummaryType: AiSummaryType;
    benchmarkType?: BenchmarkType;
    deletedByNavigation?: User;
    project: Project;
    projectObjective?: ProjectObjective;
    question?: Question;
    region?: Region;
    segment?: Segment;
    testOption?: TestOption;
    theme?: Theme;
    user: User;
    emailSummary?: EmailSummaryOutput;
    listSummary?: SummaryOutput;
    mapSummary?: SummaryOutput;
    testGroupPerformanceSummary?: TestGroupPerformanceSummaryOutput;
    driversSummary?: DriversSummaryOutput;
    recommendedScreeners?: RecommendedQuestionsOutput;
    recommendedInsideTheLoop?: RecommendedQuestionsOutput;
    recommendedOutsideTheLoop?: RecommendedQuestionsOutput;
    profileQuestionSummary?: SummaryOutput;
    fullTestSummary?: SummaryOutput;
    qualQuestionSummary?: SummaryOutput;
    priceSensitivitySummary?: SummaryOutput;
  }

  export interface AiProjectSummarySingleResult {
    queryable?: AiProjectSummary[] | null;
  }

  export interface AiProvider {
    /** @format int32 */
    id: number;
    name: string;
    aiHostedFiles: AiHostedFile[];
    aiModelDefinitions: AiModelDefinition[];
    clients: Client[];
  }

  export type AiProviderLookup = "OpenAi" | "AnthropicAwsUs" | "AnthropicAwsApac" | "Anthropic" | "Google";

  export interface AiProviderSingleResult {
    queryable?: AiProvider[] | null;
  }

  export interface AiRole {
    /** @format int32 */
    id: number;
    name: string;
    aiMessages: AiMessage[];
  }

  export type AiRoleLookup = "User" | "Assistant" | "Developer" | "System";

  export interface AiService {
    /** @format int32 */
    id: number;
    name: string;
    promptsPromptEvaluations: PromptsPromptEvaluation[];
    aiModelDefinitions: AiModelDefinition[];
  }

  export type AiServiceLookup =
    | "OpenAiChatCompletion"
    | "OpenAiResponses"
    | "Anthropic"
    | "Bedrock"
    | "Gemini";

  export interface AiServiceSingleResult {
    queryable?: AiService[] | null;
  }

  export interface AiSummaryType {
    /** @format int32 */
    id: number;
    name: string;
    aiProjectSummaries: AiProjectSummary[];
  }

  export type AiSummaryTypes =
    | "ListViewSummary"
    | "MapViewSummary"
    | "TestGroupPerformanceSummary"
    | "DriversSummary"
    | "ProfileQuestion"
    | "FullTestSummary"
    | "QualQuestionSummary"
    | "DriversSummaryByTheme"
    | "ListViewSummaryMultiple"
    | "MapViewSummaryMultiple"
    | "EmailSummaryIdea"
    | "EmailSummaryMessage"
    | "EmailSummaryNpd"
    | "EmailSummaryQuestion"
    | "PriceSensitivitySummary";

  export interface AiThread {
    /** @format int32 */
    id: number;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    aiThreadStatusId: number;
    /** @format int32 */
    aiConversationId: number;
    aiConversation: AiConversation;
    aiMessages: AiMessage[];
    aiThreadStatus: AiThreadStatus;
    amaThread?: AmaThread;
    createdByNavigation: User;
    researchBuilderThread?: ResearchBuilderThread;
    surveyRunRespondentsCsvEditThread?: SurveyRunRespondentsCsvEditThread;
    statusLookup: AiThreadStatusLookup;
  }

  export interface AiThreadSingleResult {
    queryable?: AiThread[] | null;
  }

  export interface AiThreadStatus {
    /** @format int32 */
    id: number;
    name: string;
    aiThreads: AiThread[];
  }

  export type AiThreadStatusLookup = "Created" | "InProgress" | "Completed" | "Failed";

  export interface AmaThread {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiThreadId: number;
    name?: string | null;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    teamId: number;
    aiThread: AiThread;
    project: Project;
    team: Team;
  }

  export interface AmaThreadSingleResult {
    queryable?: AmaThread[] | null;
  }

  export interface AnnotationContent {
    mimeType?: string | null;
    modelId?: string | null;
    metadata?: Record<string, any>;
    typename: "AnnotationContent";
    kind: AnnotationKind;
    label: string;
    referenceId: string;
    title?: string | null;
    /** @format int32 */
    startIndex?: number | null;
    /** @format int32 */
    endIndex?: number | null;
  }

  export interface AnnotationKind {
    label: string;
  }

  export interface ApiKey {
    /** @format int32 */
    id: number;
    name: string;
    keyHash: string;
    keyPrefix: string;
    /** @format int32 */
    userId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    expiresAt?: string | null;
    /** @format date-time */
    lastUsedAt?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    user: User;
  }

  export interface ApiKeyCreationResultDto {
    /** @format int32 */
    id: number;
    plainTextKey: string;
    keyPrefix: string;
    name: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    expiresAt?: string | null;
  }

  export interface ApiKeySingleResult {
    queryable?: ApiKey[] | null;
  }

  export interface ApplyClause {
    transformations?: TransformationNode[] | null;
  }

  export interface ApplyQueryOption {
    context?: any;
    resultClrType?: Type;
    applyClause?: ApplyClause;
    rawValue?: string | null;
  }

  export interface ApplyRespondentsCsvEditProposalDto {
    referenceId: string;
  }

  export interface AsnEncodedData {
    oid?: Oid;
    /** @format byte */
    rawData: string;
  }

  export interface Assembly {
    definedTypes: TypeInfo[];
    exportedTypes: Type[];
    /** @deprecated */
    codeBase?: string | null;
    entryPoint?: MethodInfo;
    fullName?: string | null;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    /** @deprecated */
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    /** @deprecated */
    globalAssemblyCache: boolean;
    /** @format int64 */
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
  }

  export interface AssignPromptEvaluationsDto {
    evaluations: PromptEvaluationAssignment[];
  }

  export interface AsymmetricAlgorithm {
    /** @format int32 */
    keySize: number;
    legalKeySizes: KeySizes[];
    signatureAlgorithm?: string | null;
    keyExchangeAlgorithm?: string | null;
  }

  export interface AuthChallengeDto {
    challenge: AuthChallenges;
    session: string;
    typename: "AuthChallengeDto";
  }

  export type AuthChallenges = "NewPasswordRequired";

  export interface AuthFailureDto {
    message: string;
    typename: "AuthFailureDto";
  }

  export interface BackfillResearchObjectivesDto {
    reset: boolean;
  }

  export type BarrierType = "Skepticism" | "Comprehension" | "Challenge";

  export interface BarriersMetadata {
    typename: "BarriersMetadata";
    barrierType: BarrierType;
  }

  export interface BatchInfo {
    promptName: string;
    /** @format int32 */
    conversationCount: number;
  }

  export interface BenchmarkComparison {
    /** @format int32 */
    benchmarkTypeId: number;
    /** Name of the benchmark (e.g. Ideally Average, Team Average, Category Average) */
    benchmarkName: string;
    /** @format double */
    benchmarkPercentage: number;
    /**
     * Percentage point difference above (positive) or below (negative) the benchmark
     * @format double
     */
    diff: number;
    /** Whether the difference from this benchmark is statistically significant (binomial test, p < 0.05) */
    isStatSig: boolean;
  }

  export interface BenchmarkPerformanceMetadata {
    typename: "BenchmarkPerformanceMetadata";
    benchmarkTypeId: BenchmarkTypes;
  }

  export interface BenchmarkResult {
    /** @format int32 */
    benchmarkTypeId: number;
    projectType: string;
    benchmarkType: string;
    benchmarkName: string;
    /** @format int32 */
    regionId: number;
    regionCode: string;
    /** @format int32 */
    standardQuestionId: number;
    /** @format double */
    top1Weighted: number;
    /** @format double */
    top2Weighted: number;
    /** @format double */
    totalWeight: number;
    /** @format double */
    top1Percentage: number;
    /** @format double */
    top2Percentage: number;
    /** @format double */
    top1PercentageTotal: number;
    /** @format double */
    top2PercentageTotal: number;
    /** @format int32 */
    projectCount: number;
    isAvailable: boolean;
  }

  export interface BenchmarkType {
    /** @format int32 */
    id: number;
    name: string;
    aiProjectSummaries: AiProjectSummary[];
  }

  export type BenchmarkTypes =
    | "IdeallyAverage"
    | "ClientAverage"
    | "ProductTypeAverage"
    | "WeekIdeallyAverage1_8"
    | "WeekIdeallyAverage9_16"
    | "WeekIdeallyAverage17_25"
    | "WeekIdeallyAverage26Plus"
    | "CategoryAverage"
    | "ProjectGroupAverage"
    | "ParentCategoryAverage";

  export interface BooleanSingleResult {
    queryable?: boolean[] | null;
  }

  export type BreakdownBy =
    | "NoBreakdown"
    | "ByWeek"
    | "ByAnswerValue"
    | "ByDemographic"
    | "ByAdhocQuestion"
    | "ByTestOption"
    | "ByCategorySegment"
    | "ByPanelType"
    | "ByTotalAggregate"
    | "ByDemandZone";

  export interface BulkInviteDto {
    users: UserCreateDto[];
  }

  export interface BundleIdentificationMetadata {
    typename: "BundleIdentificationMetadata";
    bundleType: BundleType;
  }

  export type BundleType = "BestBundle" | "MarginalReach" | "OptimalSize";

  export interface ByteReadOnlyMemory {
    /** @format int32 */
    length: number;
    isEmpty: boolean;
    span: ByteReadOnlySpan;
  }

  export interface ByteReadOnlySpan {
    /** @format int32 */
    length: number;
    isEmpty: boolean;
  }

  export type CallingConventions = "Standard" | "VarArgs" | "Any" | "HasThis" | "ExplicitThis";

  export interface CancellationToken {
    isCancellationRequested: boolean;
    canBeCanceled: boolean;
    waitHandle: WaitHandle;
  }

  export interface CategoriesView {
    /** @format int32 */
    id?: number | null;
    name?: string | null;
    /** @format int32 */
    parentCategoryId?: number | null;
    groupName?: string | null;
    categories?: string | null;
    categoryIds?: number[] | null;
    projects: Project[];
  }

  export interface CategoriesViewSingleResult {
    queryable?: CategoriesView[] | null;
  }

  export interface Category {
    /** @format int32 */
    id: number;
    name: string;
    /** @format int32 */
    parentCategoryId?: number | null;
    inverseParentCategory: Category[];
    parentCategory?: Category;
    products: Product[];
    projectGroups: ProjectGroup[];
    projects: Project[];
  }

  export interface ChangeProjectFrameworkDto {
    /** @format int32 */
    frameworkId: number;
  }

  export interface ChannelInfoDto {
    name: string;
    token: string;
  }

  export interface ChargebeeCredit {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    creditLogId?: number | null;
    lineItemId: string;
    sku: string;
    /** @format int32 */
    creditAmount: number;
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
    /** @format date-time */
    createdAt?: string | null;
    customerId: string;
    /** @format int32 */
    invoiceId: number;
    client: Client;
    creditLog?: CreditLog;
  }

  export interface ChargebeeSubscription {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId?: number | null;
    /** @format date-time */
    currentTermEnd?: string | null;
    /** @format date-time */
    currentTermStart?: string | null;
    customerId?: string | null;
    /** @format int64 */
    billingPeriod?: number | null;
    billingPeriodUnit?: string | null;
    /** @format int32 */
    creditAmount?: number | null;
    subscriptionId: string;
    status: string;
    /** @format int32 */
    termCreditAmount?: number | null;
    client?: Client;
  }

  export interface ChatMessageContent {
    mimeType?: string | null;
    modelId?: string | null;
    metadata?: Record<string, any>;
    typename: "ChatMessageContent";
  }

  export interface Claim {
    issuer: string;
    originalIssuer: string;
    properties: Record<string, string>;
    subject?: ClaimsIdentity;
    type: string;
    value: string;
    valueType: string;
  }

  export interface ClaimsIdentity {
    authenticationType?: string | null;
    isAuthenticated: boolean;
    actor?: ClaimsIdentity;
    bootstrapContext?: any;
    claims: Claim[];
    label?: string | null;
    name?: string | null;
    nameClaimType: string;
    roleClaimType: string;
  }

  export interface ClaimsPrincipal {
    claims: Claim[];
    identities: ClaimsIdentity[];
    identity?: IIdentity;
  }

  export interface Client {
    name?: string | null;
    status?: string | null;
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    hsCompanyId?: string | null;
    domain?: string | null;
    domainRecord?: string | null;
    /** @format date-time */
    domainValidatedAt?: string | null;
    /** @format int32 */
    ssoCognitoIdpId?: number | null;
    ssoEnabled: boolean;
    /** @format int32 */
    ssoDefaultRoleId?: number | null;
    /** @format int32 */
    enterpriseId?: number | null;
    /** @format int32 */
    orgId?: number | null;
    /** @format int32 */
    teamId?: number | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    ideallyOwned: boolean;
    nameClean?: string | null;
    /** @format int32 */
    aiProviderOverrideId?: number | null;
    brandGuideMd?: string | null;
    /** @format int32 */
    documentPlatformId?: number | null;
    /** @format int32 */
    logoS3FileId?: number | null;
    aiProviderOverride?: AiProvider;
    chargebeeCredits: ChargebeeCredit[];
    chargebeeSubscriptions: ChargebeeSubscription[];
    clientFeatures: ClientFeature[];
    clientQuestionTemplates: ClientQuestionTemplate[];
    cognitoSamlLoginRequests: CognitoSamlLoginRequest[];
    creditLogs: CreditLog[];
    documentPlatform?: DocumentPlatform;
    enterprise?: Enterprise;
    logoS3File?: S3File;
    maxioSubscriptions: MaxioSubscription[];
    org?: Org;
    projectGroupShares: ProjectGroupShare[];
    segments: Segment[];
    ssoCognitoIdp?: CognitoIdp;
    ssoDefaultRole?: UserClientRole;
    team?: Team;
    userAndClients: UserAndClient[];
    credits?: ClientCreditsView;
    hubspotCompanies?: ClientHubspotCompaniesView;
    questionTemplates: QuestionTemplatesView[];
    tier: ClientTierLookup;
  }

  export interface ClientCreditsView {
    /** @format int32 */
    clientId?: number | null;
    /** @format double */
    balance?: number | null;
    /** @format double */
    credits?: number | null;
    /** @format double */
    spend?: number | null;
    /** @format double */
    spendCurrentCycle?: number | null;
    /** @format double */
    balanceIncludingChildren?: number | null;
    /** @format double */
    spendIncludingChildren?: number | null;
    /** @format double */
    spendCurrentCycleIncludingChildren?: number | null;
    /** @format double */
    creditsIncludingChildren?: number | null;
    /** @format double */
    teamSpendCurrentCycle?: number | null;
    client: Client;
    linkedClient: ClientsView;
  }

  export interface ClientFeature {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    featureFlagId: number;
    isEnabled: boolean;
    client: Client;
    featureFlag: FeatureFlag;
  }

  export interface ClientFeatureDto {
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    featureFlagId: number;
  }

  export interface ClientFeatureSingleResult {
    queryable?: ClientFeature[] | null;
  }

  export interface ClientHubspotCompaniesView {
    /** @format int32 */
    clientId?: number | null;
    clientType?: string | null;
    domain?: string | null;
    name?: string | null;
    industry?: string | null;
    /** @format int32 */
    csm?: number | null;
    /** @format int32 */
    leadResearcher?: number | null;
    /** @format int32 */
    companyOwner?: number | null;
    demo?: boolean | null;
    hubspotId?: string | null;
    currencyCode?: string | null;
    customerType?: string | null;
    businessModel?: string | null;
    overdueInvoice?: boolean | null;
    client: Client;
    linkedClient: ClientsView;
  }

  export interface ClientQuestionTemplate {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    questionId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format int32 */
    questionPositionId: number;
    client: Client;
    createdByNavigation: User;
    deletedByNavigation?: User;
    question: Question;
    questionPosition: QuestionPosition;
  }

  export interface ClientQuestionTemplateSingleResult {
    queryable?: ClientQuestionTemplate[] | null;
  }

  export type ClientSettingTier = "Self" | "Org" | "Enterprise" | "Ideally";

  export interface ClientSingleResult {
    queryable?: Client[] | null;
  }

  export interface ClientSubData {
    /** @format int32 */
    id: number;
    /** @format int32 */
    billingPeriod: number;
    billingPeriodUnit: string;
    /** @format date-time */
    subEndDate: string;
    /** @format date-time */
    subStartDate: string;
    /** @format int32 */
    creditAmount: number;
    /** @format double */
    creditSpend: number;
  }

  export type ClientTierLookup = "Enterprise" | "Org" | "Team";

  export interface ClientsView {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    clientId?: number | null;
    name?: string | null;
    parentName?: string | null;
    orgName?: string | null;
    enterpriseName?: string | null;
    /** @format int32 */
    teamId?: number | null;
    /** @format int32 */
    orgId?: number | null;
    /** @format int32 */
    enterpriseId?: number | null;
    parentPays?: boolean | null;
    requireApprovals?: boolean | null;
    teamAdminsCanApprove?: boolean | null;
    isOverdueAccount?: boolean | null;
    /** @format date-time */
    domainValidatedAt?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    hubspotCompanies?: ClientHubspotCompaniesView;
    credits?: ClientCreditsView;
    tier: ClientTierLookup;
  }

  export interface ClientsViewSingleResult {
    queryable?: ClientsView[] | null;
  }

  export interface CloneProjectGroupResult {
    /** @format int32 */
    newProjectGroupId: number;
    projectGroupsQuestionIdMap: Record<string, number>;
    projectGroupSegmentIdMap: Record<string, number>;
    questionIdMap: Record<string, number>;
    questionOptionIdMap: Record<string, number>;
  }

  export interface CloseProjectSurveyDto {
    externalId: string;
  }

  export interface CognitoIdp {
    /** @format int32 */
    id: number;
    name: string;
    /** @format uuid */
    identifier: string;
    /** @format int32 */
    cognitoIdpTypeId: number;
    clients: Client[];
    cognitoIdpType: CognitoIdpType;
    cognitoSamlLoginRequests: CognitoSamlLoginRequest[];
    cognitoUsers: CognitoUser[];
    providerName: string;
  }

  export interface CognitoIdpSingleResult {
    queryable?: CognitoIdp[] | null;
  }

  export interface CognitoIdpType {
    /** @format int32 */
    id: number;
    name: string;
    cognitoIdps: CognitoIdp[];
  }

  export interface CognitoSamlLoginRequest {
    /** @format int32 */
    id: number;
    /** @format uuid */
    state: string;
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    cognitoIdpId: number;
    email: string;
    /** @format date-time */
    createdAt: string;
    codeVerifier: string;
    client: Client;
    cognitoIdp: CognitoIdp;
  }

  export type CognitoStatus =
    | "ARCHIVED"
    | "COMPROMISED"
    | "CONFIRMED"
    | "FORCE_CHANGE_PASSWORD"
    | "RESET_REQUIRED"
    | "UNCONFIRMED"
    | "UNKNOWN";

  export interface CognitoUser {
    /** @format int32 */
    id: number;
    /** @format int32 */
    userId: number;
    /** @format int32 */
    cognitoIdpId: number;
    username: string;
    cognitoIdp: CognitoIdp;
    user: User;
  }

  export interface CognitoUserSingleResult {
    queryable?: CognitoUser[] | null;
  }

  export interface ComputeClause {
    computedItems?: ComputeExpression[] | null;
  }

  export interface ComputeExpression {
    expression?: SingleValueNode;
    alias?: string | null;
    typeReference?: any;
  }

  export interface ComputeQueryOption {
    context?: any;
    resultClrType?: Type;
    computeClause?: ComputeClause;
    rawValue?: string | null;
    validator?: IComputeQueryValidator;
  }

  export interface ConfirmUserEmailJobPayload {
    email: string;
    code: string;
  }

  export interface ConnectionInfo {
    id: string;
    remoteIpAddress?: IPAddress;
    /** @format int32 */
    remotePort: number;
    localIpAddress?: IPAddress;
    /** @format int32 */
    localPort: number;
    clientCertificate?: X509Certificate2;
  }

  export interface ConstructorInfo {
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
  }

  export interface ContinueConversationDto {
    clone: boolean;
  }

  export interface CountQueryOption {
    context?: any;
    rawValue?: string | null;
    value: boolean;
    validator?: ICountQueryValidator;
  }

  export interface CreateAiBatchDto {
    name: string;
    /** @format int32 */
    promptId: number;
  }

  export interface CreateAiModelDefinitionDto {
    name: string;
    modelId: string;
    isFoundational: boolean;
    /** @format int32 */
    maxOutputTokens: number;
    isDeprecated: boolean;
    /** @format int32 */
    aiProviderId: number;
    aiServicesIds: number[];
    reasoningOptions?: number[] | null;
    pricing?: number[] | null;
  }

  export interface CreateAiProjectGroupSummaryDto {
    inputDto: ProjectGroupSummaryInputDto;
    /** @format int32 */
    promptVersionId?: number | null;
  }

  export interface CreateAiProjectSummaryDto {
    inputDto: ProjectSummaryInputDto;
    summaryType: AiSummaryTypes;
  }

  export interface CreateAmaThreadDto {
    /** @format int32 */
    projectId: number;
    name?: string | null;
    initialMessage?: string | null;
    /** @format int32 */
    promptVersionId?: number | null;
    additionalContext?: AiMessageAdditionalContext[] | null;
  }

  export interface CreateApiKeyDto {
    name: string;
    /** @format date-time */
    expiresAt: string;
  }

  export interface CreateCreditLogDto {
    /** @format double */
    creditAmount: number;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    creditLogTypeId?: number | null;
    description?: string | null;
    notes?: string | null;
    /** @format int32 */
    linkedCreditLogId?: number | null;
    /** @format date-time */
    transactionTimestamp?: string | null;
  }

  export interface CreateDemandZoneCellJobPayload {
    /** @format int32 */
    demandZoneId: number;
    /** @format int32 */
    questionOptionId: number;
    /** @format int32 */
    projectGroupSegmentId: number;
  }

  export interface CreateDemandZoneJobPayload {
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    regionId: number;
    zoneName: string;
    zoneDescription?: string | null;
  }

  export interface CreateDocumentDto {
    name: string;
  }

  export interface CreateDocumentVersionDto {
    /** @format int32 */
    documentId: number;
    content: string;
    description?: string | null;
  }

  export interface CreateEditDisplayScheduleDto {
    /** @format int32 */
    dayOfTheWeek: number;
    /** @format time */
    time: string;
    /** @format int32 */
    regionId: number;
  }

  export interface CreateEditDisplayScheduleExceptionDto {
    /** @format int32 */
    regionId: number;
    comment?: string | null;
    /** @format date-time */
    dateEnd?: string | null;
    /** @format date-time */
    dateStart: string;
    applyGlobally?: boolean | null;
  }

  export interface CreateEnterpriseDto {
    name: string;
    active: boolean;
    hsCompanyId?: string | null;
  }

  export interface CreateLinkInviteDto {
    /** @format int32 */
    demoProjectId?: number | null;
    /** @format date-time */
    expiresAt?: string | null;
  }

  export interface CreateManualRespondentsCsvProposalDto {
    stagingFileName: string;
  }

  export interface CreateManualRespondentsCsvProposalResultDto {
    /** @format int32 */
    aiThreadId: number;
    referenceId: string;
  }

  export interface CreateOrgDto {
    name: string;
    active: boolean;
    hsCompanyId?: string | null;
    isOverdue: boolean;
    teamName?: string | null;
    /** @format int32 */
    enterpriseId?: number | null;
  }

  export interface CreateProjectCommentDto {
    /** @format int32 */
    projectId: number;
    section: FollowUpSectionType;
    content: string;
    /** @format int32 */
    replyToId?: number | null;
  }

  export interface CreateProjectFileDto {
    /** @format int32 */
    projectId: number;
    /** @minLength 1 */
    key: string;
    /** @minLength 1 */
    contentType: string;
    projectFileType: ProjectFileTypes;
  }

  export interface CreateProjectGroupSegmentDto {
    /** @format int32 */
    projectGroupId: number;
    name: string;
    filters: GroupSegmentFilter[];
    isCategorySegment?: boolean | null;
  }

  export interface CreateProjectNarrativeSectionDto {
    /** @format int32 */
    projectNarrativeVersionId: number;
    /** @format int32 */
    sortOrder: number;
  }

  export interface CreateProjectObjectiveDto {
    summary: string;
    /** @format int32 */
    projectId: number;
  }

  export interface CreateProjectPriceSensitivitiesDto {
    regionIds: number[];
    /** @format double */
    highPrice: number;
    /** @format double */
    lowPrice: number;
  }

  export interface CreateProjectSchedulesDto {
    /** @format int32 */
    projectId: number;
    scheduleDates: string[];
    regionIds?: number[] | null;
    /** @format int32 */
    timesToRun: number;
    isManualSchedule?: boolean | null;
    hasCustomerPanel?: boolean | null;
    /** @format int32 */
    sampleSize?: number | null;
    surveyPlatform?: SurveyPlatformLookup;
  }

  export interface CreateProjectShareDto {
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    teamId: number;
  }

  export interface CreateProjectWatcherDto {
    /** @format int32 */
    teamId: number;
    forceCreate?: boolean | null;
  }

  export interface CreatePromptDto {
    description: string;
  }

  export interface CreatePromptEvaluationDto {
    name: string;
  }

  export interface CreatePromptVersionDto {
    /** @format int32 */
    promptId: number;
    description: string;
    /** @format int32 */
    promptVersionIdToCopy?: number | null;
  }

  export interface CreateResearchBuilderThreadDto {
    /** @format int32 */
    projectId?: number | null;
    name?: string | null;
    initialMessage?: string | null;
    /** @format int32 */
    promptVersionId?: number | null;
    additionalContext?: AiMessageAdditionalContext[] | null;
    /** @format int32 */
    preSelectedFrameworkId?: number | null;
  }

  export interface CreateResearchBuilderThreadFileDto {
    key: string;
    contentType: string;
    fileType: ProjectFileTypes;
  }

  export interface CreateSamlCognitoIdpDto {
    name: string;
    metadataUrl?: string | null;
    metadataXml?: string | null;
    /** @format int32 */
    defaultRoleId: number;
  }

  export interface CreateSegmentDto {
    /** @format int32 */
    projectId: number;
    name: string;
    filters: SegmentResponsesFilters;
  }

  export interface CreateSurveyRunRespondentsCsvEditThreadDto {
    initialMessage?: string | null;
  }

  export interface CreateSurveysDto {
    schedules: ManualSurveyScheduleDto[];
    regionSurveyNames: Record<string, string>;
    surveyCreateSettings?: SurveyCreateSettingsDto;
  }

  export interface CreateTeamDto {
    name: string;
    active: boolean;
    /** @format int32 */
    orgId: number;
    parentPays?: boolean | null;
    requireApprovals?: boolean | null;
    teamAdminsCanApprove?: boolean | null;
    autoResolveNameConflicts?: boolean | null;
  }

  export interface CreateUsageAndAttitudeSeedProjectJobPayload {
    /** @format int32 */
    projectGroupId: number;
    regionIds: number[];
    /** @format int32 */
    scheduleFrequencyWeeks: number;
  }

  export interface CreateUserAiMessageDto {
    /** @format int32 */
    aiThreadId: number;
    content: string;
    additionalContext?: AiMessageAdditionalContext[] | null;
    aiRoleOverride?: AiRoleLookup;
  }

  export interface CreditCostTotalDto {
    /** @format double */
    totalChargedCreditCost: number;
    perRegionCost: ProjectScheduleEstimate[];
    /** @format double */
    teamCredits: number;
    /** @format double */
    orgCredits: number;
    /** @format double */
    totalCreditsAvailable: number;
    /** @format double */
    orgTransferFutureReBalance: number;
    /** @format double */
    teamTotalFutureCharge: number;
    /** @format double */
    teamRemainingFutureCredits: number;
  }

  export interface CreditLog {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    creditLogTypeId: number;
    /** @format int32 */
    createdById: number;
    /** @format int32 */
    surveyRunId?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format double */
    creditAmount: number;
    /** @format date-time */
    transactionTimestamp: string;
    metadata?: string | null;
    description?: string | null;
    internalNotes?: string | null;
    /** @format int32 */
    usedByTeamId?: number | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format int32 */
    projectScheduleId?: number | null;
    chargebeeCredits: ChargebeeCredit[];
    client: Client;
    createdBy: User;
    creditLogType: CreditLogType;
    deletedByNavigation?: User;
    hubspotCredits: HubspotCredit[];
    project?: Project;
    projectSchedule?: ProjectSchedule;
    surveyRun?: SurveyRun;
    usedByTeam?: Team;
  }

  export interface CreditLogSingleResult {
    queryable?: CreditLog[] | null;
  }

  export interface CreditLogType {
    /** @format int32 */
    id: number;
    name: string;
    defaultDescription?: string | null;
    title?: string | null;
    creditLogs: CreditLog[];
    lookup: CreditLogTypeLookup;
  }

  export type CreditLogTypeLookup =
    | "HubspotDeal"
    | "CBSubscription"
    | "PendingSurveyRun"
    | "SurveyRun"
    | "ServProjectLoad"
    | "ServReporting"
    | "ServAnalysis"
    | "AddRunAdj"
    | "StdQuestionAdj"
    | "AddProfilerAdj"
    | "MakeGoodAdj"
    | "BoostedSampleAdj"
    | "MonadicAdj"
    | "Freebie"
    | "OtherAdj"
    | "PendingTransfer"
    | "Transfer";

  export interface CreditLogTypeSingleResult {
    queryable?: CreditLogType[] | null;
  }

  export interface CrossOptionComparisonMetadata {
    typename: "CrossOptionComparisonMetadata";
    /**
     * ID of the leading / winning test option, if there is a clear leader. Use a real testOptionId from the supporting facts — never invent IDs. Null if no clear leader
     * @format int32
     */
    leadingOptionId?: number | null;
  }

  export type CrosstabBy = "ByCategorySegment" | "ByAdhocQuestion";

  export interface CrosstabResult {
    /** @format int32 */
    count: number;
    /** @format int32 */
    countByCrosstab: number;
    /** @format int32 */
    countTotal: number;
    /** @format double */
    percentage: number;
    /** @format double */
    percentageBase: number;
    isSignificant: boolean;
    /** @format int32 */
    optionId: number;
    optionText: string;
    /** @format int32 */
    questionId: number;
    questionTitle: string;
    /** @format int32 */
    crosstabById: number;
  }

  export interface CustomAttributeData {
    attributeType: Type;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
  }

  export interface CustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
  }

  export interface CustomAttributeTypedArgument {
    argumentType: Type;
    value?: any;
  }

  export interface DataEventsLog {
    /** @format int32 */
    id: number;
    /** @format int32 */
    dataEventsLogTypeId?: number | null;
    entity?: string | null;
    /** @format int32 */
    entityId?: number | null;
    /** @format int32 */
    userId?: number | null;
    /** @format date-time */
    createdAt?: string | null;
    metadata?: string | null;
    dataEventsLogType?: DataEventsLogType;
    user?: User;
    dataEventsLogTypeLookup?: DataEventsLogTypeLookup;
  }

  export interface DataEventsLogSingleResult {
    queryable?: DataEventsLog[] | null;
  }

  export interface DataEventsLogType {
    /** @format int32 */
    id: number;
    typeLabel?: string | null;
    dataEventsLogs: DataEventsLog[];
    dataEventsLogTypeLookup: DataEventsLogTypeLookup;
  }

  export type DataEventsLogTypeLookup = "Created" | "Deleted" | "Updated";

  export interface DecipherCompletesCountDto {
    externalId: string;
    /** @format int32 */
    qualifiedCount?: number | null;
  }

  export interface DecipherRespondentDto {
    psid: string;
    uuid: string;
  }

  export interface DecipherTranslationsCountDto {
    /** @format int32 */
    totalRequired: number;
    /** @format int32 */
    totalUploaded: number;
  }

  export interface DefaultQueryConfigurations {
    enableExpand: boolean;
    enableSelect: boolean;
    enableCount: boolean;
    enableOrderBy: boolean;
    enableFilter: boolean;
    /** @format int32 */
    maxTop?: number | null;
    enableSkipToken: boolean;
  }

  export interface DeleteProjectPriceSensitivitiesDto {
    regionIds: number[];
  }

  export type DeltaItemKind = "Resource" | "DeletedResource" | "DeltaDeletedLink" | "DeltaLink" | "Unknown";

  export interface DemandLandscapeWeightedDto {
    /** @format int32 */
    questionOptionId: number;
    /** @format int32 */
    projectGroupSegmentId: number;
    /** @format float */
    weight: number;
    /** @format float */
    weightScored: number;
    /** @format int32 */
    additionalQuestionId: number | null;
    /** @format int32 */
    sessionCount: number;
    /** @format float */
    percentage: number;
    /** @format int32 */
    demandZoneId: number | null;
  }

  export interface DemandZone {
    /** @format int32 */
    id: number;
    name: string;
    description?: string | null;
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    regionId: number;
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    demandZoneCells: DemandZoneCell[];
    projectGroup: ProjectGroup;
    region: Region;
  }

  export interface DemandZoneCell {
    /** @format int32 */
    id: number;
    /** @format int32 */
    demandZoneId: number;
    /** @format int32 */
    questionOptionId: number;
    /** @format int32 */
    projectGroupSegmentId: number;
    demandZone: DemandZone;
    projectGroupSegment: ProjectGroupSegment;
    questionOption: QuestionOption;
  }

  export interface DemandZoneCellSingleResult {
    queryable?: DemandZoneCell[] | null;
  }

  export interface DemandZoneCellUpdateDto {
    /** @format int32 */
    questionOptionId: number;
    /** @format int32 */
    projectGroupSegmentId: number;
  }

  export interface DemandZoneRegenerateDto {
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format float */
    cellSimilarityMaxThreshold?: number | null;
  }

  export interface DemandZoneSingleResult {
    queryable?: DemandZone[] | null;
  }

  export interface DemandZoneTestOptionResult {
    /** @format int32 */
    demandZoneId: number;
    demandZoneName: string;
    /** @format int32 */
    testOptionId: number;
    testOptionName: string;
    /** @format int32 */
    standardQuestionId: number;
    /** @format double */
    metricSharePercentage: number;
    /** @format double */
    categorySharePercentage: number;
    /** @format int32 */
    count: number;
    /** @format double */
    index: number;
  }

  export interface DemandZoneTopNeedsBrands {
    /** @format int32 */
    demandZoneId: number | null;
    /** @format int32 */
    uAndATypeId: number;
    sortedTopOptions: string[];
    top: string;
  }

  export interface DemandZoneUpdateDto {
    zoneName: string;
    zoneDescription?: string | null;
  }

  export interface DemandZonesSyncCellsDto {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    projectGroupSegmentId: number;
    /** @format int32 */
    questionOptionId: number;
  }

  export interface DemandZonesSyncDto {
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    regionId: number;
    zones: DemandZonesSyncZoneDto[];
  }

  export interface DemandZonesSyncZoneDto {
    /** @format int32 */
    id?: number | null;
    name: string;
    description?: string | null;
    cells: DemandZonesSyncCellsDto[];
  }

  export interface DemoProjectDto {
    projectName?: string | null;
  }

  export interface DemographicResponsesFilters {
    regionIds: number[];
    surveyIds?: number[] | null;
    questionOptionsIds?: number[] | null;
    filterIds?: number[] | null;
    testOptionIds?: number[] | null;
    standardQuestionIds?: number[] | null;
    excludeQuestionOptionsIds?: number[] | null;
    panelType?: PanelType;
    projectGroupSegmentIds?: number[] | null;
    /** @format date-time */
    dateFrom?: string | null;
    /** @format date-time */
    dateTo?: string | null;
    questionIds?: number[] | null;
    forceSystemQuestionIds?: number[] | null;
  }

  export interface DemographicsResult {
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    questionId: number;
    /** @format int32 */
    systemQuestionId: number;
    questionLabel: string;
    /** @format int32 */
    systemQuestionOptionId: number;
    answerLabel: string;
    /** @format double */
    weight: number;
    /** @format int32 */
    responsesCount: number;
    /** @format double */
    totalWeight: number;
  }

  export interface DiagnoseScoreThemeResponseCountsView {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    themeId?: number | null;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format double */
    value?: number | null;
    /** @format double */
    pValue?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    projectQuestionId?: number | null;
    /** @format int32 */
    customMetricQuestionId?: number | null;
    themeLabel?: string | null;
    themeShortLabel?: string | null;
    /** @format int32 */
    projectGroupSegmentId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int64 */
    responseCount?: number | null;
  }

  export interface DiagnoseScoreThemeResponseCountsViewSingleResult {
    queryable?: DiagnoseScoreThemeResponseCountsView[] | null;
  }

  export interface DisplaySchedule {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    dayOfTheWeek: number;
    /** @format time */
    time?: string | null;
    region: Region;
  }

  export interface DisplayScheduleException {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format date-time */
    dateStart: string;
    /** @format date-time */
    dateEnd: string;
    comment?: string | null;
    region: Region;
  }

  export interface DisplayScheduleExceptionSingleResult {
    queryable?: DisplayScheduleException[] | null;
  }

  export interface DisplayScheduleSingleResult {
    queryable?: DisplaySchedule[] | null;
  }

  export interface Document {
    /** @format int32 */
    id: number;
    name: string;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    deletedByNavigation?: User;
    documentVersions: DocumentVersion[];
  }

  export interface DocumentPlatform {
    /** @format int32 */
    id: number;
    name: string;
    clients: Client[];
  }

  export interface DocumentSingleResult {
    queryable?: Document[] | null;
  }

  export interface DocumentVersion {
    /** @format int32 */
    id: number;
    /** @format int32 */
    documentId: number;
    content: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    description?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    deletedByNavigation?: User;
    document: Document;
  }

  export interface DocumentVersionDelta {
    kind: DeltaItemKind;
    structuredType?: Type;
    expectedClrType?: Type;
    updatableProperties?: string[] | null;
    isComplexType: boolean;
  }

  export interface DocumentVersionSingleResult {
    queryable?: DocumentVersion[] | null;
  }

  export interface DriverResultFactMetadata {
    typename: "DriverResultFactMetadata";
    /**
     * The theme ID that is a driver
     * @format int32
     */
    themeId: number;
    /**
     * The text question ID this theme is derived from
     * @format int32
     */
    projectQuestionId: number;
    /**
     * The standard question ID this theme drives (null if driven by a custom metric)
     * @format int32
     */
    standardQuestionId?: number | null;
    /**
     * The custom metric question ID this theme drives (null if driven by a standard question)
     * @format int32
     */
    customMetricQuestionId?: number | null;
    /**
     * Regression coefficient for how much this theme drives the metric. Positive = theme positively drives the metric, negative = negatively drives. No fixed bounds; larger magnitude = stronger effect.
     * @format double
     */
    value: number;
    /**
     * Statistical p-value from regression (range 0-0.4, as values above 0.4 are eliminated during backward elimination). Lower = higher confidence the theme truly drives the metric. Below 0.05 = highly significant.
     * @format double
     */
    pValue: number;
    /**
     * Theme sentiment: -1 = negative, 0 = neutral, 1 = positive
     * @format int32
     */
    sentimentScore?: number | null;
  }

  export interface DriversSummaryOutput {
    output1?: string | null;
    output2?: string | null;
    output3?: string | null;
  }

  export interface DuplicateDto {
    projectName?: string | null;
    /** @format int32 */
    frameworkId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
  }

  export interface DuplicateProjectGroupDto {
    /** @format int32 */
    targetClientId: number;
    nameSuffix?: string | null;
  }

  export interface ETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface EditProjectCommentDto {
    content?: string | null;
    commentType?: ProjectCommentTypeLookup;
  }

  export interface EmailSummaryOutput {
    bodyText?: string | null;
  }

  export interface EmptyMetadata {
    typename: "EmptyMetadata";
  }

  export interface EmptyProjectFindingMetadata {
    typename: "EmptyProjectFindingMetadata";
  }

  export interface Enterprise {
    /** @format int32 */
    id: number;
    client?: Client;
    orgs: Org[];
  }

  export interface EnterpriseSingleResult {
    queryable?: Enterprise[] | null;
  }

  export interface EstimatedProjectDurationView {
    /** @format int32 */
    projectId?: number | null;
    /** @format int64 */
    estimatedDuration?: number | null;
    project?: Project;
  }

  export interface EstimatedProjectDurationViewSingleResult {
    queryable?: EstimatedProjectDurationView[] | null;
  }

  export type EventAttributes = "None" | "SpecialName" | "RTSpecialName";

  export interface EventInfo {
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    isMulticast: boolean;
    eventHandlerType?: Type;
  }

  export interface ExceptionMetadata {
    typename: "ExceptionMetadata";
    exceptionStackTrace: string;
  }

  export interface ExecutorSchemaFieldDto {
    path: string;
    type: string;
    description?: string | null;
  }

  export interface ExportPlanDocumentDto {
    convertToPdf: boolean;
    include: ExportPlanDocumentIncludeOptions;
  }

  export interface ExportPlanDocumentIncludeOptions {
    planFramework: boolean;
    planBackground: boolean;
    planResearchObjectives: boolean;
    planMarketsAndAudience: boolean;
    setupAudiences: boolean;
    setupConfiguration: boolean;
    setupPriceSensitivity: boolean;
    setupMarketReach: boolean;
    setupScheduling: boolean;
    demographicQuestions: boolean;
    frameworkQuestions: boolean;
    conceptsAndQuestions: boolean;
    costBreakdown: boolean;
    questionAnswerChoices: boolean;
  }

  export interface ExportPowerPointDto {
    filters: ResponsesFilters;
    /** @format int32 */
    benchmarkTypeId: number;
    /** @format int32 */
    segmentId?: number | null;
  }

  export interface ExportTableToExcelRequest {
    tableData: string[][];
    fileName?: string | null;
  }

  export interface ExtendedTeamsView {
    /** @format int32 */
    teamId?: number | null;
    teamName?: string | null;
    /** @format int32 */
    orgId?: number | null;
    orgName?: string | null;
    /** @format int32 */
    enterpriseId?: number | null;
    enterpriseName?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
  }

  export interface ExtendedTeamsViewSingleResult {
    queryable?: ExtendedTeamsView[] | null;
  }

  export type ExtrapolatedRoleEnum = "EnterpriseAdmin" | "User" | "Viewer" | "OrgAdmin" | "TeamAdmin";

  export interface ExtrapolatedUserAndClient {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    userId: number;
    /** @format int32 */
    roleId: number;
    role: ExtrapolatedRoleEnum;
  }

  export interface ExtrapolatedUserAndClientSingleResult {
    queryable?: ExtrapolatedUserAndClient[] | null;
  }

  export type FF =
    | "RandomisedQuestions"
    | "AsahiCustomNpdQuestion"
    | "CustomLoginUI"
    | "AddQuestionsAtRuntime"
    | "SynthQuestions"
    | "RecommendedQuestions"
    | "SegmentSummaries"
    | "AiGoals"
    | "CanChooseUsStateMarkets"
    | "CategoriesBenchmarks"
    | "TranslationsEmail"
    | "ProjectGroups"
    | "Scheduling"
    | "FullTestSummary"
    | "Ama"
    | "TextResponsesQaPrompt"
    | "MarketReach"
    | "ThemedSentiment"
    | "DocumentToProject"
    | "CustomMetrics"
    | "IncidenceEstimation"
    | "AgeSlider"
    | "CompareConcepts"
    | "ProjectGroupShare"
    | "AgenticThemingWorkflow"
    | "DemandLandscape"
    | "ResultsDownloadPage"
    | "SyntheticDemo"
    | "Reskin"
    | "ResearchBuilder"
    | "AiProviderOverride"
    | "AutoGenerateFilterSets"
    | "ProjectNarratives"
    | "Crosstabs"
    | "UsRegionPricingMultiplier"
    | "EnableThumbnailCron"
    | "MaxioSubscriptionsCron"
    | "LegacyPurchaseIntent"
    | "NewHubspotAirbyteTables"
    | "SurveyPlatformProviders"
    | "DemandZoneConceptMapping"
    | "SyntheticShadowProject";

  export interface FeatureFlag {
    /** @format int32 */
    id: number;
    name: string;
    isEnabled: boolean;
    isDeprecated: boolean;
    description?: string | null;
    clientFeatures: ClientFeature[];
    ff: FF;
  }

  export interface FeatureFlagSingleResult {
    queryable?: FeatureFlag[] | null;
  }

  export interface Feedback {
    /** @format int32 */
    id: number;
    name: string;
    aiMessages: AiMessage[];
  }

  export type FeedbackLookup = "Good" | "Bad";

  export interface FetchDecipherRespondentsDto {
    refetch: boolean;
  }

  export type FieldAttributes =
    | "PrivateScope"
    | "Private"
    | "FamANDAssem"
    | "Assembly"
    | "Family"
    | "FamORAssem"
    | "Public"
    | "FieldAccessMask"
    | "Static"
    | "InitOnly"
    | "Literal"
    | "NotSerialized"
    | "HasFieldRVA"
    | "SpecialName"
    | "RTSpecialName"
    | "HasFieldMarshal"
    | "PinvokeImpl"
    | "HasDefault"
    | "ReservedMask";

  export interface FieldInfo {
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    isInitOnly: boolean;
    isLiteral: boolean;
    /** @deprecated */
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
  }

  export interface FilterClause {
    expression?: SingleValueNode;
    rangeVariable?: RangeVariable;
    itemType?: any;
  }

  export interface FilterQueryOption {
    context?: any;
    validator?: IFilterQueryValidator;
    compute?: ComputeQueryOption;
    filterClause?: FilterClause;
    rawValue?: string | null;
  }

  export type FilterQuestionType =
    | "QUAL"
    | "HH_SHOP"
    | "SUP_PURCH"
    | "total"
    | "dAgexGender"
    | "AGE_GPS"
    | "CAT_PURCH"
    | "TECH_ADOP"
    | "dRegion"
    | "REGN_NZ"
    | "GENDER"
    | "ETHN_LN"
    | "HH_INC"
    | "HH_STR_SH"
    | "dAgeRecode"
    | "CAN_DRINK_ALCOHOL";

  export type FindingActionability = "High" | "Medium" | "Low" | "Speculative";

  export type FindingSentiment = "Positive" | "Negative" | "Mixed";

  export type FollowUpSectionType =
    | "ProjectName"
    | "Background"
    | "ResearchObjectives"
    | "MarketsAndAudience"
    | "Framework"
    | "Setup"
    | "Markets"
    | "Addons"
    | "Concepts"
    | "Questionnaire";

  export interface ForceCloseSurveyDto {
    processResults: boolean;
  }

  export interface ForgotPasswordDto {
    email: string;
  }

  export interface ForwardLookingOpportunitiesMetadata {
    typename: "ForwardLookingOpportunitiesMetadata";
    actionability: FindingActionability;
  }

  export interface Framework {
    /** @format int32 */
    id: number;
    title: string;
    descriptionShort: string;
    description: string;
    /** @format int32 */
    projectTypeId: number;
    examples?: string | null;
    objectiveSummaries: string[];
    imagePaths?: string[] | null;
    imagePath?: string | null;
    conceptIntroText?: string | null;
    projectType: ProjectType;
    projects: Project[];
    standardQuestions: StandardQuestion[];
    projectTypeLookup: ProjectTypeLookup;
  }

  export interface FrameworkSingleResult {
    queryable?: Framework[] | null;
  }

  export interface FrameworkSuggestionResponse {
    /**
     * The suggested framework ID
     * @format int32
     */
    frameworkId: number;
    /**
     * Markdown-formatted reasoning for the framework suggestion. You can use <br> for line breaks.
     * AP style — no shorthand or abbreviations. Structured formatting with short paragraphs or bullet points.
     * Max 500 characters.
     */
    reasoning?: string | null;
  }

  export interface FunctionCall {
    name: string;
    extraArgument: string;
  }

  export interface FunctionCallContent {
    mimeType?: string | null;
    modelId?: string | null;
    metadata?: Record<string, any>;
    typename: "FunctionCallContent";
    id?: string | null;
    pluginName?: string | null;
    functionName?: string | null;
    arguments?: AiArgument[] | null;
  }

  export interface FunctionParameter {
    name: string;
    description: string;
    required: boolean;
  }

  export interface FunctionResultContent {
    mimeType?: string | null;
    modelId?: string | null;
    metadata?: Record<string, any>;
    typename: "FunctionResultContent";
    result?: string | null;
    callId?: string | null;
  }

  export interface GenerateFilterSetsDto {
    /** @format int32 */
    regionId: number;
  }

  export interface GenerateSlideDeckRequestDto {
    userInstructions?: string | null;
    numberOfSlides?: string | null;
  }

  export interface GenerateTrialClientJobPayload {
    email: string;
    firstName: string;
    lastName: string;
    companyName: string;
    companyIndustry: string;
    /** @format uuid */
    inviteIdentifier: string;
  }

  export type GenericParameterAttributes =
    | "None"
    | "Covariant"
    | "Contravariant"
    | "VarianceMask"
    | "ReferenceTypeConstraint"
    | "NotNullableValueTypeConstraint"
    | "DefaultConstructorConstraint"
    | "SpecialConstraintMask"
    | "AllowByRefLike";

  export interface GroupQuestionTextsView {
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int32 */
    projectGroupsQuestionId?: number | null;
    questionText?: string | null;
    projectGroupQuestion: ProjectGroupsQuestion;
  }

  export interface GroupResponsesFilters {
    regionIds: number[];
    surveyIds?: number[] | null;
    questionOptionsIds?: number[] | null;
    filterIds?: number[] | null;
    testOptionIds?: number[] | null;
    standardQuestionIds?: number[] | null;
    excludeQuestionOptionsIds?: number[] | null;
    panelType?: PanelType;
    projectGroupSegmentIds?: number[] | null;
    /** @format date-time */
    dateFrom?: string | null;
    /** @format date-time */
    dateTo?: string | null;
    /** @format int32 */
    questionId?: number | null;
    questionPositionIds?: number[] | null;
    routedFromQuestionOptionIds?: number[] | null;
    /** @format int32 */
    demandZoneId?: number | null;
    uAndATypeIds?: number[] | null;
  }

  export interface GroupSegmentFilter {
    uandAQuestionOptionsIds?: number[] | null;
    excludeUandAQuestionOptionsIds?: number[] | null;
    questionOptionsIds?: number[] | null;
    filterIds?: number[] | null;
    testOptionIds?: number[] | null;
    standardQuestionIds?: number[] | null;
    excludeQuestionOptionsIds?: number[] | null;
    panelType?: PanelType;
    projectGroupSegmentIds?: number[] | null;
    /** @format date-time */
    dateFrom?: string | null;
    /** @format date-time */
    dateTo?: string | null;
  }

  export interface HostString {
    value?: string | null;
    hasValue: boolean;
    host: string;
    /** @format int32 */
    port?: number | null;
  }

  export interface HttpContext {
    features: TypeObjectKeyValuePair[];
    request: HttpRequest;
    response: HttpResponse;
    connection: ConnectionInfo;
    webSockets: WebSocketManager;
    user: ClaimsPrincipal;
    items: Record<string, any>;
    requestServices: IServiceProvider;
    requestAborted: CancellationToken;
    traceIdentifier: string;
    session: ISession;
  }

  export interface HttpRequest {
    httpContext: HttpContext;
    method: string;
    scheme: string;
    isHttps: boolean;
    host: HostString;
    pathBase: PathString;
    path: PathString;
    queryString: QueryString;
    query: StringStringValuesKeyValuePair[];
    protocol: string;
    headers: Record<string, string[]>;
    cookies: StringStringKeyValuePair[];
    /** @format int64 */
    contentLength?: number | null;
    contentType?: string | null;
    /** @format binary */
    body: File;
    /** @format binary */
    bodyReader: File;
    hasFormContentType: boolean;
    form: StringStringValuesKeyValuePair[];
    routeValues: Record<string, any>;
  }

  export interface HttpResponse {
    httpContext: HttpContext;
    /** @format int32 */
    statusCode: number;
    headers: Record<string, string[]>;
    /** @format binary */
    body: File;
    bodyWriter: PipeWriter;
    /** @format int64 */
    contentLength?: number | null;
    contentType?: string | null;
    cookies: IResponseCookies;
    hasStarted: boolean;
  }

  export interface HubspotCompany {
    hubspotId: string;
    /** @format int32 */
    id: number;
    name?: string | null;
    domain?: string | null;
    industry?: string | null;
    demo: boolean;
    /** @format date */
    onboardingCompletionDate?: string | null;
    /** @format int32 */
    csm?: number | null;
    /** @format int32 */
    leadResearcher?: number | null;
    /** @format int32 */
    companyOwner?: number | null;
    businessModel?: string | null;
    customerType?: string | null;
    estMarketingBudgetRange?: string | null;
    /** @format int32 */
    numberOfEmployees?: number | null;
    revenueRange?: string | null;
    vitallyCustomerTier?: string | null;
    vitallyChurnRisk?: boolean | null;
    currencyCode?: string | null;
    type?: string | null;
    overdueInvoice?: boolean | null;
    /** @format date-time */
    contractStartDate?: string | null;
    /** @format date-time */
    contractRenewalDate?: string | null;
    /** @format int32 */
    contractTermMonths?: number | null;
    companyOwnerNavigation?: User;
    csmNavigation?: User;
    leadResearcherNavigation?: User;
    hubspotContacts: HubspotContact[];
  }

  export interface HubspotContact {
    hubspotId: string;
    /** @format int32 */
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    hubspotCompanies: HubspotCompany[];
  }

  export interface HubspotCredit {
    /** @format int32 */
    id: number;
    /** @format int32 */
    creditLogId?: number | null;
    hsLineItemId: string;
    /** @format date-time */
    dealDate: string;
    hsCompanyId: string;
    /** @format int32 */
    creditAmount: number;
    sku: string;
    /** @format date-time */
    createdAt: string;
    currencyCode?: string | null;
    /** @format double */
    creditPrice?: number | null;
    hsDealId?: string | null;
    /** @format date-time */
    dealContractDate?: string | null;
    creditLog?: CreditLog;
  }

  export interface HubspotRole {
    /** @format int32 */
    id: number;
    roleName: string;
    roleLabel: string;
    users: User[];
  }

  export interface HubspotRoleSingleResult {
    queryable?: HubspotRole[] | null;
  }

  export type IComputeQueryValidator = object;

  export type ICountQueryValidator = object;

  export type ICustomAttributeProvider = object;

  export type IFilterQueryValidator = object;

  export interface IIdentity {
    name?: string | null;
    authenticationType?: string | null;
    isAuthenticated: boolean;
  }

  export type IOrderByQueryValidator = object;

  export interface IPAddress {
    addressFamily: AddressFamily;
    /** @format int64 */
    scopeId: number;
    isIPv6Multicast: boolean;
    isIPv6LinkLocal: boolean;
    isIPv6SiteLocal: boolean;
    isIPv6Teredo: boolean;
    isIPv6UniqueLocal: boolean;
    isIPv4MappedToIPv6: boolean;
    /**
     * @deprecated
     * @format int64
     */
    address: number;
  }

  export type IPromptContent = BaseIPromptContent &
    (
      | BaseIPromptContentTypenameMapping<"PlaybookDto", PlaybookDto>
      | BaseIPromptContentTypenameMapping<"WorkflowDto", WorkflowDto>
      | BaseIPromptContentTypenameMapping<"SyntheticSurveyWorkflowDto", SyntheticSurveyWorkflowDto>
    );

  export type IResponseCookies = object;

  export type ISelectExpandQueryValidator = object;

  export type IServiceProvider = object;

  export interface ISession {
    isAvailable: boolean;
    id: string;
    keys: string[];
  }

  export type ISkipQueryValidator = object;

  export type ISkipTokenQueryValidator = object;

  export type ITopQueryValidator = object;

  export interface ImportPromptVersionFromJsonDto {
    /** @format int32 */
    promptId: number;
    jsonString: string;
    description: string;
  }

  export interface ImportPromptVersionFromYmlDto {
    /** @format int32 */
    promptId: number;
    ymlString: string;
  }

  export interface IncidenceEstimate {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    questionId: number;
    /** @format double */
    incidenceRate: number;
    incidenceRateHash: string;
    /** @format date-time */
    createdAt: string;
    question: Question;
    region: Region;
  }

  export interface IncidenceRate {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    systemQuestionOptionId: number;
    /** @format double */
    ir: number;
    region: Region;
    systemQuestionOption: SystemQuestionOption;
  }

  export interface Int32NullableResolvedFieldDto {
    /** @format int32 */
    value?: number | null;
    sourceTier?: ClientSettingTier;
    sourceClientName?: string | null;
  }

  export type IntPtr = object;

  export type Item = BaseItem &
    (
      | BaseItemTypenameMapping<"TextContent", TextContent>
      | BaseItemTypenameMapping<"FunctionCallContent", FunctionCallContent>
      | BaseItemTypenameMapping<"FunctionResultContent", FunctionResultContent>
      | BaseItemTypenameMapping<"ChatMessageContent", ChatMessageContent>
      | BaseItemTypenameMapping<"AnnotationContent", AnnotationContent>
    );

  export interface KeySizes {
    /** @format int32 */
    minSize: number;
    /** @format int32 */
    maxSize: number;
    /** @format int32 */
    skipSize: number;
  }

  export type LayoutKind = "Sequential" | "Explicit" | "Auto";

  export interface LinkExpiredDto {
    typename: "LinkExpiredDto";
  }

  export interface LinkInvalidDto {
    typename: "LinkInvalidDto";
  }

  export interface LinkInvite {
    /** @format int32 */
    id: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    expiresAt?: string | null;
    /** @format int32 */
    demoProjectId?: number | null;
    /** @format uuid */
    identifier: string;
    createdByNavigation: User;
    demoProject?: Project;
  }

  export interface LinkInviteDto {
    /** @format date-time */
    expiresAt?: string | null;
    /** @format uuid */
    identifier: string;
    demoProjectName?: string | null;
  }

  export interface LinkInviteDtoSingleResult {
    queryable?: LinkInviteDto[] | null;
  }

  export interface LinkInviteSingleResult {
    queryable?: LinkInvite[] | null;
  }

  export interface LoginMethodDto {
    name: LoginMethods;
    redirect?: string | null;
  }

  export type LoginMethods = "Password" | "Google" | "SAML";

  export interface MakeCreditTransferDto {
    /** @format int32 */
    senderId: number;
    /** @format int32 */
    receiverId: number;
    /** @format double */
    creditAmount: number;
    description?: string | null;
  }

  export interface ManualSurveyScheduleDto {
    /** @format int32 */
    projectScheduleId?: number | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    regionId?: number | null;
    creditAdjustment?: ScheduleAdjustmentDto;
    /** @format date-time */
    scheduleDate?: string | null;
  }

  export interface MarkActionTakenAiMessageDto {
    actionTaken: boolean;
    actionOutcome?: string | null;
  }

  export interface MarketReach {
    /** @format int32 */
    id: number;
    /** @format int32 */
    maxOptionsSelect?: number | null;
    marketReachesTestOptions: MarketReachesTestOption[];
    projects: Project[];
  }

  export interface MarketReachResult {
    /** @format int32 */
    id: number;
    /** @format double */
    reach: number;
    /** @format int32 */
    unduplicatedCount: number;
    /** @format double */
    frequency: number;
    /** @format int32 */
    total: number;
    questionOptionIds: number[];
  }

  export interface MarketReachResultFactMetadata {
    typename: "MarketReachResultFactMetadata";
    /** The combination of question option IDs (product/variant IDs) in this TURF result */
    questionOptionIds: number[];
    /**
     * Optional project question ID for adhoc market reach questions (null = standard market reach question)
     * @format int32
     */
    projectQuestionId?: number | null;
    /**
     * Percentage of respondents reached by this combination of options (unduplicated reach %)
     * @format double
     */
    reachPercentage: number;
    /**
     * Number of unique respondents reached by this combination
     * @format int32
     */
    unduplicatedCount: number;
    /**
     * Average number of options selected per reached respondent (frequency of engagement)
     * @format double
     */
    frequency: number;
    /**
     * Number of options (k) in this combination
     * @format int32
     */
    combinationSize: number;
    /**
     * Rank of this combination within its combination size group (1 = highest reach for this k)
     * @format int32
     */
    rank: number;
  }

  export interface MarketReachesTestOption {
    /** @format int32 */
    marketReachId: number;
    /** @format int32 */
    testOptionId: number;
    /** @format int32 */
    questionOptionId?: number | null;
    marketReach: MarketReach;
    questionOption?: QuestionOption;
    testOption: TestOption;
  }

  export interface MaxioSubscription {
    /** @format int32 */
    id: number;
    /** @format int32 */
    clientId?: number | null;
    /** @format date-time */
    currentTermEnd?: string | null;
    /** @format date-time */
    currentTermStart?: string | null;
    customerId?: string | null;
    /** @format int32 */
    creditAmount?: number | null;
    subscriptionId: string;
    subscriptionSource: string;
    active?: boolean | null;
    client?: Client;
  }

  export interface MemberInfo {
    memberType: MemberTypes;
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
  }

  export type MemberTypes =
    | "Constructor"
    | "Event"
    | "Field"
    | "Method"
    | "Property"
    | "TypeInfo"
    | "Custom"
    | "NestedType"
    | "All";

  export interface Message {
    content: string;
    role: string;
  }

  export interface MessageRecallAndTakeawayMetadata {
    typename: "MessageRecallAndTakeawayMetadata";
    sentiment: FindingSentiment;
  }

  export type MethodAttributes =
    | "PrivateScope"
    | "Private"
    | "FamANDAssem"
    | "Assembly"
    | "Family"
    | "FamORAssem"
    | "Public"
    | "MemberAccessMask"
    | "UnmanagedExport"
    | "Static"
    | "Final"
    | "Virtual"
    | "HideBySig"
    | "NewSlot"
    | "CheckAccessOnOverride"
    | "Abstract"
    | "SpecialName"
    | "RTSpecialName"
    | "PinvokeImpl"
    | "HasSecurity"
    | "RequireSecObject"
    | "ReservedMask";

  export interface MethodBase {
    memberType: MemberTypes;
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
  }

  export type MethodImplAttributes =
    | "IL"
    | "Native"
    | "OPTIL"
    | "CodeTypeMask"
    | "ManagedMask"
    | "NoInlining"
    | "ForwardRef"
    | "Synchronized"
    | "NoOptimization"
    | "PreserveSig"
    | "AggressiveInlining"
    | "AggressiveOptimization"
    | "InternalCall"
    | "Async"
    | "MaxMethodImplVal";

  export interface MethodInfo {
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;
  }

  export interface MetricResultFactMetadata {
    typename: "MetricResultFactMetadata";
    /**
     * The standard question ID this metric is derived from
     * @format int32
     */
    standardQuestionId: number;
    /**
     * The percentage score for this metric (e.g., Top-2 box score)
     * @format double
     */
    percentage: number;
    /** Comparisons against available industry/team benchmarks (Ideally Average, Team Average, etc.) */
    benchmarkComparisons?: BenchmarkComparison[] | null;
    vsTotal?: VsTotalComparison;
  }

  export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    /** @format int32 */
    mdStreamVersion: number;
    /** @format uuid */
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    /** @format int32 */
    metadataToken: number;
  }

  export interface ModuleHandle {
    /** @format int32 */
    mdStreamVersion: number;
  }

  export interface MoveProjectDto {
    /** @format int32 */
    teamId: number;
    removeCurrentTeamAccess: boolean;
    moveCreditLogs: boolean;
  }

  export interface NamingOrFormatPreferenceMetadata {
    typename: "NamingOrFormatPreferenceMetadata";
    /**
     * ID of the preferred variant, if a clear winner. Use a real testOptionId from the supporting facts — never invent IDs. Null if no clear preference
     * @format int32
     */
    preferredOptionId?: number | null;
    variantType: NamingVariantType;
  }

  export type NamingVariantType = "Name" | "Copy" | "Format";

  export interface NewPasswordRequiredDto {
    session: string;
    newPassword: string;
    email: string;
  }

  export interface NewScheduleDto {
    regions: NewScheduleRegionDto[];
    /** @format date-time */
    scheduleDate?: string | null;
    /** @format int32 */
    creditLogTypeId?: number | null;
    creditLogDescription?: string | null;
    creditLogNotes?: string | null;
  }

  export interface NewScheduleRegionDto {
    /** @format int32 */
    regionId: number;
    /** @format double */
    creditAmount: number;
  }

  export interface Notification {
    /** @format int32 */
    id: number;
    /** @format int32 */
    userId: number;
    /** @format int32 */
    notificationTypeId: number;
    message: string;
    actionData?: string | null;
    /** @format date-time */
    readAt?: string | null;
    /** @format date-time */
    createdAt: string;
    title: string;
    footer: string;
    notificationType: NotificationType;
    user: User;
    actionDataParsed?: any;
    notificationTypeLookup: NotificationTypes;
  }

  export interface NotificationDelta {
    kind: DeltaItemKind;
    structuredType?: Type;
    expectedClrType?: Type;
    updatableProperties?: string[] | null;
    isComplexType: boolean;
  }

  export interface NotificationSingleResult {
    queryable?: Notification[] | null;
  }

  export interface NotificationType {
    /** @format int32 */
    id: number;
    name: string;
    notifications: Notification[];
  }

  export interface NotificationTypeSingleResult {
    queryable?: NotificationType[] | null;
  }

  export type NotificationTypes =
    | "SurveySubmittedForApproval"
    | "SurveyApproved"
    | "SurveyApprovalDeclined"
    | "ProjectSentOutForSurvey"
    | "ProjectReady"
    | "PasswordReset"
    | "UserAddedToTeam"
    | "CustomPanelProjectReadyForSurvey"
    | "NewTest"
    | "AddedToProject"
    | "ProjectScheduleNoCreditReminder"
    | "ScheduledProjectCharged"
    | "ScheduledProjectPaused"
    | "ScheduledProjectLapsed";

  export interface Oid {
    value?: string | null;
    friendlyName?: string | null;
  }

  export interface OrderByClause {
    thenBy?: OrderByClause;
    expression?: SingleValueNode;
    direction: OrderByDirection;
    rangeVariable?: RangeVariable;
    itemType?: any;
  }

  export type OrderByDirection = "Ascending" | "Descending";

  export interface OrderByNode {
    direction: OrderByDirection;
  }

  export interface OrderByQueryOption {
    context?: any;
    orderByNodes?: OrderByNode[] | null;
    rawValue?: string | null;
    validator?: IOrderByQueryValidator;
    compute?: ComputeQueryOption;
    orderByClause?: OrderByClause;
  }

  export interface Org {
    /** @format int32 */
    id: number;
    /** @format int32 */
    enterpriseId?: number | null;
    isOverdueAccount: boolean;
    client?: Client;
    enterprise?: Enterprise;
    teams: Team[];
  }

  export interface OrgSingleResult {
    queryable?: Org[] | null;
  }

  export interface OutputDto {
    name: string;
    instructions: string[];
    objectives: string[];
    format?: string | null;
    saveKey?: string | null;
    saveFunction?: string | null;
  }

  export type PanelType = "Ideally" | "Customer" | "Simulated" | "Synthetic";

  export type ParameterAttributes =
    | "None"
    | "In"
    | "Out"
    | "Lcid"
    | "Retval"
    | "Optional"
    | "HasDefault"
    | "HasFieldMarshal"
    | "Reserved3"
    | "Reserved4"
    | "ReservedMask";

  export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name?: string | null;
    parameterType: Type;
    /** @format int32 */
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue?: any;
    rawDefaultValue?: any;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    /** @format int32 */
    metadataToken: number;
  }

  export interface ParseInviteFileDto {
    /** @minLength 1 */
    fileKey: string;
    /** @minLength 1 */
    fileName: string;
    /** @minLength 1 */
    contentType: string;
  }

  export interface PasswordLoginDto {
    email: string;
    password: string;
    rememberMe?: boolean | null;
  }

  export interface PatchProjectGroupSegmentDto {
    /** @format int32 */
    id?: number | null;
    name?: string | null;
    description?: string | null;
    filters?: GroupSegmentFilter[] | null;
  }

  export interface PatchProjectNarrativeDto {
    title?: string | null;
  }

  export interface PatchProjectNarrativeSectionDto {
    title?: string | null;
    content?: string | null;
  }

  export interface PatchSegmentDto {
    name?: string | null;
    filters?: SegmentResponsesFilters;
  }

  export interface PathString {
    value?: string | null;
    hasValue: boolean;
  }

  export interface PendingWorkflowEvaluationInfo {
    /** @format int32 */
    promptId: number;
    promptName: string;
    /** @format int32 */
    promptVersionId: number;
    promptVersionDescription: string | null;
    isActiveVersion: boolean;
    /** @format int32 */
    pendingCount: number;
  }

  export type Permission = "projectApproval";

  export interface PipeWriter {
    canGetUnflushedBytes: boolean;
    /** @format int64 */
    unflushedBytes: number;
  }

  export type PlanSection = "ProjectName" | "Background" | "ResearchObjectives" | "MarketsAndAudience";

  export interface PlaybookDto {
    inputs: string[];
    agentService: AiServiceLookup;
    /** @format float */
    temperature?: number | null;
    /** @format int64 */
    seed?: number | null;
    reasoningEffort?: ReasoningEffort;
    /** @format int32 */
    aiModelDefinitionId: number;
    plugins: string[];
    mcps?: string[] | null;
    persona?: string | null;
    instructions?: string[] | null;
    objectives?: string[] | null;
    /** @deprecated */
    data?: string[] | null;
    functions?: FunctionCall[] | null;
    outputPlugin?: string | null;
    outputs: OutputDto[];
    format?: string | null;
    typename: "PlaybookDto";
  }

  export interface PlaybookPluginOptionsDto {
    functionPlugins: Plugin[];
    outputPlugins: string[];
    mcps: Plugin[];
    aiModelDefinitions: AiModelDefinitionDto[];
  }

  export interface Plugin {
    name: string;
    functions: PluginFunction[];
  }

  export interface PluginFunction {
    name: string;
    description: string;
    parameters: FunctionParameter[];
    returns: string | null;
  }

  export type Policy =
    | "SuperAdmin"
    | "IdeallyResearch"
    | "IdeallySales"
    | "IdeallyAdmin"
    | "IdeallyAdminViewer"
    | "SharedViewerEnterpriseAdmin"
    | "SharedViewerOrgAdmin"
    | "SharedViewerTeamAdmin"
    | "SharedViewerUser"
    | "SharedViewerViewer"
    | "EnterpriseAdmin"
    | "OrgAdmin"
    | "TeamAdmin"
    | "TeamUser"
    | "TeamViewer";

  export type PricePointType = "Optimum" | "Floor" | "Ceiling" | "Indifference";

  export interface PriceSensitivityDataPoint {
    /** @format int32 */
    answerValue: number;
    /** @format double */
    price: number;
    /** @format int32 */
    percentage: number;
    /** @format int32 */
    total: number;
  }

  export interface PriceSensitivityResult {
    /** @format double */
    minAcceptablePrice: number;
    /** @format double */
    maxAcceptablePrice: number;
    /** @format double */
    indifferencePrice: number;
    /** @format double */
    optimumPrice: number;
    /** @format int32 */
    totalResponseCount: number;
    /** @format int32 */
    totalSessions: number;
    seriesData: PriceSensitivitySeriesData;
  }

  export interface PriceSensitivitySeriesData {
    tooCheapSeries: PriceSensitivityDataPoint[];
    cheapSeries: PriceSensitivityDataPoint[];
    expensiveSeries: PriceSensitivityDataPoint[];
    tooExpensiveSeries: PriceSensitivityDataPoint[];
  }

  export interface PricingOptimumAndRangeMetadata {
    typename: "PricingOptimumAndRangeMetadata";
    pricePoint: PricePointType;
  }

  export interface PricingSegmentDifferencesMetadata {
    typename: "PricingSegmentDifferencesMetadata";
    pricePoint: PricePointType;
  }

  export interface PricingSenseResultFactMetadata {
    typename: "PricingSenseResultFactMetadata";
    /**
     * Price floor — the lowest price consumers find acceptable (intersection of 'too cheap' and 'expensive' curves)
     * @format double
     */
    minAcceptablePrice: number;
    /**
     * Price ceiling — the highest price consumers find acceptable (intersection of 'cheap' and 'too expensive' curves)
     * @format double
     */
    maxAcceptablePrice: number;
    /**
     * The price at which equal proportions find it cheap vs expensive — the expected market price (intersection of 'cheap' and 'expensive' curves)
     * @format double
     */
    indifferencePrice: number;
    /**
     * The optimal price point that minimises resistance — fewest find it too cheap or too expensive (intersection of 'too cheap' and 'too expensive' curves)
     * @format double
     */
    optimumPrice: number;
    /**
     * Width of the acceptable price range (maxAcceptablePrice - minAcceptablePrice)
     * @format double
     */
    acceptableRange: number;
  }

  export interface Product {
    /** @format int32 */
    id: number;
    /** @format int32 */
    productTypeId: number;
    /** @format int32 */
    categoryId: number;
    /** @format double */
    price?: number | null;
    sku?: string | null;
    /** @format int32 */
    regionId?: number | null;
    description: string;
    name: string;
    brandName: string;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    url?: string | null;
    /** @format int32 */
    imageS3FileId?: number | null;
    category: Category;
    createdByNavigation: User;
    imageS3File?: S3File;
    productType: ProductType;
    projectGroupProducts: ProjectGroupProduct[];
    region?: Region;
  }

  export interface ProductType {
    /** @format int32 */
    id: number;
    type: string;
    products: Product[];
    projects: Project[];
  }

  export type ProductTypeLookup = "Consumable" | "Durable" | "Pack" | "Media" | "Entertainment" | "Service";

  export interface Project {
    /** @format int32 */
    statusCode: number;
    projectName?: string | null;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    category?: string | null;
    productType?: string | null;
    isBranded?: boolean | null;
    brand?: string | null;
    /** @format int32 */
    id: number;
    /** @format int32 */
    verbatimStatus?: number | null;
    /** @format int32 */
    driverModelStatus?: number | null;
    /** @format int32 */
    summaryOverviewStatus?: number | null;
    /** @format int32 */
    summaryDiagnoseStatus?: number | null;
    /** @format int32 */
    topicingStatus?: number | null;
    regionDependentTopics?: boolean | null;
    conceptIntroText?: string | null;
    /** @format int32 */
    wavesRequired?: number | null;
    frequency?: string | null;
    /** @format int32 */
    sort?: number | null;
    /** @format int32 */
    sampleSize?: number | null;
    /** @format date-time */
    startDate?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    summaryOverviewAdhocStatus: number;
    randomiseQuestions: boolean;
    /** @format date-time */
    launchDate?: string | null;
    /** @format int32 */
    createdBy?: number | null;
    /** @format int32 */
    splitCellQuota?: number | null;
    /** @format date-time */
    submittedAt?: string | null;
    /** @format int32 */
    submittedBy?: number | null;
    reference?: string | null;
    /** @format int32 */
    teamId: number;
    hsProjectId?: string | null;
    /** @format int32 */
    frameworkId: number;
    projectType?: string | null;
    /** @format int32 */
    activeProjectObjectiveId?: number | null;
    /** @format date-time */
    startedGeneratingRecommendedQuestionsAt?: string | null;
    aiQaSuggestions?: string | null;
    /** @format int32 */
    categoryId?: number | null;
    /** @format date-time */
    hsSyncedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    researchNote?: string | null;
    /** @format int32 */
    brandTranslatedTextId?: number | null;
    /** @format int32 */
    categoryTranslatedTextId?: number | null;
    /** @format int32 */
    conceptIntroTranslatedTextId?: number | null;
    requiresResultsEmail: boolean;
    /** @format date-time */
    schedulePause?: string | null;
    /** @format int32 */
    scheduleFrequencyWeeks?: number | null;
    /** @format date-time */
    scheduleStartDate?: string | null;
    /** @format int32 */
    scheduleWavesRequired?: number | null;
    internalResearchNote?: string | null;
    /** @format int32 */
    marketReachId?: number | null;
    background?: string | null;
    marketsAndAudience?: string | null;
    researchObjectives?: string | null;
    /** @format int32 */
    projectGroupId?: number | null;
    aiQaSuggestionsJson?: string | null;
    /** @format int32 */
    pricingSensitivityVersion?: number | null;
    randomiseConceptOrder: boolean;
    activeProjectObjective?: ProjectObjective;
    aiConversations: AiConversation[];
    aiProjectSummaries: AiProjectSummary[];
    amaThreads: AmaThread[];
    brandTranslatedText?: TranslatedText;
    categoryNavigation?: Category;
    categoryTranslatedText?: TranslatedText;
    conceptIntroTranslatedText?: TranslatedText;
    createdByNavigation?: User;
    creditLogs: CreditLog[];
    deletedByNavigation?: User;
    framework: Framework;
    linkInvites: LinkInvite[];
    marketReach?: MarketReach;
    productTypeNavigation?: ProductType;
    projectComments: ProjectComment[];
    projectEmailSummaries: ProjectEmailSummary[];
    projectFacts: ProjectFact[];
    projectFiles: ProjectFile[];
    projectFindings: ProjectFinding[];
    projectGroup?: ProjectGroup;
    projectLogs: ProjectLog[];
    projectNarrativeSections: ProjectNarrativeSection[];
    projectNarrativeVersionExports: ProjectNarrativeVersionExport[];
    projectNarrativeVersions: ProjectNarrativeVersion[];
    projectNarratives: ProjectNarrative[];
    projectObjectives: ProjectObjective[];
    projectPriceSensitivities: ProjectPriceSensitivity[];
    projectQuestions: ProjectQuestion[];
    projectSchedules: ProjectSchedule[];
    projectShares: ProjectShare[];
    projectsAiBatchGroups: ProjectsAiBatchGroup[];
    recommendedQuestions: RecommendedQuestion[];
    regressionScores: RegressionScore[];
    researchBuilderThreads: ResearchBuilderThread[];
    responses: Response[];
    resultsFiles: ResultsFile[];
    segments: Segment[];
    statusCodeNavigation: ProjectStatus;
    submittedByNavigation?: User;
    surveyProcessings: SurveyProcessing[];
    surveySessionTestOptionOrders: SurveySessionTestOptionOrder[];
    targets: Target[];
    team: Team;
    testOptionCells: TestOptionCell[];
    testOptions: TestOption[];
    textResponses: TextResponse[];
    textResponsesThemes: TextResponsesTheme[];
    userDataExports: UserDataExport[];
    projectGroupTags: ProjectGroupTag[];
    surveyRuns: SurveyRun[];
    estimatedDuration?: EstimatedProjectDurationView;
    projectWeeks?: ProjectWeeksView[] | null;
    projectStatusLookup: ProjectStatusLookup;
    /** @format int32 */
    projectTypeId: number;
    projectQaSuggestions: ProjectQaSuggestionsView[];
    projectsRegions: ProjectsRegionsView[];
    categoryView: CategoriesView;
    projectsSystemQuestionOptions: ProjectsSystemQuestionOptionsView[];
  }

  export interface ProjectBuilderResponse {
    /** One update per section that was changed. Each update has a short summary and reasoning for that section. */
    updates: ProjectBuilderUpdate[];
    /**
     * Markdown-formatted conversational reasoning explaining the project builder updates. You can use <br> for line breaks.
     * AP style — no shorthand or abbreviations. Structured formatting with short paragraphs or bullet points.
     * Max 200 characters.
     */
    reasoning?: string | null;
  }

  export type ProjectBuilderSectionType = "Setup" | "Markets" | "Addons" | "Concepts" | "Questionnaire";

  export interface ProjectBuilderUpdate {
    sectionType: ProjectBuilderSectionType;
    /** Very short summary of changes to this section. Include counts but omit specific values (e.g., 'Added 3 questions and set regions', 'Enabled market reach', 'Set category and added concept'). Keep it concise - specific details are visible in the reasoning and UI. */
    summary: string;
    /**
     * Use markdown formatting. You can use <br> for line breaks. Short reasoning explaining what was changed in this section and why.
     * AP style — no shorthand or abbreviations. For trivial changes, keep to one brief sentence or omit entirely.
     * Max 200 characters.
     */
    reasoning?: string | null;
  }

  export interface ProjectComment {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    section: string;
    /** @format int32 */
    replyToId?: number | null;
    content: string;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format date-time */
    editedAt?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format date-time */
    dismissedAt?: string | null;
    /** @format int32 */
    dismissedBy?: number | null;
    /** @format int32 */
    projectCommentTypeId: number;
    createdByNavigation: User;
    deletedByNavigation?: User;
    dismissedByNavigation?: User;
    inverseReplyTo: ProjectComment[];
    project: Project;
    projectCommentType: ProjectCommentType;
    replyTo?: ProjectComment;
  }

  export interface ProjectCommentSingleResult {
    queryable?: ProjectComment[] | null;
  }

  export interface ProjectCommentType {
    /** @format int32 */
    id: number;
    name: string;
    projectComments: ProjectComment[];
  }

  export type ProjectCommentTypeLookup = "Basic" | "ResearcherRequest";

  export interface ProjectCreateDto {
    projectName?: string | null;
    /** @format int32 */
    frameworkId: number;
    timeZone: string;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int32 */
    projectGroupTagId?: number | null;
  }

  export interface ProjectDeclinedDto {
    reason?: string | null;
  }

  export interface ProjectDto {
    /** @format int32 */
    statusCode?: number | null;
    projectName?: string | null;
    projectType: ProjectTypeLookup;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    updatedAt: string;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy?: number | null;
    createdByNavigation?: User;
    /** @format date-time */
    submittedAt?: string | null;
    /** @format int32 */
    submittedBy?: number | null;
    category?: string | null;
    /** @format int32 */
    categoryId?: number | null;
    productType?: ProductTypeLookup;
    isBranded?: boolean | null;
    brand?: string | null;
    /** @format int32 */
    verbatimStatus?: number | null;
    /** @format int32 */
    frameworkId: number;
    /** @format int32 */
    driverModelStatus?: number | null;
    /** @format int32 */
    summaryOverviewStatus?: number | null;
    /** @format int32 */
    summaryDiagnoseStatus?: number | null;
    /** @format int32 */
    topicingStatus?: number | null;
    regionDependentTopics?: boolean | null;
    /** @format int32 */
    splitCellQuota?: number | null;
    randomiseQuestions: boolean;
    randomiseConceptOrder: boolean;
    conceptIntroText?: string | null;
    /** @format int32 */
    scheduleWavesRequired?: number | null;
    /** @format int32 */
    scheduleFrequencyWeeks?: number | null;
    /** @format int32 */
    wavesRequired?: number | null;
    /** @format date-time */
    schedulePause?: string | null;
    /** @format int32 */
    sort?: number | null;
    /** @format int32 */
    sampleSize?: number | null;
    /** @format date-time */
    scheduleStartDate?: string | null;
    /** @format int32 */
    projectTypeId: number;
    /** @format date-time */
    launchDate?: string | null;
    reference?: string | null;
    /** @format int32 */
    activeProjectObjectiveId?: number | null;
    /** @format date-time */
    startedGeneratingRecommendedQuestionsAt?: string | null;
    aiQaSuggestionsJson?: string | null;
    projectQaSuggestions: ProjectQaSuggestionsView[];
    researchNote?: string | null;
    internalResearchNote?: string | null;
    requiresResultsEmail: boolean;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int32 */
    marketReachId?: number | null;
    background?: string | null;
    researchObjectives?: string | null;
    marketsAndAudience?: string | null;
    /** @format int32 */
    pricingSensitivityVersion?: number | null;
    activeProjectObjective?: ProjectObjective;
    team: Team;
    regressionScores: RegressionScore[];
    projectsRegions: ProjectsRegionsView[];
    projectSchedules: ProjectSchedule[];
    framework: Framework;
    projectQuestions: ProjectQuestion[];
    responses: Response[];
    categoryNavigation?: Category;
    projectGroup?: ProjectGroup;
    statusCodeNavigation?: ProjectStatus;
    submittedByNavigation?: User;
    marketReach?: MarketReach;
    testOptions: TestOptionDto[];
    projectShares: ProjectShare[];
    projectLogs: ProjectLog[];
    textResponses: TextResponse[];
    textResponsesThemes: TextResponsesTheme[];
    themes: Theme[];
    surveyRuns: SurveyRun[];
    estimatedDuration?: EstimatedProjectDurationView;
    projectWeeks: ProjectWeeksView[];
    projectObjectives: ProjectObjective[];
    projectGroupTags: ProjectGroupTag[];
    creditLogs: CreditLog[];
    recommendedQuestions: RecommendedQuestion[];
    projectPriceSensitivities: ProjectPriceSensitivity[];
    testOptionCells: TestOptionCell[];
    projectsSystemQuestionOptions: ProjectsSystemQuestionOptionsView[];
    projectsAiBatchGroups: ProjectsAiBatchGroup[];
    /** @format date-time */
    lastActivityAt?: string | null;
    /** @format int32 */
    id: number;
    /** @format int32 */
    teamId: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
  }

  export interface ProjectDtoDelta {
    kind: DeltaItemKind;
    structuredType?: Type;
    expectedClrType?: Type;
    updatableProperties?: string[] | null;
    isComplexType: boolean;
  }

  export interface ProjectDtoETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface ProjectDtoSingleResult {
    queryable?: ProjectDto[] | null;
  }

  export interface ProjectEmailSummary {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    aiConversationId: number;
    /** @format int32 */
    createdBy: number;
    /** @format int32 */
    regionId: number;
    subject: string;
    body: string;
    htmlBody: string;
    /** @format date-time */
    createdAt: string;
    aiConversation: AiConversation;
    createdByNavigation: User;
    project: Project;
    region: Region;
  }

  export interface ProjectEmailSummarySingleResult {
    queryable?: ProjectEmailSummary[] | null;
  }

  export interface ProjectFact {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    projectFactTypeId: number;
    metadata: string;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    segmentId?: number | null;
    /** @format int32 */
    demographicOptionId?: number | null;
    /** @format int32 */
    screenerOptionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    description: string;
    /** @format int32 */
    sampleSize: number;
    /** @format int32 */
    projectGroupSegmentId?: number | null;
    demographicOption?: SystemQuestionOption;
    project: Project;
    projectFactType: ProjectFactType;
    projectGroupSegment?: ProjectGroupSegment;
    region: Region;
    screenerOption?: QuestionOption;
    segment?: Segment;
    testOption?: TestOption;
    projectFindings: ProjectFinding[];
    projectFactTypeLookup: ProjectFactTypes;
    metadataObject: ProjectFactMetadata;
  }

  export type ProjectFactMetadata = BaseProjectFactMetadata &
    (
      | BaseProjectFactMetadataTypenameMapping<"QualResultFactMetadata", QualResultFactMetadata>
      | BaseProjectFactMetadataTypenameMapping<"MetricResultFactMetadata", MetricResultFactMetadata>
      | BaseProjectFactMetadataTypenameMapping<"ThemeResultFactMetadata", ThemeResultFactMetadata>
      | BaseProjectFactMetadataTypenameMapping<"DriverResultFactMetadata", DriverResultFactMetadata>
      | BaseProjectFactMetadataTypenameMapping<"MarketReachResultFactMetadata", MarketReachResultFactMetadata>
      | BaseProjectFactMetadataTypenameMapping<
          "PricingSenseResultFactMetadata",
          PricingSenseResultFactMetadata
        >
    );

  export interface ProjectFactSingleResult {
    queryable?: ProjectFact[] | null;
  }

  export interface ProjectFactType {
    /** @format int32 */
    id: number;
    name: string;
    projectFacts: ProjectFact[];
  }

  export type ProjectFactTypes =
    | "QualResult"
    | "MetricResult"
    | "ThemeResult"
    | "DriverResult"
    | "MarketReachResult"
    | "PricingSenseResult";

  export interface ProjectFile {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    s3FileId?: number | null;
    /** @format int32 */
    projectFileTypeId?: number | null;
    /** @format int32 */
    createdBy?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format date-time */
    deletedAt?: string | null;
    createdByNavigation?: User;
    project: Project;
    projectFileType?: ProjectFileType;
    s3File?: S3File;
  }

  export interface ProjectFileSingleResult {
    queryable?: ProjectFile[] | null;
  }

  export interface ProjectFileType {
    /** @format int32 */
    id: number;
    name?: string | null;
    projectFiles: ProjectFile[];
  }

  export type ProjectFileTypes = "Brief" | "Stimulus" | "SyntheticReport";

  export interface ProjectFinding {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    projectFindingTypeId: number;
    /** @format double */
    confidenceScore: number;
    /** @format double */
    priorityScore: number;
    metadata: string;
    description: string;
    project: Project;
    projectFindingType: ProjectFindingType;
    projectNarrativeSectionFindings: ProjectNarrativeSectionFinding[];
    projectFacts: ProjectFact[];
    projectFindingTypeLookup: ProjectFindingTypes;
    metadataObject: ProjectFindingMetadata;
  }

  export type ProjectFindingMetadata = BaseProjectFindingMetadata &
    (
      | BaseProjectFindingMetadataTypenameMapping<"EmptyProjectFindingMetadata", EmptyProjectFindingMetadata>
      | BaseProjectFindingMetadataTypenameMapping<"UsageContextMetadata", UsageContextMetadata>
      | BaseProjectFindingMetadataTypenameMapping<
          "ForwardLookingOpportunitiesMetadata",
          ForwardLookingOpportunitiesMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<"BarriersMetadata", BarriersMetadata>
      | BaseProjectFindingMetadataTypenameMapping<
          "BenchmarkPerformanceMetadata",
          BenchmarkPerformanceMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<"RegressionDriversMetadata", RegressionDriversMetadata>
      | BaseProjectFindingMetadataTypenameMapping<
          "CrossOptionComparisonMetadata",
          CrossOptionComparisonMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<
          "NamingOrFormatPreferenceMetadata",
          NamingOrFormatPreferenceMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<
          "MessageRecallAndTakeawayMetadata",
          MessageRecallAndTakeawayMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<
          "RepeatPurchaseInsightsMetadata",
          RepeatPurchaseInsightsMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<
          "BundleIdentificationMetadata",
          BundleIdentificationMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<
          "PricingOptimumAndRangeMetadata",
          PricingOptimumAndRangeMetadata
        >
      | BaseProjectFindingMetadataTypenameMapping<
          "PricingSegmentDifferencesMetadata",
          PricingSegmentDifferencesMetadata
        >
    );

  export interface ProjectFindingSingleResult {
    queryable?: ProjectFinding[] | null;
  }

  export interface ProjectFindingType {
    /** @format int32 */
    id: number;
    name: string;
    projectFindings: ProjectFinding[];
  }

  export type ProjectFindingTypes =
    | "BehaviouralPrevalence"
    | "UsageContext"
    | "PerceptionAndDefinition"
    | "ForwardLookingOpportunities"
    | "CrossMarketComparison"
    | "QualitativeDrivers"
    | "SegmentDifferences"
    | "Barriers"
    | "BenchmarkPerformance"
    | "RegressionDrivers"
    | "CrossOptionComparison"
    | "PerformanceOverview"
    | "BrandImpactAndConsideration"
    | "NamingOrFormatPreference"
    | "MessageRecallAndTakeaway"
    | "ClaimPerformance"
    | "RepeatPurchaseInsights"
    | "BundleIdentification"
    | "SegmentSpecificBundles"
    | "PricingOptimumAndRange"
    | "PricingSegmentDifferences";

  export interface ProjectGroup {
    /** @format int32 */
    id: number;
    name: string;
    /** @format int32 */
    teamId: number;
    /** @format int32 */
    categoryId: number;
    /** @format int32 */
    createdBy?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format date-time */
    deletedAt?: string | null;
    isTemplate: boolean;
    /** @format int32 */
    deletedBy?: number | null;
    purchasedRegions: string;
    categoryLabel?: string | null;
    /** @format int32 */
    extraSeedRuns?: number | null;
    hasAddonBrands?: boolean | null;
    hasAddonNeeds?: boolean | null;
    hasAddonOccasions?: boolean | null;
    aiConversations: AiConversation[];
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    category: Category;
    createdByNavigation?: User;
    deletedByNavigation?: User;
    demandZones: DemandZone[];
    projectGroupProducts: ProjectGroupProduct[];
    projectGroupSegments: ProjectGroupSegment[];
    projectGroupShares: ProjectGroupShare[];
    projectGroupTags: ProjectGroupTag[];
    projectGroupsQuestions: ProjectGroupsQuestion[];
    projects: Project[];
    team: Team;
    userDataExports: UserDataExport[];
    purchasedRegionIds?: number[] | null;
    projectGroupMetas: ProjectGroupMetasView[];
  }

  export interface ProjectGroupCreateDto {
    name: string;
    /** @format int32 */
    categoryId?: number | null;
    /** @format int32 */
    templateId?: number | null;
    categoryLabel?: string | null;
  }

  export interface ProjectGroupGenerateSummariesDto {
    /** @format int32 */
    regionId: number;
  }

  export interface ProjectGroupMetaRegions {
    /** @format int32 */
    regionId: number;
    regionName?: string | null;
  }

  export interface ProjectGroupMetasView {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    clientId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
    hasAddonOccasions?: boolean | null;
    hasAddonNeeds?: boolean | null;
    hasAddonBrands?: boolean | null;
    /** @format int64 */
    allProjectsCount?: number | null;
    /** @format int64 */
    completedProjectsCount?: number | null;
    /** @format int64 */
    ideaProjectsCount?: number | null;
    /** @format int64 */
    messageProjectsCount?: number | null;
    /** @format int64 */
    npdProjectsCount?: number | null;
    /** @format int64 */
    adhocProjectsCount?: number | null;
    regionsRaw?: string | null;
    surveyRunIds?: number[] | null;
    regions?: ProjectGroupMetaRegions[] | null;
    projectGroup: ProjectGroup;
  }

  export interface ProjectGroupPatchDto {
    name?: string | null;
    isTemplate?: boolean | null;
    categoryLabel?: string | null;
  }

  export interface ProjectGroupProduct {
    /** @format int32 */
    id: number;
    /** @format int32 */
    productId: number;
    /** @format int32 */
    projectGroupId: number;
    isCompetitor: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    createdByNavigation: User;
    deletedByNavigation?: User;
    product: Product;
    projectGroup: ProjectGroup;
  }

  export interface ProjectGroupQuestionOrders {
    projectGroupQuestionIds: number[];
    /** @format int32 */
    projectGroupId: number;
  }

  export interface ProjectGroupSegment {
    /** @format int32 */
    id: number;
    name: string;
    filters: string;
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    teamId: number;
    /** @format int32 */
    createdBy?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format date-time */
    deletedAt?: string | null;
    description?: string | null;
    isCategorySegment: boolean;
    /** @format int32 */
    deletedBy?: number | null;
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    createdByNavigation?: User;
    demandZoneCells: DemandZoneCell[];
    projectFacts: ProjectFact[];
    projectGroup: ProjectGroup;
    team: Team;
    surveySessions: SurveySession[];
    responsesFilters: ProjectGroupSegmentFilter;
  }

  export interface ProjectGroupSegmentFilter {
    filterList: GroupSegmentFilter[];
    filter?: GroupSegmentFilter;
  }

  export interface ProjectGroupSegmentSingleResult {
    queryable?: ProjectGroupSegment[] | null;
  }

  export interface ProjectGroupShare {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    clientId: number;
    isAdmin: boolean;
    client: Client;
    projectGroup: ProjectGroup;
  }

  export interface ProjectGroupShareDto {
    /** @format int32 */
    clientId: number;
  }

  export interface ProjectGroupSingleResult {
    queryable?: ProjectGroup[] | null;
  }

  export interface ProjectGroupSummaryInputDto {
    aiProjectGroupSummaryType: AiProjectGroupSummaryTypes;
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    projectGroupSegmentId?: number | null;
    /** @format int32 */
    questionOptionId?: number | null;
    /** @format int32 */
    demandZoneId?: number | null;
  }

  export interface ProjectGroupTag {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectGroupId: number;
    name: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    projectGroup: ProjectGroup;
    projects: Project[];
  }

  export interface ProjectGroupTagDto {
    name: string;
    /** @format int32 */
    projectGroupId: number;
    projectIds: number[];
  }

  export interface ProjectGroupTagSingleResult {
    queryable?: ProjectGroupTag[] | null;
  }

  export interface ProjectGroupsQuestion {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectGroupId: number;
    /** @format int32 */
    questionId: number;
    /** @format int32 */
    questionPositionId: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    sortOrder: number;
    /** @format int32 */
    uAndATypeId?: number | null;
    questionTextVars?: string | null;
    projectGroup: ProjectGroup;
    projectQuestions: ProjectQuestion[];
    question: Question;
    questionPosition: QuestionPosition;
    region?: Region;
    uAndAType?: UAndAType;
    questionOptions: QuestionOption[];
    questionPositionLookup: QuestionPositions;
    questionTexts: GroupQuestionTextsView[];
  }

  export interface ProjectGroupsQuestionSingleResult {
    queryable?: ProjectGroupsQuestion[] | null;
  }

  export interface ProjectLog {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectLogEventId: number;
    /** @format int32 */
    userId: number;
    /** @format date-time */
    createdAt: string;
    additionalData: string;
    /** @format int32 */
    projectId: number;
    project: Project;
    projectLogEvent: ProjectLogEvent;
    user: User;
    projectLogEventType: ProjectLogEventType;
  }

  export interface ProjectLogEvent {
    /** @format int32 */
    id: number;
    name: string;
    projectLogs: ProjectLog[];
    projectLogEventType: ProjectLogEventType;
  }

  export type ProjectLogEventType =
    | "Created"
    | "StatusChanged"
    | "Deleted"
    | "ResultsReady"
    | "Shared"
    | "SubmittedForSurvey"
    | "ResearcherApproved"
    | "ResearcherRejected"
    | "ResearcherCleared";

  export interface ProjectNarrative {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    title: string;
    /** @format int32 */
    activeProjectNarrativeVersionId?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdByUserId?: number | null;
    activeProjectNarrativeVersion?: ProjectNarrativeVersion;
    createdByUser?: User;
    project: Project;
    projectNarrativeVersions: ProjectNarrativeVersion[];
  }

  export interface ProjectNarrativeSection {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectNarrativeVersionId: number;
    title: string;
    content: string;
    /** @format int32 */
    sortOrder: number;
    /** @format int32 */
    projectId: number;
    project: Project;
    projectNarrativeSectionFindings: ProjectNarrativeSectionFinding[];
    projectNarrativeVersion: ProjectNarrativeVersion;
  }

  export interface ProjectNarrativeSectionFinding {
    /** @format int32 */
    projectNarrativeSectionId: number;
    /** @format int32 */
    projectFindingId: number;
    reasoningText?: string | null;
    projectFinding: ProjectFinding;
    projectNarrativeSection: ProjectNarrativeSection;
  }

  export interface ProjectNarrativeSectionSingleResult {
    queryable?: ProjectNarrativeSection[] | null;
  }

  export interface ProjectNarrativeSingleResult {
    queryable?: ProjectNarrative[] | null;
  }

  export interface ProjectNarrativeVersion {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectNarrativeId: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdByUserId?: number | null;
    /** @format int32 */
    projectId: number;
    createdByUser?: User;
    project: Project;
    projectNarrative: ProjectNarrative;
    projectNarrativeSections: ProjectNarrativeSection[];
    projectNarrativeVersionExports: ProjectNarrativeVersionExport[];
    projectNarratives: ProjectNarrative[];
  }

  export interface ProjectNarrativeVersionExport {
    /** @format int32 */
    id: number;
    name: string;
    /** @format int32 */
    s3FileId?: number | null;
    /** @format int32 */
    projectNarrativeVersionId: number;
    /** @format date-time */
    completedAt?: string | null;
    /** @format int32 */
    projectId: number;
    project: Project;
    projectNarrativeVersion: ProjectNarrativeVersion;
    s3File?: S3File;
  }

  export interface ProjectNarrativeVersionExportSingleResult {
    queryable?: ProjectNarrativeVersionExport[] | null;
  }

  export interface ProjectNarrativeVersionSingleResult {
    queryable?: ProjectNarrativeVersion[] | null;
  }

  export interface ProjectObjective {
    /** @format int32 */
    id: number;
    summary: string;
    /** @format int32 */
    userId: number;
    /** @format int32 */
    projectId?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    aiProjectSummaries: AiProjectSummary[];
    deletedByNavigation?: User;
    project?: Project;
    projects: Project[];
    user: User;
  }

  export interface ProjectObjectiveSingleResult {
    queryable?: ProjectObjective[] | null;
  }

  export interface ProjectPriceSensitivity {
    /** @format int32 */
    id: number;
    /** @format double */
    highPrice: number;
    /** @format double */
    lowPrice: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    regionId: number;
    exampleProducts: string;
    /** @format double */
    typicalPrice: number;
    project: Project;
    region: Region;
    testOptions: TestOption[];
  }

  export interface ProjectQaSuggestionsView {
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    entityType?: number | null;
    /** @format int32 */
    entityId?: number | null;
    suggestion?: string | null;
    /** @format int32 */
    ruleNumber?: number | null;
    /** @format double */
    confidenceScore?: number | null;
    project: Project;
    entityTypeLookup: QaEntityType;
  }

  export interface ProjectQuestion {
    /** @format int32 */
    id: number;
    /** @format int32 */
    questionId: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    questionPositionId: number;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    sortOrder: number;
    isSynthetic: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    routingId?: number | null;
    hasSurveyPageBreakAfter: boolean;
    questionTextVars?: string | null;
    /** @format int32 */
    projectGroupsQuestionId?: number | null;
    /** @format int32 */
    projectQuestionThemingVersionId?: number | null;
    project: Project;
    projectGroupsQuestion?: ProjectGroupsQuestion;
    projectQuestionThemingVersion?: ProjectQuestionThemingVersion;
    question: Question;
    questionPosition: QuestionPosition;
    regressionScores: RegressionScore[];
    responses: Response[];
    routing?: Routing;
    routings: Routing[];
    shortThemeSummaries: ShortThemeSummary[];
    testOption?: TestOption;
    textResponses: TextResponse[];
    themeSentiments: ThemeSentiment[];
    questionPositionLookup: QuestionPositions;
    questionTexts: ProjectQuestionTextsView[];
  }

  export interface ProjectQuestionDto {
    /** @format int32 */
    id: number;
    /** @format int32 */
    questionId: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    questionPositionId: number;
    /** @format int32 */
    projectQuestionThemingVersionId?: number | null;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    sortOrder: number;
    isSynthetic: boolean;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt?: string | null;
    /** @format int32 */
    routingId?: number | null;
    hasSurveyPageBreakAfter: boolean;
    project: Project;
    question: Question;
    questionPosition: QuestionPosition;
    responses: Response[];
    routing?: Routing;
    routings: Routing[];
    standardQuestion?: StandardQuestion;
    testOption?: TestOption;
    textResponses: TextResponse[];
    questionTexts: ProjectQuestionTextsView[];
    questionPositionLookup: QuestionPositions;
  }

  export interface ProjectQuestionDtoETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface ProjectQuestionTextsView {
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    projectQuestionId?: number | null;
    questionText?: string | null;
    projectQuestion: ProjectQuestion;
  }

  export interface ProjectQuestionThemingVersion {
    /** @format int32 */
    id: number;
    name: string;
    projectQuestions: ProjectQuestion[];
  }

  export interface ProjectSchedule {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format date-time */
    scheduleDate: string;
    /** @format int32 */
    createdBy?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    surveyRunId?: number | null;
    /** @format int32 */
    regionId: number;
    /** @format double */
    incidenceEstimate?: number | null;
    /** @format int32 */
    sampleSize?: number | null;
    /** @format double */
    creditCostAtSubmit?: number | null;
    isStandby: boolean;
    /** @format double */
    averageProjectCompletionTime?: number | null;
    /** @format int32 */
    projectScheduleTypeId: number;
    /** @format int32 */
    surveyProcessingId?: number | null;
    /** @format int32 */
    surveySampleProviderId?: number | null;
    isCustomerPanel?: boolean | null;
    createdByNavigation?: User;
    creditLog?: CreditLog;
    project: Project;
    projectScheduleType: ProjectScheduleType;
    region: Region;
    surveyProcessing?: SurveyProcessing;
    surveyRun?: SurveyRun;
    surveySampleProvider?: SurveySampleProvider;
  }

  export interface ProjectScheduleEstimate {
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    regionId: number;
    projectType: string;
    /** @format int32 */
    projectScheduleCount: number;
    /** @format int32 */
    futureProjectScheduleCount: number;
    /** @format double */
    creditAmountBase: number;
    /** @format double */
    creditAmountDiscounted: number;
    /** @format double */
    creditAmountPrevious: number;
    /** @format double */
    creditAmountFuture: number;
    /** @format int32 */
    currencyRegionMultiplier: number;
  }

  export interface ProjectScheduleSingleResult {
    queryable?: ProjectSchedule[] | null;
  }

  export interface ProjectScheduleType {
    /** @format int32 */
    id: number;
    name: string;
    projectSchedules: ProjectSchedule[];
  }

  export interface ProjectShare {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    teamId: number;
    project: Project;
    projectWatchers: ProjectWatcher[];
    team: Team;
  }

  export interface ProjectShareSingleResult {
    queryable?: ProjectShare[] | null;
  }

  export interface ProjectStatus {
    status?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    projects: Project[];
  }

  export type ProjectStatusLookup =
    | "Draft"
    | "AwaitingApproval"
    | "Submitted"
    | "ReviewingQuestions"
    | "AwaitingSurvey"
    | "WaitingOnResponses"
    | "SomeResultsReady"
    | "WaveComplete"
    | "Complete"
    | "Demo";

  export interface ProjectStatusSingleResult {
    queryable?: ProjectStatus[] | null;
  }

  export interface ProjectSummaryInputDto {
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    themeId?: number | null;
    /** @format int32 */
    segmentId?: number | null;
    /** @format int32 */
    projectObjectiveId?: number | null;
    benchmarkType?: BenchmarkTypes;
    comparisonDisplayMode?: string | null;
  }

  export interface ProjectSurveySessionsView {
    /** @format int32 */
    id?: number | null;
    externalId?: string | null;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    surveyRunId?: number | null;
    /** @format int32 */
    projectId?: number | null;
    psid?: string | null;
    /** @format int32 */
    surveySampleProviderId?: number | null;
  }

  export interface ProjectSurveySessionsViewSingleResult {
    queryable?: ProjectSurveySessionsView[] | null;
  }

  export interface ProjectSystemQuestionOption {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId?: number | null;
    answerLabel: string;
    /** @format int32 */
    answerValue: number;
    /** @format int32 */
    systemQuestionId: number;
    questionLabel: string;
    questionCode: string;
    /** @format int32 */
    systemQuestionTypeId: number;
    /** @format int32 */
    responseCount: number;
  }

  export interface ProjectToDocumentDto {
    inputText?: string | null;
    documentFileKey?: string | null;
    documentContentType?: string | null;
    /** @format int32 */
    fileId?: number | null;
    /** @format int32 */
    frameworkId: number;
    /** @format int32 */
    teamId: number;
    timeZone: string;
  }

  export interface ProjectType {
    /** @format int32 */
    id: number;
    type?: string | null;
    frameworks: Framework[];
  }

  export type ProjectTypeLookup = "idea" | "message" | "question" | "npd";

  export interface ProjectWatcher {
    /** @format int32 */
    id: number;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    projectShareId: number;
    /** @format int32 */
    userAndClientId: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    createdByNavigation: User;
    deletedByNavigation?: User;
    projectShare: ProjectShare;
    userAndClient: UserAndClient;
  }

  export interface ProjectWatcherSingleResult {
    queryable?: ProjectWatcher[] | null;
  }

  export interface ProjectWeeksView {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    surveyRunId?: number | null;
    /** @format int32 */
    regionId?: number | null;
    /** @format date-time */
    startDate?: string | null;
    /** @format date-time */
    scheduleDate?: string | null;
    /** @format double */
    week?: number | null;
    /** @format int32 */
    surveySampleProviderId?: number | null;
    project?: Project;
  }

  export interface ProjectWeeksViewSingleResult {
    queryable?: ProjectWeeksView[] | null;
  }

  export interface ProjectsAiBatchGroup {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    surveyRunId: number;
    /** @format int32 */
    aiBatchGroupId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    aiBatchGroup: AiBatchGroup;
    project: Project;
    surveyRun: SurveyRun;
  }

  export interface ProjectsAiBatchGroupSingleResult {
    queryable?: ProjectsAiBatchGroup[] | null;
  }

  export interface ProjectsRegionsView {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    regionId?: number | null;
    hasSurveyRuns?: boolean | null;
    hasSchedules?: boolean | null;
    project?: Project;
    region?: Region;
  }

  export interface ProjectsRegionsViewSingleResult {
    queryable?: ProjectsRegionsView[] | null;
  }

  export interface ProjectsSystemQuestionOptionsView {
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    systemQuestionOptionId?: number | null;
    project?: Project;
    region?: Region;
    systemQuestionOption?: SystemQuestionOption;
  }

  export interface Prompt {
    /** @format int32 */
    id: number;
    description: string;
    /** @format int32 */
    promptTypeId?: number | null;
    /** @format int32 */
    activePromptVersionId?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format int32 */
    regressionBatchId?: number | null;
    activePromptVersion?: PromptVersion;
    aiBatches: AiBatch[];
    createdByNavigation: User;
    promptType?: PromptType;
    promptVersions: PromptVersion[];
    promptsPromptEvaluations: PromptsPromptEvaluation[];
    regressionBatch?: AiBatch;
    promptTypeName: PromptTypeLookup;
  }

  export interface PromptEvaluation {
    /** @format int32 */
    id: number;
    ratingDefinitions: string;
    name: string;
    definition: string;
    additionalInstructions?: string | null;
    promptsPromptEvaluations: PromptsPromptEvaluation[];
  }

  export interface PromptEvaluationAssignment {
    /** @format int32 */
    evaluationId: number;
    /** @format int32 */
    aiModelDefinitionId: number;
    /** @format int32 */
    aiServiceId: number;
    executorScope?: string[] | null;
  }

  export interface PromptEvaluationSingleResult {
    queryable?: PromptEvaluation[] | null;
  }

  export interface PromptSingleResult {
    queryable?: Prompt[] | null;
  }

  export interface PromptType {
    /** @format int32 */
    id: number;
    name: string;
    isWorkflow: boolean;
    prompt?: Prompt;
    lookup: PromptTypeLookup;
  }

  export type PromptTypeLookup =
    | "DriversByTheme"
    | "DriversOverall"
    | "EmailIdea"
    | "EmailMessage"
    | "EmailNpd"
    | "EmailQuestion"
    | "ListViewMultipleTests"
    | "ListViewSingleTest"
    | "MapViewMultipleTests"
    | "MapViewSingleTest"
    | "RecommendedQuestions"
    | "TestGroupPerformance"
    | "ProfileQuestion"
    | "IncidenceEstimate"
    | "FullTestSummary"
    | "QualQuestionSummary"
    | "SubmittedProjectQa"
    | "PriceSensitivitySummary"
    | "ImageFileMetadata"
    | "ThemeGenerate"
    | "ThemeTextResponses"
    | "ShortThemeSummary"
    | "AssignProjectCategory"
    | "ProjectTranslation"
    | "StandardQuestionTranslation"
    | "DecipherSurveyTextTranslation"
    | "CategorySegments"
    | "TextResponsesQa"
    | "AskMeAnything"
    | "SentimentThemeGenerate"
    | "SentimentThemeTextResponses"
    | "DocumentToProject"
    | "ProjectPdfFileMetadata"
    | "ProjectGroupSegmentSummary"
    | "OccasionsQuestionSummary"
    | "UandAQuestionsSummary"
    | "SentimentThemeGroup"
    | "ResearchBuilder"
    | "OccasionsOverviewSummary"
    | "SyntheticSurveyWorkflow"
    | "Theming"
    | "OccasionNetsGeneration"
    | "DemandZonesWorkflow"
    | "ProjectGroupSummaryWorkflow"
    | "BulkInviteWorkflow"
    | "FactsFindingsWorkflow"
    | "SlideDeckGeneration"
    | "BackfillProjectObjectives"
    | "DiscoverProductsWorkflow"
    | "RespondentsCsvEditWorkflow"
    | "GenerateFilterSetsWorkflow";

  export interface PromptVersion {
    /** @format int32 */
    id: number;
    /** @format int32 */
    promptId: number;
    content: string;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    updatedBy?: number | null;
    /** @format date-time */
    publishedAt?: string | null;
    /** @format int32 */
    publishedBy?: number | null;
    description?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    aiBatchRuns: AiBatchRun[];
    aiConversations: AiConversation[];
    createdByNavigation: User;
    deletedByNavigation?: User;
    prompt: Prompt;
    prompts: Prompt[];
    publishedByNavigation?: User;
    syntheticProviderSettings: SyntheticProviderSetting[];
    updatedByNavigation?: User;
  }

  export interface PromptVersionDelta {
    kind: DeltaItemKind;
    structuredType?: Type;
    expectedClrType?: Type;
    updatableProperties?: string[] | null;
    isComplexType: boolean;
  }

  export interface PromptVersionHistoryDto {
    /** @format int32 */
    promptVersionId: number;
    /** @format date-time */
    timestamp: string;
  }

  export interface PromptVersionSingleResult {
    queryable?: PromptVersion[] | null;
  }

  export interface PromptsPromptEvaluation {
    /** @format int32 */
    promptId: number;
    /** @format int32 */
    promptEvaluationId: number;
    /** @format int32 */
    aiModelDefinitionId: number;
    /** @format int32 */
    aiServiceId: number;
    executorScope?: string[] | null;
    aiModelDefinition: AiModelDefinition;
    aiService: AiService;
    prompt: Prompt;
    promptEvaluation: PromptEvaluation;
    aiServiceLookup: AiServiceLookup;
  }

  export type PropertyAttributes =
    | "None"
    | "SpecialName"
    | "RTSpecialName"
    | "HasDefault"
    | "Reserved2"
    | "Reserved3"
    | "Reserved4"
    | "ReservedMask";

  export interface PropertyInfo {
    name: string;
    declaringType?: Type;
    reflectedType?: Type;
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;
  }

  export interface PublicKey {
    encodedKeyValue: AsnEncodedData;
    encodedParameters?: AsnEncodedData;
    key: AsymmetricAlgorithm;
    oid: Oid;
  }

  export type QaEntityType = "Project" | "ProjectQuestion" | "TestOption" | "Other";

  export interface QualResult {
    /** @format int32 */
    id: number;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format double */
    percentage: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    testOptionId?: number | null;
    testOptionName?: string | null;
    /** @format int32 */
    count: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    answerValue?: number | null;
    /** @format int32 */
    week?: number | null;
    /** @format int32 */
    optionId?: number | null;
    optionText?: string | null;
    splitByValue: string;
    /** @format int32 */
    splitById: number;
    /** @format int32 */
    totalCount: number;
    /** @format float */
    weight: number;
    /** @format float */
    totalWeight: number;
    /** @format int32 */
    questionId: number;
    affirmative: boolean;
  }

  export interface QualResultFactMetadata {
    typename: "QualResultFactMetadata";
    /**
     * The ID of the project question this fact is derived from
     * @format int32
     */
    projectQuestionId: number;
    /**
     * The question option ID (answer choice) that was selected
     * @format int32
     */
    questionOptionId: number;
    /**
     * The percentage of respondents who selected this answer
     * @format double
     */
    percentage: number;
    vsTotal?: VsTotalComparison;
  }

  export interface QualResultGroup {
    /** @format int32 */
    questionId: number;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format double */
    percentage: number;
    /** @format int32 */
    testOptionId?: number | null;
    testOptionName?: string | null;
    /** @format int32 */
    count: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    answerValue?: number | null;
    /** @format int32 */
    week?: number | null;
    /** @format float */
    weight: number;
    /** @format int32 */
    optionId?: number | null;
    optionText?: string | null;
    splitByValue: string;
    /** @format int32 */
    splitById: number;
    /** @format int32 */
    totalCount: number;
    /** @format float */
    totalWeight: number;
    /** @format date-time */
    latestRespondedAt: string;
  }

  export type QueryNodeKind =
    | "None"
    | "Constant"
    | "Convert"
    | "NonResourceRangeVariableReference"
    | "BinaryOperator"
    | "UnaryOperator"
    | "SingleValuePropertyAccess"
    | "CollectionPropertyAccess"
    | "SingleValueFunctionCall"
    | "Any"
    | "CollectionNavigationNode"
    | "SingleNavigationNode"
    | "SingleValueOpenPropertyAccess"
    | "SingleResourceCast"
    | "All"
    | "CollectionResourceCast"
    | "ResourceRangeVariableReference"
    | "SingleResourceFunctionCall"
    | "CollectionFunctionCall"
    | "CollectionResourceFunctionCall"
    | "NamedFunctionParameter"
    | "ParameterAlias"
    | "EntitySet"
    | "KeyLookup"
    | "SearchTerm"
    | "CollectionOpenPropertyAccess"
    | "CollectionComplexNode"
    | "SingleComplexNode"
    | "Count"
    | "SingleValueCast"
    | "CollectionPropertyNode"
    | "AggregatedCollectionPropertyNode"
    | "In"
    | "CollectionConstant"
    | "RootPath"
    | "CustomQueryOption";

  export interface QueryString {
    value?: string | null;
    hasValue: boolean;
  }

  export interface Question {
    questionText?: string | null;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    shuffleOptions?: string | null;
    /** @format int32 */
    atleast?: number | null;
    /** @format int32 */
    atmost?: number | null;
    questionTitle: string;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    createdBy?: number | null;
    isSynthetic: boolean;
    isTemplate: boolean;
    allowShortAnswer: boolean;
    /** @format int32 */
    s3FileId?: number | null;
    /** @format int32 */
    questionTypeId: number;
    /** @format int32 */
    questionTextTranslatedTextId?: number | null;
    marketReachEnabled: boolean;
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    aiProjectSummaries: AiProjectSummary[];
    clientQuestionTemplates: ClientQuestionTemplate[];
    createdByNavigation?: User;
    incidenceEstimates: IncidenceEstimate[];
    projectGroupsQuestions: ProjectGroupsQuestion[];
    projectQuestions: ProjectQuestion[];
    questionOptions: QuestionOption[];
    questionRegionIrs: QuestionRegionIr[];
    questionTextTranslatedText?: TranslatedText;
    questionType: QuestionType;
    regressionScores: RegressionScore[];
    s3File?: S3File;
    standardQuestion?: StandardQuestion;
    targets: Target[];
    textResponses: TextResponse[];
    questionTemplates: QuestionTemplatesView[];
    questionTypeLookup: QuestionTypeLookup;
  }

  export interface QuestionCreateDto {
    isTemplate?: boolean | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int32 */
    questionTypeId: number;
    allowShortAnswer?: boolean | null;
    questionTitle: string;
    questionText: string;
    questionPosition: QuestionPositions;
    /** @format int32 */
    sortOrder: number;
    questionTextVars?: Record<string, string>;
    /** @format int32 */
    uAndATypeId?: number | null;
    randomiseAnswerOrder: boolean;
    /** @format int32 */
    atleast?: number | null;
    /** @format int32 */
    atmost?: number | null;
    isSynthetic: boolean;
    marketReachEnabled: boolean;
    questionOptions: QuestionOptionsCreateDto[];
    routings: RoutingCreateDto[];
    file?: QuestionCreateFileDto;
    deleteFile: boolean;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    hasSurveyPageBreakAfter: boolean;
  }

  export interface QuestionCreateFileDto {
    key: string;
    contentType: string;
  }

  export interface QuestionDto {
    /** @format int32 */
    questionTypeId: number;
    questionTypeLookup: QuestionTypeLookup;
    allowShortAnswer?: boolean | null;
    questionText?: string | null;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    createdAt?: string | null;
    /** @format date-time */
    updatedAt?: string | null;
    /** @format int32 */
    id: number;
    shuffleOptions?: string | null;
    /** @format int32 */
    atleast?: number | null;
    /** @format int32 */
    atmost?: number | null;
    questionTitle: string;
    /** @format int32 */
    standardQuestionId?: number | null;
    regionsIr?: string | null;
    isTemplate: boolean;
    marketReachEnabled: boolean;
    project?: Project;
    questionOptions: QuestionOption[];
    standardQuestion?: StandardQuestion;
    targets: Target[];
    clientQuestionTemplates: ClientQuestionTemplate[];
    templateQuestion?: Question;
    textResponses: TextResponse[];
    inverseTemplateQuestion: Question[];
    projectGroupsQuestions: ProjectGroupsQuestion[];
    questionTemplates: QuestionTemplatesView[];
    projectQuestions: ProjectQuestion[];
    createdByUser?: User;
    s3File?: S3File;
  }

  export interface QuestionDtoETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface QuestionDtoSingleResult {
    queryable?: QuestionDto[] | null;
  }

  export interface QuestionListDto {
    questionIds: number[];
    standardQuestionIds?: number[] | null;
  }

  export interface QuestionOption {
    /** @format int32 */
    questionId: number;
    optionText?: string | null;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    randomise?: boolean | null;
    exclusive?: boolean | null;
    affirmative: boolean;
    /** @format int32 */
    templateQuestionOptionId?: number | null;
    /** @format double */
    answerValue?: number | null;
    /** @format int32 */
    optionTextTranslatedTextId?: number | null;
    /** @format int32 */
    s3FileId?: number | null;
    isExcluded: boolean;
    /** @format int32 */
    parentOptionId?: number | null;
    optionDescription?: string | null;
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    demandZoneCells: DemandZoneCell[];
    inverseParentOption: QuestionOption[];
    inverseTemplateQuestionOption: QuestionOption[];
    marketReachesTestOptions: MarketReachesTestOption[];
    optionTextTranslatedText?: TranslatedText;
    parentOption?: QuestionOption;
    projectFacts: ProjectFact[];
    question: Question;
    responses: Response[];
    s3File?: S3File;
    targets: Target[];
    templateQuestionOption?: QuestionOption;
    projectGroupQuestions: ProjectGroupsQuestion[];
    routingConditions: RoutingCondition[];
    screenerQuestionOptionsResponses: ScreenerQuestionOptionsResponsesView[];
    screenerQuestionOptionsTextResponses: ScreenerQuestionOptionsTextResponsesView[];
  }

  export interface QuestionOptionSingleResult {
    queryable?: QuestionOption[] | null;
  }

  export interface QuestionOptionsCreateDto {
    optionText: string;
    fixedPosition: boolean;
    exclusive: boolean;
    isTarget?: boolean | null;
    isExcluded: boolean;
    affirmative: boolean;
    /** @format double */
    answerValue?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    file?: QuestionCreateFileDto;
    optionDescription?: string | null;
  }

  export interface QuestionOrders {
    projectQuestionIds: number[];
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    questionPositionId: number;
    /** @format int32 */
    removeRoutingProjectQuestionId?: number | null;
  }

  export interface QuestionPosition {
    /** @format int32 */
    id: number;
    name?: string | null;
    clientQuestionTemplates: ClientQuestionTemplate[];
    projectGroupsQuestions: ProjectGroupsQuestion[];
    projectQuestions: ProjectQuestion[];
    recommendedQuestions: RecommendedQuestion[];
  }

  export type QuestionPositions =
    | "Screener"
    | "InsideLoop"
    | "OutsideLoop"
    | "Awareness"
    | "Standard"
    | "Custom"
    | "BeforeLoop"
    | "Segment"
    | "Occasions"
    | "UsageAndAttitudeTracked"
    | "CustomMetric"
    | "OccasionsNet";

  export interface QuestionRegionIr {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    questionId: number;
    /** @format double */
    ir: number;
    question: Question;
    region: Region;
  }

  export interface QuestionTemplateDto {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    clientId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    questionTitle?: string | null;
    questionText?: string | null;
    projectIdsInUse?: number[] | null;
    isScreener?: boolean | null;
    question: Question;
  }

  export interface QuestionTemplateDtoETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface QuestionTemplateDtoSingleResult {
    queryable?: QuestionTemplateDto[] | null;
  }

  export interface QuestionTemplatesView {
    /** @format int32 */
    id?: number | null;
    /** @format int32 */
    clientId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    questionTitle?: string | null;
    questionText?: string | null;
    projectIdsInUse?: number[] | null;
    /** @format int32 */
    questionPositionId?: number | null;
    /** @format int32 */
    questionTypeId?: number | null;
    question: Question;
    client: Client;
  }

  export interface QuestionType {
    /** @format int32 */
    id: number;
    title?: string | null;
    questions: Question[];
    recommendedQuestions: RecommendedQuestion[];
    standardQuestions: StandardQuestion[];
    systemQuestions: SystemQuestion[];
  }

  export type QuestionTypeLookup = "single" | "multiple" | "text" | "dropdown" | "numeric";

  export interface RangeVariable {
    name?: string | null;
    typeReference?: any;
    /** @format int32 */
    kind: number;
  }

  export interface ReThemeProjectDto {
    regionIds: number[];
    projectQuestionIds: number[];
    /** @format int32 */
    themingVersion: number;
    groupsOnly: boolean;
    sentimentMode?: boolean | null;
    /** @format int32 */
    surveyRunId?: number | null;
  }

  export type ReasoningEffort = "None" | "Low" | "Medium" | "High" | "Minimal";

  export interface ReasoningEffortDto {
    /** @format int32 */
    id: number;
    name: string;
  }

  export interface ReassignThemesDto {
    themeIds: number[];
  }

  export interface RecommendedQuestion {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    questionPositionId: number;
    category: string;
    title: string;
    text: string;
    formattedText: string;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    questionTypeId: number;
    project: Project;
    questionPosition: QuestionPosition;
    questionType: QuestionType;
    recommendedQuestionOptions: RecommendedQuestionOption[];
    questionPositionLookup: QuestionPositions;
    questionTypeLookup: QuestionTypeLookup;
  }

  export interface RecommendedQuestionOption {
    /** @format int32 */
    id: number;
    /** @format int32 */
    recommendedQuestionId: number;
    text: string;
    isTarget: boolean;
    recommendedQuestion: RecommendedQuestion;
  }

  export interface RecommendedQuestionsOutput {
    questions: RecommendedQuestion[];
  }

  export interface RefetchProjectMetadata {
    typename: "RefetchProjectMetadata";
    actionTaken: boolean;
    persistUntilActioned: boolean;
    actionOutcome?: string | null;
  }

  export interface Region {
    regionName?: string | null;
    /** @format int32 */
    parentRegionId?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    isSupportedCountry?: boolean | null;
    /** @format int32 */
    defaultSampleSize?: number | null;
    isPublic: boolean;
    currencySymbol: string;
    currencyCode: string;
    translateToLanguage?: string | null;
    timezone?: string | null;
    regionCode: string;
    /** @format double */
    creditCostMultiplier: number;
    samplifyLanguageCode: string;
    /** @format uuid */
    samplifyTemplateUuid?: string | null;
    /** @format int32 */
    legalDrinkingAge: number;
    regionCode2?: string | null;
    aiProjectGroupSummaries: AiProjectGroupSummary[];
    aiProjectSummaries: AiProjectSummary[];
    demandZones: DemandZone[];
    displayScheduleExceptions: DisplayScheduleException[];
    displaySchedules: DisplaySchedule[];
    incidenceEstimates: IncidenceEstimate[];
    incidenceRates: IncidenceRate[];
    inverseParentRegion: Region[];
    parentRegion?: Region;
    products: Product[];
    projectEmailSummaries: ProjectEmailSummary[];
    projectFacts: ProjectFact[];
    projectGroupsQuestions: ProjectGroupsQuestion[];
    projectPriceSensitivities: ProjectPriceSensitivity[];
    projectSchedules: ProjectSchedule[];
    questionRegionIrs: QuestionRegionIr[];
    regressionScores: RegressionScore[];
    responses: Response[];
    sampleIrs: SampleIr[];
    surveyRuns: SurveyRun[];
    surveySessions: SurveySession[];
    systemQuestionOptionWeights: SystemQuestionOptionWeight[];
    systemQuestionOptions: SystemQuestionOption[];
    targets: Target[];
    textResponses: TextResponse[];
    themeSentiments: ThemeSentiment[];
    translatedTextRegions: TranslatedTextRegion[];
    projectsRegions: ProjectsRegionsView[];
    projectsSystemQuestionOptions: ProjectsSystemQuestionOptionsView[];
  }

  export interface RegionDelta {
    kind: DeltaItemKind;
    structuredType?: Type;
    expectedClrType?: Type;
    updatableProperties?: string[] | null;
    isComplexType: boolean;
  }

  export interface RegionSingleResult {
    queryable?: Region[] | null;
  }

  export interface RegionStat {
    /** @format int32 */
    id: number;
    regionName: string;
    /** @format int32 */
    projectCount: number;
    /** @format int32 */
    surveyRunCount: number;
    /** @format int32 */
    ideaProjectCount: number;
    /** @format int32 */
    messageProjectCount: number;
    /** @format int32 */
    adhocProjectCount: number;
    /** @format int32 */
    npdProjectCount: number;
  }

  export interface RegressionDriversMetadata {
    typename: "RegressionDriversMetadata";
    /** True for a positive driver, false for a negative driver / barrier */
    isDriver: boolean;
  }

  export interface RegressionScore {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    themeId: number;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format double */
    value?: number | null;
    /** @format double */
    pValue?: number | null;
    /** @format int32 */
    projectQuestionId: number;
    /** @format int32 */
    customMetricQuestionId?: number | null;
    customMetricQuestion?: Question;
    project: Project;
    projectQuestion: ProjectQuestion;
    region: Region;
    standardQuestion?: StandardQuestion;
    testOption?: TestOption;
    theme: Theme;
  }

  export interface RegressionScoreSingleResult {
    queryable?: RegressionScore[] | null;
  }

  export interface RemoveFromSurveyRunDto {
    /** @format int32 */
    surveyRunId: number;
  }

  export interface RemoveUserFromAccountDto {
    /** @format int32 */
    clientId?: number | null;
    removeFromChildren: boolean;
  }

  export interface RemoveUuidsFromSurveyDto {
    uuidsToRemove: string[];
    projectIds: number[];
  }

  export interface RenameOrgDto {
    name: string;
  }

  export interface RenameTeamDto {
    name: string;
  }

  export type RepeatLikelihood = "High" | "Medium" | "Low";

  export interface RepeatPurchaseInsightsMetadata {
    typename: "RepeatPurchaseInsightsMetadata";
    repeatLikelihood?: RepeatLikelihood;
  }

  export interface ResearchBuilderFrameworkMetadata {
    typename: "ResearchBuilderFrameworkMetadata";
    actionTaken: boolean;
    persistUntilActioned: boolean;
    actionOutcome?: string | null;
    /**
     * The suggested framework id
     * @format int32
     */
    suggestedFrameworkId?: number | null;
  }

  export interface ResearchBuilderMetadata {
    typename: "ResearchBuilderMetadata";
    /** A follow up question to ask the user */
    followUpQuestion?: string | null;
    /** Suggested responses that will become the next user message (leave null or empty if no suitable suggestions) - max 4. IMPORTANT: Responses must be actionable chat messages. For file upload questions, either omit suggestions or provide responses like 'No files to upload' or 'Skip for now'. Never suggest actions users can't perform via chat (e.g., don't say 'Upload stimuli now'). */
    suggestedResponses?: string[] | null;
    sectionUpdateResponse?: SectionUpdateResponse;
    frameworkSuggestionResponse?: FrameworkSuggestionResponse;
    projectBuilderResponse?: ProjectBuilderResponse;
    followUpSection?: FollowUpSectionType;
    /**
     * The project ID if a project was created or already exists for this thread
     * @format int32
     */
    projectId?: number | null;
  }

  export interface ResearchBuilderProgressMetadata {
    typename: "ResearchBuilderProgressMetadata";
    /** Planning state - true when planning, false when planned, null when not yet started */
    planning?: boolean | null;
    /** Section update state - true when updating, false when updated, null when not yet started */
    updatingSections?: boolean | null;
    /** Framework selection state - true when selecting, false when selected, null when not yet started */
    selectingFramework?: boolean | null;
    /** Survey building state - true when building, false when built, null when not yet started */
    buildingSurvey?: boolean | null;
    /** Framework selected state - true when framework was selected in the most recent message */
    frameworkSelected?: boolean | null;
    /**
     * Short user-facing reasoning text shown while the coordinator is planning.
     * Set by the report_progress tool so the user can see what the agent is thinking about.
     */
    currentReasoning?: string | null;
  }

  export interface ResearchBuilderThread {
    /** @format int32 */
    id: number;
    /** @format int32 */
    aiThreadId: number;
    name?: string | null;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    teamId: number;
    aiThread: AiThread;
    project?: Project;
    researchBuilderThreadFiles: ResearchBuilderThreadFile[];
    team: Team;
  }

  export interface ResearchBuilderThreadFile {
    /** @format int32 */
    id: number;
    /** @format int32 */
    researchBuilderThreadId: number;
    /** @format int32 */
    s3FileId: number;
    /** @format int32 */
    fileType: number;
    /** @format int32 */
    createdBy: number;
    /** @format date-time */
    createdAt: string;
    createdByNavigation: User;
    researchBuilderThread: ResearchBuilderThread;
    s3File: S3File;
  }

  export interface ResearchBuilderThreadSingleResult {
    queryable?: ResearchBuilderThread[] | null;
  }

  export interface ResendInviteDto {
    /** @format int32 */
    clientId: number | null;
  }

  export interface ResetPasswordDto {
    email: string;
    code: string;
    newPassword: string;
  }

  export interface ResolvedClientSettingsDto {
    brandGuideMd: StringResolvedFieldDto;
    documentPlatformId: Int32NullableResolvedFieldDto;
    logoS3FileId: Int32NullableResolvedFieldDto;
    logoUrl?: string | null;
  }

  export interface RespondentCount {
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    count: number;
    /** @format float */
    weight: number;
    byWeek: RespondentCountByWeek[];
  }

  export interface RespondentCountByWeek {
    /** @format int32 */
    week: number;
    /** @format int32 */
    count: number;
    /** @format float */
    weight: number;
  }

  export interface RespondentsCsvEditProposalMetadata {
    typename: "RespondentsCsvEditProposalMetadata";
    actionTaken: boolean;
    persistUntilActioned: boolean;
    actionOutcome?: string | null;
    referenceId: string;
    /** @format int32 */
    s3FileId: number;
    fileName: string;
  }

  export interface RespondentsCsvUploadUrlDto {
    url: string;
    stagingFileName: string;
  }

  export interface Response {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    surveySessionId: number;
    /** @format double */
    weight: number;
    answerCode?: string | null;
    /** @format int32 */
    questionOptionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    externalResponseId: string;
    /** @format int32 */
    answer: number;
    /** @format int32 */
    answerValue?: number | null;
    /** @format date-time */
    respondedAt: string;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    projectQuestionId?: number | null;
    project: Project;
    projectQuestion?: ProjectQuestion;
    questionOption?: QuestionOption;
    region: Region;
    standardQuestion?: StandardQuestion;
    surveySession: SurveySession;
    testOption?: TestOption;
    screenerQuestionOptionsResponses: ScreenerQuestionOptionsResponsesView[];
    systemQuestionOptionsResponses: SystemQuestionOptionsResponsesView[];
    systemQuestionOptions: SystemQuestionOption[];
  }

  export interface ResponseDeletedReason {
    /** @format int32 */
    id: number;
    name: string;
    textResponses: TextResponse[];
  }

  export interface ResponseSingleResult {
    queryable?: Response[] | null;
  }

  export interface ResponsesFilters {
    regionIds: number[];
    surveyIds?: number[] | null;
    questionOptionsIds?: number[] | null;
    filterIds?: number[] | null;
    testOptionIds?: number[] | null;
    standardQuestionIds?: number[] | null;
    excludeQuestionOptionsIds?: number[] | null;
    panelType?: PanelType;
    projectGroupSegmentIds?: number[] | null;
    /** @format date-time */
    dateFrom?: string | null;
    /** @format date-time */
    dateTo?: string | null;
  }

  export interface ResultMetadata {
    typename: "ResultMetadata";
    thinking: string;
    /** @format double */
    durationSeconds: number;
    followUpQuestions?: string[] | null;
  }

  export interface ResultsFile {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    key: string;
    /** @format int32 */
    s3FileId: number;
    /** @format date-time */
    createdAt: string;
    openAiFileId: string;
    project: Project;
    s3File: S3File;
  }

  export interface Role {
    label: string;
  }

  export interface Routing {
    /** @format int32 */
    id: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    projectQuestionId: number;
    projectQuestion: ProjectQuestion;
    projectQuestions: ProjectQuestion[];
    routingConditions: RoutingCondition[];
  }

  export interface RoutingCondition {
    /** @format int32 */
    id: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    routingId: number;
    comparator: string;
    precedingOperator: string;
    routing: Routing;
    questionOptions: QuestionOption[];
  }

  export interface RoutingConditionCreateDto {
    comparator: string;
    precedingOperator: string;
    optionIndexes: number[];
  }

  export interface RoutingCreateDto {
    projectQuestionIds: number[];
    routingConditions: RoutingConditionCreateDto[];
  }

  export interface RunAiBatchDto {
    /** @format int32 */
    promptVersionId: number;
  }

  export interface RunDecipherSimulatedDataDto {
    /** @format int32 */
    runCount: number;
  }

  export interface RunProjectAiEvaluationsJobResult {
    /** @format int32 */
    batchGroupId: number;
    /** @format int32 */
    projectsAiBatchGroupsId: number;
    batches: BatchInfo[];
    /** @format int32 */
    totalConversations: number;
    /** @format int32 */
    totalEvaluations: number;
  }

  export interface RunProjectFactsFindingsDto {
    /** @format int32 */
    regionId: number;
  }

  export interface RunPromptVersionDto {
    inputValues: Record<string, string>;
    /** @format int32 */
    requestKey: number;
  }

  export interface RunPromptVersionResponseDto {
    channel: ChannelInfoDto;
    /** @format int32 */
    aiConversationId: number;
  }

  export interface RunSyntheticSurveyDto {
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    sampleSize: number;
    /** @format int32 */
    promptVersionId?: number | null;
    notes: string;
    /** @format int32 */
    sourceProjectId?: number | null;
    /** @format int32 */
    sourceSurveyRunId?: number | null;
  }

  export interface RunWorkflowAiEvaluationsJobResult {
    batchGroupIds: number[];
    /** @format int32 */
    totalConversations: number;
    /** @format int32 */
    totalEvaluations: number;
  }

  export interface RuntimeFieldHandle {
    value: IntPtr;
  }

  export interface RuntimeMethodHandle {
    value: IntPtr;
  }

  export interface RuntimeTypeHandle {
    value: IntPtr;
  }

  export interface S3File {
    /** @format int32 */
    id: number;
    key: string;
    fileType: string;
    /** @format date-time */
    createdAt: string;
    metadata?: string | null;
    metadataSummary?: string | null;
    hasAudio?: boolean | null;
    thumbProcessed?: boolean | null;
    aiConversationS3File?: AiConversationS3File;
    aiHostedFiles: AiHostedFile[];
    clients: Client[];
    products: Product[];
    projectFiles: ProjectFile[];
    projectNarrativeVersionExports: ProjectNarrativeVersionExport[];
    questionOptions: QuestionOption[];
    questions: Question[];
    researchBuilderThreadFiles: ResearchBuilderThreadFile[];
    resultsFiles: ResultsFile[];
    surveyRun?: SurveyRun;
    testOptions: TestOption[];
    thumbnailS3Files: Thumbnail[];
    thumbnailThumbS3Files: Thumbnail[];
    userDataExports: UserDataExport[];
    thumbnails?: S3FilesThumbnailsView;
    signedUrl: string;
    fileName: string;
  }

  export interface S3FilesThumbnailsView {
    /** @format int32 */
    s3FileId?: number | null;
    fileType?: string | null;
    key?: string | null;
    metadata?: string | null;
    hasAudio?: boolean | null;
    thumbProcessed?: boolean | null;
    metadataSummary?: string | null;
    squareThumbnailFileType?: string | null;
    squareThumbnailKey?: string | null;
    /** @format int32 */
    squareThumbnailId?: number | null;
    ratioThumbnailFileType?: string | null;
    ratioThumbnailKey?: string | null;
    /** @format int32 */
    ratioThumbnailId?: number | null;
    s3File?: S3File;
    squareThumbnailSignedUrl?: string | null;
    ratioThumbnailSignedUrl?: string | null;
  }

  export interface SafeWaitHandle {
    isClosed: boolean;
    isInvalid: boolean;
  }

  export interface SampleIr {
    /** @format int32 */
    regionId?: number | null;
    sampleName?: string | null;
    sampleGroupId?: string | null;
    sampleGroupName?: string | null;
    /** @format double */
    ir?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    answerText?: string | null;
    /** @format int32 */
    id: number;
    region?: Region;
  }

  export interface SaveLogoRequest {
    key: string;
    contentType: string;
  }

  export interface ScheduleAdjustmentDto {
    /** @format double */
    creditAmount: number;
    /** @format int32 */
    creditLogTypeId?: number | null;
    description?: string | null;
    notes?: string | null;
  }

  export interface ScheduleInfo {
    /** @format date-time */
    scheduleDate: string;
    hasRan: boolean;
    /** @format int32 */
    runNumber: number;
    inCurrentPattern: boolean;
    /** @format double */
    creditsSpent?: number | null;
    surveyStatus?: SurveyStatusLookup;
    projectSchedules: ProjectSchedule[];
    surveyRunIds: number[];
  }

  export interface SchedulingState {
    /** @format int32 */
    projectId: number;
    /** @format date-time */
    scheduleStartDate?: string | null;
    status: SchedulingStateStatus;
    /** @format int32 */
    scheduleFrequencyWeeks?: number | null;
    /** @format int32 */
    scheduleWavesRequired?: number | null;
    /** @format date-time */
    schedulePaused?: string | null;
    schedules: ScheduleInfo[];
  }

  export type SchedulingStateStatus =
    | "None"
    | "LowCredits"
    | "Paused"
    | "PausedHasCredits"
    | "Running"
    | "Completed";

  export interface ScreenerQuestionOptionsResponsesView {
    /** @format int32 */
    responseId?: number | null;
    /** @format int32 */
    questionOptionId?: number | null;
    /** @format int32 */
    surveySessionId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    response?: Response;
    questionOption?: QuestionOption;
  }

  export interface ScreenerQuestionOptionsTextResponsesView {
    /** @format int32 */
    textResponseId?: number | null;
    /** @format int32 */
    questionOptionId?: number | null;
    /** @format int32 */
    surveySessionId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    textResponse?: TextResponse;
    questionOption?: QuestionOption;
  }

  export interface ScreenerQuestionWithCount {
    /** @format int32 */
    questionId: number;
    questionTitle: string;
    questionText: string;
    /** @format int32 */
    questionTypeId: number;
    s3FileType?: string | null;
    s3SignedUrl?: string | null;
    /** @format int32 */
    totalCount: number;
    /** @format float */
    totalWeight: number;
    /** @format int32 */
    targetedCount: number;
    options: ScreenerQuestionWithCountOptions[];
  }

  export interface ScreenerQuestionWithCountOptions {
    /** @format int32 */
    questionId: number;
    /** @format int32 */
    questionOptionId: number;
    optionText: string;
    /** @format int32 */
    responseCount: number;
    /** @format float */
    weight: number;
    isTarget: boolean;
  }

  export interface SearchClause {
    expression?: SingleValueNode;
  }

  export interface SearchQueryOption {
    context?: any;
    resultClrType?: Type;
    searchClause?: SearchClause;
    rawValue?: string | null;
  }

  export interface SectionUpdateMetadata {
    typename: "SectionUpdateMetadata";
    actionTaken: boolean;
    persistUntilActioned: boolean;
    actionOutcome?: string | null;
    updatedSection: PlanSection;
    /** The updated section using text as displayed within quill editor */
    updatedSectionContent: string;
    /** Very short summary of the update (max 5 words) */
    summary?: string | null;
    /**
     * Use markdown formatting. You can use <br> for line breaks. Short reasoning explaining why this section was updated.
     * AP style — no shorthand or abbreviations. For trivial changes, keep to one brief sentence or omit entirely.
     * Max 200 characters.
     */
    reasoning?: string | null;
  }

  export interface SectionUpdateResponse {
    /** Short summaries of each section update */
    summaries?: string[] | null;
    /**
     * Markdown-formatted conversational reasoning explaining the updates. You can use <br> for line breaks.
     * AP style — no shorthand or abbreviations. Structured formatting with short paragraphs or bullet points.
     * Max 200 characters.
     */
    reasoning?: string | null;
  }

  export type SecurityRuleSet = "None" | "Level1" | "Level2";

  export interface Segment {
    /** @format int32 */
    id: number;
    name: string;
    filters: string;
    /** @format int32 */
    projectId: number;
    /** @format date-time */
    createdAt: string;
    /** @format int32 */
    createdBy: number;
    /** @format int32 */
    clientId: number;
    aiProjectSummaries: AiProjectSummary[];
    client: Client;
    createdByNavigation: User;
    project: Project;
    projectFacts: ProjectFact[];
    responsesFilters?: SegmentResponsesFilters;
  }

  export interface SegmentCounts {
    /** @format int32 */
    surveySessionsCount: number;
    /** @format int32 */
    surveyRunsCount: number;
    /** @format double */
    totalWeight: number;
    /** @format int32 */
    segmentId: number;
    splitByValue: string;
  }

  export interface SegmentResponsesFilters {
    regionIds: number[];
    surveyIds?: number[] | null;
    questionOptionsIds?: number[] | null;
    filterIds?: number[] | null;
    testOptionIds?: number[] | null;
    standardQuestionIds?: number[] | null;
    excludeQuestionOptionsIds?: number[] | null;
    panelType?: PanelType;
    projectGroupSegmentIds?: number[] | null;
    /** @format date-time */
    dateFrom?: string | null;
    /** @format date-time */
    dateTo?: string | null;
  }

  export interface SegmentSingleResult {
    queryable?: Segment[] | null;
  }

  export interface SelectExpandClause {
    selectedItems?: SelectItem[] | null;
    allSelected: boolean;
  }

  export interface SelectExpandQueryOption {
    context?: any;
    rawSelect?: string | null;
    rawExpand?: string | null;
    compute?: ComputeQueryOption;
    validator?: ISelectExpandQueryValidator;
    selectExpandClause?: SelectExpandClause;
    /** @format int32 */
    levelsMaxLiteralExpansionDepth: number;
  }

  export type SelectItem = object;

  export interface SetAllUsagesResultDto {
    /** @format int32 */
    updatedWorkflowCount: number;
    /** @format int32 */
    documentVersionId: number;
  }

  export interface SetFeedbackAiMessageDto {
    feedbackPositive: boolean;
  }

  export interface SetOccasionNetsJobPayload {
    /** @format int32 */
    projectGroupId: number;
    occasionsToOccasionNets: Record<string, number | null>;
    occasionNetOptionLabels: Record<string, string>;
    occasionNetOptionDescriptions: Record<string, string>;
  }

  export interface ShareProjectDto {
    /** @format int32 */
    clientId: number;
  }

  export interface ShortThemeSummary {
    /** @format int32 */
    id: number;
    /** @format int32 */
    themeId: number;
    /** @format int32 */
    projectQuestionId: number;
    themeSummary: string;
    projectQuestion: ProjectQuestion;
    theme: Theme;
  }

  export interface SingleValueNode {
    typeReference?: any;
    kind: QueryNodeKind;
  }

  export interface SkipQueryOption {
    context?: any;
    rawValue?: string | null;
    /** @format int32 */
    value: number;
    validator?: ISkipQueryValidator;
  }

  export type SkipTokenHandler = object;

  export interface SkipTokenQueryOption {
    rawValue?: string | null;
    context?: any;
    validator?: ISkipTokenQueryValidator;
    handler?: SkipTokenHandler;
  }

  export interface StagedRespondentsCsvDto {
    stagingFileName: string;
  }

  export interface StandardQuestion {
    /** @format int32 */
    id: number;
    questionCode: string;
    questionLabel: string;
    /** @format int32 */
    questionTypeId: number;
    generateSummary: boolean;
    description?: string | null;
    /** @format int32 */
    sortOrder?: number | null;
    questionType: QuestionType;
    questions: Question[];
    regressionScores: RegressionScore[];
    responses: Response[];
    textResponses: TextResponse[];
    frameworks: Framework[];
  }

  export interface StandardQuestionSingleResult {
    queryable?: StandardQuestion[] | null;
  }

  export interface StartSurveyProcessingDto {
    /** @format int32 */
    projectId?: number | null;
    reset: boolean;
    surveyProcessingType: SurveyProcessingTypes;
  }

  export interface StringResolvedFieldDto {
    value?: string | null;
    sourceTier?: ClientSettingTier;
    sourceClientName?: string | null;
  }

  export interface StringStringKeyValuePair {
    key?: string | null;
    value?: string | null;
  }

  export interface StringStringValuesKeyValuePair {
    key?: string | null;
    value: string[];
  }

  export interface StructLayoutAttribute {
    typeId: any;
    value: LayoutKind;
  }

  export interface SummaryOutput {
    /** Summary generated by the agent */
    summaries: string[];
  }

  export interface SurveyCreateSettingsDto {
    hasRandomisedProjects: boolean;
    hasSharedScreeners: boolean;
    autoSplitSurveys: boolean;
    surveyPlatform: SurveyPlatformLookup;
  }

  export interface SurveyPlatform {
    /** @format int32 */
    id: number;
    name: string;
    surveyRuns: SurveyRun[];
  }

  export type SurveyPlatformLookup = "Decipher" | "ConsumerSurveyPlatform" | "Synthetic";

  export interface SurveyProcessing {
    /** @format int32 */
    id: number;
    /** @format int32 */
    surveyRunId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    startedAt?: string | null;
    /** @format date-time */
    completedAt?: string | null;
    success?: boolean | null;
    error?: string | null;
    weights: boolean;
    diagnoseScore: boolean;
    codeVerbatims: boolean;
    translateVerbatims: boolean;
    summaryConcepts: boolean;
    summaryQuestions: boolean;
    summaryDiagnose: boolean;
    link?: string | null;
    reset: boolean;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    surveyProcessingTypeId: number;
    project?: Project;
    projectSchedules: ProjectSchedule[];
    surveyProcessingType: SurveyProcessingType;
    surveyRun: SurveyRun;
    surveyProcessingTypeLookup: SurveyProcessingTypes;
  }

  export interface SurveyProcessingType {
    /** @format int32 */
    id: number;
    name: string;
    surveyProcessings: SurveyProcessing[];
  }

  export type SurveyProcessingTypes =
    | "ImportSurveyData"
    | "ProcessProjectData"
    | "GenerateProjectGroupSummaries";

  export interface SurveyRun {
    /** @format int32 */
    id: number;
    title?: string | null;
    externalId: string;
    /** @format int32 */
    regionId: number;
    weightedStatus: boolean;
    weightedScreenersCompletes: boolean;
    weightedIncremental: boolean;
    /** @format int32 */
    surveyStatusId: number;
    /** @format date-time */
    finishTime?: string | null;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format date-time */
    createdAt: string;
    samplifyId?: string | null;
    environment?: string | null;
    samplifyQuotaHistory?: string | null;
    hasRandomisedProjects?: boolean | null;
    /** @format int32 */
    s3FileId?: number | null;
    slackTs?: string | null;
    /** @format int32 */
    surveySampleProviderId: number;
    /** @format int32 */
    estimatedDuration?: number | null;
    hasSharedScreeners?: boolean | null;
    /** @format double */
    averageSurveyCompletionTime?: number | null;
    /** @format int32 */
    deletedBy?: number | null;
    cfTokenId?: string | null;
    /** @format int32 */
    surveyPlatformId: number;
    creditLogs: CreditLog[];
    deletedByNavigation?: User;
    projectSchedules: ProjectSchedule[];
    projectsAiBatchGroups: ProjectsAiBatchGroup[];
    region: Region;
    s3File?: S3File;
    surveyPlatform: SurveyPlatform;
    surveyProcessings: SurveyProcessing[];
    surveyRunRespondentsCsvEditThreads: SurveyRunRespondentsCsvEditThread[];
    surveySessions: SurveySession[];
    surveyStatus: SurveyStatus;
    syntheticProviderSetting?: SyntheticProviderSetting;
    systemQuestionsResponses: SystemQuestionsResponse[];
    projects: Project[];
    surveyStatusLookup: SurveyStatusLookup;
    sampleProvider: SurveySampleProviders;
    surveyPlatformLookup: SurveyPlatformLookup;
  }

  export interface SurveyRunRespondentsCsvEditThread {
    /** @format int32 */
    id: number;
    /** @format int32 */
    surveyRunId: number;
    /** @format int32 */
    aiThreadId: number;
    /** @format date-time */
    createdAt: string;
    aiThread: AiThread;
    surveyRun: SurveyRun;
  }

  export interface SurveyRunRespondentsCsvEditThreadSingleResult {
    queryable?: SurveyRunRespondentsCsvEditThread[] | null;
  }

  export interface SurveyRunSingleResult {
    queryable?: SurveyRun[] | null;
  }

  export interface SurveySampleProvider {
    /** @format int32 */
    id: number;
    name: string;
    projectSchedules: ProjectSchedule[];
  }

  export type SurveySampleProviders = "Samplify" | "CustomPanel" | "SimulatedData" | "SyntheticData";

  export interface SurveySession {
    /** @format int32 */
    id: number;
    externalId?: string | null;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    surveyRunId: number;
    /** @format double */
    weight: number;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format int32 */
    surveySessionDeletedReasonId?: number | null;
    psid?: string | null;
    /** @format int32 */
    surveySampleProviderId: number;
    aiConversations: AiConversation[];
    deletedByNavigation?: User;
    region: Region;
    responses: Response[];
    surveyRun: SurveyRun;
    surveySessionDeletedReason?: SurveySessionDeletedReason;
    surveySessionTestOptionOrders: SurveySessionTestOptionOrder[];
    systemQuestionsResponses: SystemQuestionsResponse[];
    textResponses: TextResponse[];
    projectGroupSegments: ProjectGroupSegment[];
    sampleProvider: SurveySampleProviders;
  }

  export interface SurveySessionDeletedReason {
    /** @format int32 */
    id: number;
    name: string;
    surveySessions: SurveySession[];
  }

  export interface SurveySessionSingleResult {
    queryable?: SurveySession[] | null;
  }

  export interface SurveySessionTestOptionOrder {
    /** @format int32 */
    id: number;
    /** @format int32 */
    surveySessionId: number;
    /** @format int32 */
    testOptionId: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    surveyOrder: number;
    project: Project;
    surveySession: SurveySession;
    testOption: TestOption;
  }

  export interface SurveyStatus {
    /** @format int32 */
    id: number;
    status?: string | null;
    surveyRuns: SurveyRun[];
  }

  export type SurveyStatusLookup =
    | "draft"
    | "testing"
    | "live"
    | "closed"
    | "dev"
    | "errorXml"
    | "errorProcessing";

  export interface SyncProjectScheduleDto {
    /** @format int32 */
    projectId: number;
    /** @format date-time */
    launchDate?: string | null;
    scheduleDates?: string[] | null;
    scheduleWeeks?: number[] | null;
    regionIds?: number[] | null;
    incidentEstimates?: Record<string, number | null>;
  }

  export interface SynthAssignProjectToGroupDto {
    /** @format int32 */
    projectGroupId: number;
  }

  export interface SyntheticProviderSetting {
    /** @format int32 */
    id: number;
    /** @format int32 */
    surveyRunId: number;
    /** @format int32 */
    sampleSize: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt?: string | null;
    /** @format int32 */
    promptVersionId?: number | null;
    notes?: string | null;
    /** @format int32 */
    sourceProjectId?: number | null;
    /** @format int32 */
    sourceSurveyRunId?: number | null;
    promptVersion?: PromptVersion;
    sourceProject?: Project;
    sourceSurveyRun?: SurveyRun;
    surveyRun: SurveyRun;
  }

  export interface SyntheticSurveyWorkflowDto {
    agents: AgentDto[];
    useCodeInterpreter: boolean;
    useImageMetadataOnAICall: boolean;
    includeDemandLandscapeQuestions: boolean;
    typename: "SyntheticSurveyWorkflowDto";
  }

  export interface SystemQuestion {
    /** @format int32 */
    id: number;
    questionCode: string;
    questionLabel?: string | null;
    generateSummary: boolean;
    isFilterable: boolean;
    isScreener: boolean;
    /** @format int32 */
    questionTypeId: number;
    questionText?: string | null;
    /** @format int32 */
    questionTextTranslatedTextId?: number | null;
    questionTextTranslatedText?: TranslatedText;
    questionType: QuestionType;
    systemQuestionOptions: SystemQuestionOption[];
    questionCodeLookup: FilterQuestionType;
  }

  export interface SystemQuestionOption {
    /** @format int32 */
    id: number;
    externalId?: string | null;
    /** @format int32 */
    legacyId?: number | null;
    answerLabel?: string | null;
    /** @format int32 */
    answerValue: number;
    /** @format double */
    ir?: number | null;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    systemQuestionId: number;
    isVisible: boolean;
    calculatedValue?: string | null;
    optionText?: string | null;
    /** @format double */
    weight?: number | null;
    filterSubtext?: string | null;
    /** @format int32 */
    optionTextTranslatedTextId?: number | null;
    incidenceRates: IncidenceRate[];
    optionTextTranslatedText?: TranslatedText;
    projectFacts: ProjectFact[];
    region?: Region;
    systemQuestion: SystemQuestion;
    systemQuestionOptionWeights: SystemQuestionOptionWeight[];
    systemQuestionsResponses: SystemQuestionsResponse[];
    targets: Target[];
    sourceSystemQuestionOptions: SystemQuestionOption[];
    targetSystemQuestionOptions: SystemQuestionOption[];
    systemQuestionOptionsResponses: SystemQuestionOptionsResponsesView[];
    systemQuestionOptionsTextResponses: SystemQuestionOptionsTextResponsesView[];
    projectsSystemQuestionOptions: ProjectsSystemQuestionOptionsView[];
    responses: Response[];
    textResponses: TextResponse[];
  }

  export interface SystemQuestionOptionSingleResult {
    queryable?: SystemQuestionOption[] | null;
  }

  export interface SystemQuestionOptionWeight {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    systemQuestionOptionId: number;
    /** @format double */
    weight: number;
    region: Region;
    systemQuestionOption: SystemQuestionOption;
  }

  export interface SystemQuestionOptionsResponsesView {
    /** @format int32 */
    responseId?: number | null;
    /** @format int32 */
    systemQuestionOptionId?: number | null;
    response?: Response;
    systemQuestionOption?: SystemQuestionOption;
  }

  export interface SystemQuestionOptionsTextResponsesView {
    /** @format int32 */
    textResponseId?: number | null;
    /** @format int32 */
    systemQuestionOptionId?: number | null;
    textResponse?: TextResponse;
    systemQuestionOption?: SystemQuestionOption;
  }

  export interface SystemQuestionSingleResult {
    queryable?: SystemQuestion[] | null;
  }

  export interface SystemQuestionsResponse {
    /** @format int32 */
    id: number;
    /** @format int32 */
    surveySessionId: number;
    /** @format int32 */
    systemQuestionOptionId: number;
    /** @format int32 */
    surveyRunId: number;
    surveyRun: SurveyRun;
    surveySession: SurveySession;
    systemQuestionOption: SystemQuestionOption;
  }

  export interface Target {
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    questionOptionId?: number | null;
    questionCode?: string | null;
    /** @format int32 */
    answerValue?: number | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    systemQuestionOptionId?: number | null;
    targetMode?: boolean | null;
    project?: Project;
    question?: Question;
    questionOption?: QuestionOption;
    region?: Region;
    systemQuestionOption?: SystemQuestionOption;
    questionCodes?: FilterQuestionType;
  }

  export interface TargetSingleResult {
    queryable?: Target[] | null;
  }

  export interface Team {
    /** @format int32 */
    id: number;
    /** @format int32 */
    orgId?: number | null;
    parentPays: boolean;
    requireApprovals: boolean;
    teamAdminsCanApprove: boolean;
    amaThreads: AmaThread[];
    client?: Client;
    creditLogs: CreditLog[];
    org?: Org;
    projectGroupSegments: ProjectGroupSegment[];
    projectGroups: ProjectGroup[];
    projectShares: ProjectShare[];
    projects: Project[];
    researchBuilderThreads: ResearchBuilderThread[];
  }

  export interface TeamSingleResult {
    queryable?: Team[] | null;
  }

  export interface TestGroupPerformanceSummaryOutput {
    attractiveGroup: string;
    top2BoxScores: string;
    percentages: string;
    topThemes: number[];
    dislikes: number[];
  }

  export interface TestOption {
    /** @format int32 */
    projectId: number;
    conceptText?: string | null;
    conceptDescription?: string | null;
    conceptProblem?: string | null;
    conceptBenefits?: string | null;
    conceptAvailability?: string | null;
    conceptBrand?: string | null;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    /** @format int32 */
    sort?: number | null;
    decipherAssetId?: string | null;
    /** @format int32 */
    s3FileId?: number | null;
    /** @format int32 */
    conceptDescriptionTranslatedTextId?: number | null;
    /** @format int32 */
    testOptionCellId?: number | null;
    hasOccasionsQuestion: boolean;
    /** @format int32 */
    conceptBrandTranslatedTextId?: number | null;
    /** @format int32 */
    productId?: number | null;
    aiProjectSummaries: AiProjectSummary[];
    conceptBrandTranslatedText?: TranslatedText;
    conceptDescriptionTranslatedText?: TranslatedText;
    marketReachesTestOptions: MarketReachesTestOption[];
    project: Project;
    projectFacts: ProjectFact[];
    projectQuestions: ProjectQuestion[];
    regressionScores: RegressionScore[];
    responses: Response[];
    s3File?: S3File;
    surveySessionTestOptionOrders: SurveySessionTestOptionOrder[];
    testOptionCell?: TestOptionCell;
    textResponses: TextResponse[];
    projectPriceSensitivities: ProjectPriceSensitivity[];
  }

  export interface TestOptionCell {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    numTestOptionsShown?: number | null;
    project: Project;
    testOptions: TestOption[];
  }

  export interface TestOptionDto {
    /** @format int32 */
    projectId?: number | null;
    conceptText?: string | null;
    conceptDescription?: string | null;
    conceptProblem?: string | null;
    conceptBenefits?: string | null;
    conceptAvailability?: string | null;
    conceptBrand?: string | null;
    /** @format uuid */
    uuid?: string | null;
    /** @format date-time */
    createdAt?: string | null;
    /** @format date-time */
    updatedAt?: string | null;
    /** @format int32 */
    id: number;
    /** @format int32 */
    sort?: number | null;
    decipherAssetId?: string | null;
    /** @format int32 */
    testOptionCellId?: number | null;
    hasOccasionsQuestion: boolean;
    project?: Project;
    s3File?: S3File;
    responses: Response[];
    textResponses: TextResponse[];
    testOptionCell?: TestOptionCell;
  }

  export interface TestOptionDtoETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface TestOptionEditDto {
    /** @format int32 */
    projectId?: number | null;
    conceptText: string;
    conceptDescription?: string | null;
    conceptBrand?: string | null;
    file?: TestOptionFileDto;
    /** @format int32 */
    sort?: number | null;
    deleteFile: boolean;
    testMarketReach: boolean;
    testPricingSensitivity: boolean;
    hasOccasionsQuestion: boolean;
  }

  export interface TestOptionFileDto {
    key: string;
    contentType: string;
  }

  export interface TestOptionSingleResult {
    queryable?: TestOption[] | null;
  }

  export interface TextContent {
    mimeType?: string | null;
    modelId?: string | null;
    metadata?: Record<string, any>;
    typename: "TextContent";
    text?: string | null;
  }

  export interface TextResponse {
    /** @format int32 */
    id: number;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    surveySessionId: number;
    /** @format double */
    weight: number;
    answerText?: string | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    externalResponseId: string;
    /** @format date-time */
    deletedAt?: string | null;
    /** @format date-time */
    respondedAt: string;
    /** @format date-time */
    themedAt?: string | null;
    /** @format int32 */
    standardQuestionId?: number | null;
    /** @format int32 */
    responseDeletedReasonId?: number | null;
    answerTextRaw?: string | null;
    /** @format int32 */
    projectQuestionId?: number | null;
    /** @format int32 */
    deletedBy?: number | null;
    /** @format date-time */
    qaProcessedAt?: string | null;
    deletedByNavigation?: User;
    project: Project;
    projectQuestion?: ProjectQuestion;
    question?: Question;
    region: Region;
    responseDeletedReason?: ResponseDeletedReason;
    standardQuestion?: StandardQuestion;
    surveySession: SurveySession;
    testOption?: TestOption;
    textResponsesThemes: TextResponsesTheme[];
    themes: Theme[];
    screenerQuestionOptionsTextResponses: ScreenerQuestionOptionsTextResponsesView[];
    systemQuestionOptionsTextResponses: SystemQuestionOptionsTextResponsesView[];
    systemQuestionOptions: SystemQuestionOption[];
  }

  export interface TextResponseSingleResult {
    queryable?: TextResponse[] | null;
  }

  export interface TextResponsesFilters {
    regionIds: number[];
    surveyIds?: number[] | null;
    questionOptionsIds?: number[] | null;
    filterIds?: number[] | null;
    testOptionIds?: number[] | null;
    standardQuestionIds?: number[] | null;
    excludeQuestionOptionsIds?: number[] | null;
    panelType?: PanelType;
    projectGroupSegmentIds?: number[] | null;
    /** @format date-time */
    dateFrom?: string | null;
    /** @format date-time */
    dateTo?: string | null;
    /** @format int32 */
    questionId?: number | null;
    /** @format int32 */
    sortByStandardQuestionId?: number | null;
    themeIds?: number[] | null;
    search?: string | null;
    sortDesc?: boolean | null;
    sentimentScores?: number[] | null;
    /** @format int32 */
    questionPositionId?: number | null;
  }

  export interface TextResponsesTheme {
    /** @format int32 */
    id: number;
    /** @format int32 */
    projectId: number;
    /** @format int32 */
    textResponsesId: number;
    /** @format int32 */
    themeId: number;
    project: Project;
    textResponses: TextResponse;
    theme: Theme;
  }

  export interface TextResponsesThemeSingleResult {
    queryable?: TextResponsesTheme[] | null;
  }

  export interface Theme {
    /** @format int32 */
    id: number;
    themeLabel: string;
    shortLabel?: string | null;
    aiProjectSummaries: AiProjectSummary[];
    regressionScores: RegressionScore[];
    shortThemeSummaries: ShortThemeSummary[];
    textResponsesThemes: TextResponsesTheme[];
    themeSentiments: ThemeSentiment[];
    textResponses: TextResponse[];
  }

  export interface ThemeResultFactMetadata {
    typename: "ThemeResultFactMetadata";
    /**
     * The theme ID this fact is derived from
     * @format int32
     */
    themeId: number;
    /**
     * The project question ID (text question) this theme appeared in
     * @format int32
     */
    projectQuestionId: number;
    /**
     * The percentage of respondents who mentioned this theme
     * @format double
     */
    percentage: number;
    /**
     * Theme sentiment: -1 = negative, 0 = neutral, 1 = positive
     * @format int32
     */
    sentimentScore?: number | null;
    vsTotal?: VsTotalComparison;
  }

  export interface ThemeSentiment {
    /** @format int32 */
    id: number;
    /** @format int32 */
    themeId: number;
    /** @format int32 */
    sentimentScore: number;
    /** @format int32 */
    projectQuestionId: number;
    /** @format int32 */
    regionId?: number | null;
    summaryLong?: string | null;
    summaryShort?: string | null;
    /** @format int32 */
    themeSentimentGroupId?: number | null;
    projectQuestion: ProjectQuestion;
    region?: Region;
    theme: Theme;
    themeSentimentGroup?: ThemeSentimentGroup;
  }

  export interface ThemeSentimentGroup {
    /** @format int32 */
    id: number;
    name: string;
    themeSentiments: ThemeSentiment[];
  }

  export interface ThemeSentimentSingleResult {
    queryable?: ThemeSentiment[] | null;
  }

  export interface ThemeSingleResult {
    queryable?: Theme[] | null;
  }

  export interface Thumbnail {
    /** @format int32 */
    id: number;
    /** @format int32 */
    s3FileId: number;
    /** @format int32 */
    thumbS3FileId: number;
    /** @format int32 */
    thumbnailTypeId: number;
    s3File: S3File;
    thumbS3File: S3File;
    thumbnailType: ThumbnailType;
  }

  export interface ThumbnailType {
    /** @format int32 */
    id: number;
    name: string;
    thumbnails: Thumbnail[];
  }

  export interface TopQueryOption {
    context?: any;
    rawValue?: string | null;
    /** @format int32 */
    value: number;
    validator?: ITopQueryValidator;
  }

  export interface TransformationNode {
    kind: TransformationNodeKind;
  }

  export type TransformationNodeKind = "Aggregate" | "GroupBy" | "Filter" | "Compute" | "Expand";

  export type TranslatableEntityTypes =
    | "ProjectCategory"
    | "ProjectBrand"
    | "ProjectConceptIntro"
    | "QuestionText"
    | "QuestionOptionText"
    | "TestOptionDescription"
    | "DemographicQuestionText"
    | "DemographicQuestionOptionText"
    | "ConceptBrand";

  export interface TranslatedText {
    /** @format int32 */
    id: number;
    projectBrandTranslatedTexts: Project[];
    projectCategoryTranslatedTexts: Project[];
    projectConceptIntroTranslatedTexts: Project[];
    questionOptions: QuestionOption[];
    questions: Question[];
    systemQuestionOptions: SystemQuestionOption[];
    systemQuestions: SystemQuestion[];
    testOptionConceptBrandTranslatedTexts: TestOption[];
    testOptionConceptDescriptionTranslatedTexts: TestOption[];
    translatedTextRegions: TranslatedTextRegion[];
  }

  export interface TranslatedTextRegion {
    /** @format int32 */
    id: number;
    translation: string;
    /** @format int32 */
    regionId: number;
    /** @format int32 */
    translatedTextId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    region: Region;
    translatedText: TranslatedText;
  }

  export interface TranslatedTextRegionSingleResult {
    queryable?: TranslatedTextRegion[] | null;
  }

  export interface TrialClientSetupResponseDto {
    /** @format int32 */
    teamId: number;
    /** @format int32 */
    projectId?: number | null;
    orgName: string | null;
    teamName: string | null;
  }

  export interface Type {
    name: string;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    memberType: MemberTypes;
    namespace?: string | null;
    assemblyQualifiedName?: string | null;
    fullName?: string | null;
    assembly: Assembly;
    module: Module;
    isInterface: boolean;
    isNested: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    isFunctionPointer: boolean;
    isUnmanagedFunctionPointer: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[];
    /** @format int32 */
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    /** @format uuid */
    guid: string;
    baseType?: Type;
    /** @deprecated */
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
  }

  export type TypeAttributes =
    | "NotPublic"
    | "Public"
    | "NestedPublic"
    | "NestedPrivate"
    | "NestedFamily"
    | "NestedAssembly"
    | "NestedFamANDAssem"
    | "VisibilityMask"
    | "SequentialLayout"
    | "ExplicitLayout"
    | "LayoutMask"
    | "Interface"
    | "Abstract"
    | "Sealed"
    | "SpecialName"
    | "RTSpecialName"
    | "Import"
    | "Serializable"
    | "WindowsRuntime"
    | "UnicodeClass"
    | "AutoClass"
    | "StringFormatMask"
    | "HasSecurity"
    | "ReservedMask"
    | "BeforeFieldInit"
    | "CustomFormatMask";

  export interface TypeInfo {
    name: string;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    /** @format int32 */
    metadataToken: number;
    memberType: MemberTypes;
    namespace?: string | null;
    assemblyQualifiedName?: string | null;
    fullName?: string | null;
    assembly: Assembly;
    module: Module;
    isInterface: boolean;
    isNested: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    isFunctionPointer: boolean;
    isUnmanagedFunctionPointer: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[];
    /** @format int32 */
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    /** @format uuid */
    guid: string;
    baseType?: Type;
    /** @deprecated */
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
    genericTypeParameters: Type[];
    declaredConstructors: ConstructorInfo[];
    declaredEvents: EventInfo[];
    declaredFields: FieldInfo[];
    declaredMembers: MemberInfo[];
    declaredMethods: MethodInfo[];
    declaredNestedTypes: TypeInfo[];
    declaredProperties: PropertyInfo[];
    implementedInterfaces: Type[];
  }

  export interface TypeObjectKeyValuePair {
    key?: Type;
    value?: any;
  }

  export interface UAndAType {
    /** @format int32 */
    id: number;
    title?: string | null;
    isCore: boolean;
    projectGroupsQuestions: ProjectGroupsQuestion[];
  }

  export interface UAndATypeSingleResult {
    queryable?: UAndAType[] | null;
  }

  export interface UpdateAiBatchDto {
    name?: string | null;
  }

  export interface UpdateAiModelDefinitionDto {
    name: string;
    modelId: string;
    isFoundational: boolean;
    /** @format int32 */
    maxOutputTokens: number;
    isDeprecated: boolean;
    /** @format int32 */
    aiProviderId: number;
    reasoningOptions?: number[] | null;
    pricing?: number[] | null;
    aiServicesIds: number[];
  }

  export interface UpdateAmaThreadDto {
    name?: string | null;
  }

  export interface UpdateAutoProjectWatchDto {
    enableAutoProjectWatch: boolean;
    /** @format int32 */
    userId: number;
  }

  export interface UpdateClientDto {
    ssoEnabled?: boolean | null;
    domain?: string | null;
    /** @format int32 */
    aiProviderOverrideId?: number | null;
    brandGuideMd?: string | null;
    /** @format int32 */
    documentPlatformId?: number | null;
    /** @format int32 */
    logoS3FileId?: number | null;
  }

  export interface UpdateCreditLogDto {
    /** @format double */
    creditAmount: number;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    creditLogTypeId?: number | null;
    description?: string | null;
    notes?: string | null;
    /** @format date-time */
    transactionTimestamp?: string | null;
  }

  export interface UpdateFeatureFlagDto {
    isEnabled?: boolean | null;
    isDeprecated?: boolean | null;
    description?: string | null;
  }

  export interface UpdateGroupTagsDto {
    projectGroupTagIds: number[];
  }

  export interface UpdateMarketReachDto {
    /** @format int32 */
    maxOptionsSelect?: number | null;
  }

  export interface UpdateOrgDto {
    isOverdueAccount: boolean;
  }

  export interface UpdatePreSelectedFrameworkDto {
    /** @format int32 */
    frameworkId: number;
  }

  export interface UpdateProjectGroupQuestionDto {
    /** @format int32 */
    regionId?: number | null;
    routedQuestionOptionIds?: number[] | null;
  }

  export interface UpdateProjectIncidenceEstimateDto {
    regionIds: number[];
  }

  export interface UpdateProjectOwnerDto {
    /** @format int32 */
    teamId: number;
  }

  export interface UpdateProjectPriceSensitivitiesDto {
    /** @format int32 */
    regionId: number;
    /** @format double */
    highPrice?: number | null;
    /** @format double */
    lowPrice?: number | null;
    exampleProducts?: string | null;
    /** @format double */
    typicalPrice?: number | null;
  }

  export interface UpdateProjectRegionsDto {
    regionIds: number[];
  }

  export interface UpdateProjectScheduleDto {
    /** @format date-time */
    scheduleDate?: string | null;
    /** @format int32 */
    regionId?: number | null;
    isCustomerPanel?: boolean | null;
    /** @format int32 */
    sampleSize?: number | null;
    isStandby?: boolean | null;
    /** @format double */
    incidenceEstimate?: number | null;
  }

  export interface UpdateProjectSchedulingDto {
    /** @format int32 */
    scheduleWavesRequired?: number | null;
    /** @format date-time */
    scheduleStartDate?: string | null;
    /** @format int32 */
    scheduleFrequencyWeeks?: number | null;
    customScheduleDates?: string[] | null;
  }

  export interface UpdateProjectTargetsDto {
    projectDemographicIds: number[];
    questionCode: string;
    syncPriceSensitivities: boolean;
    /** @format int32 */
    regionId?: number | null;
    /** @format int32 */
    regionIdToReplace?: number | null;
    /** @format int32 */
    runCount: number;
    hasCustomerPanel?: boolean | null;
    /** @format int32 */
    sampleSize?: number | null;
    customScheduleDates?: string[] | null;
  }

  export interface UpdateProjectWatchersDto {
    userAndClientIds: number[];
    /** @format int32 */
    teamId: number;
  }

  export interface UpdatePromptDto {
    description?: string | null;
    /** @format int32 */
    regressionBatchId?: number | null;
  }

  export interface UpdatePromptEvaluationDto {
    name?: string | null;
    definition?: string | null;
    ratingDefinitions?: string | null;
    additionalInstructions?: string | null;
  }

  export interface UpdateResearchBuilderThreadDto {
    name?: string | null;
  }

  export interface UpdateRespondentsCsvProposalDto {
    referenceId: string;
    stagingFileName: string;
  }

  export interface UpdateRespondentsCsvProposalResultDto {
    referenceId: string;
  }

  export interface UpdateSamlCognitoIdpDto {
    name?: string | null;
    metadataUrl?: string | null;
    metadataXml?: string | null;
    /** @format int32 */
    defaultRoleId?: number | null;
  }

  export interface UpdateTeamDto {
    requireApprovals?: boolean | null;
    teamAdminsCanApprove?: boolean | null;
    parentPays?: boolean | null;
  }

  export interface UpdateTranslatedTextRegionDto {
    translation: string;
  }

  export type UsageContextDimension = "Occasion" | "Time" | "Location" | "Other";

  export interface UsageContextMetadata {
    typename: "UsageContextMetadata";
    contextDimension: UsageContextDimension;
  }

  export interface User {
    userName?: string | null;
    email: string;
    /** @format uuid */
    awsCognitoId?: string | null;
    /** @format int32 */
    roleId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    active?: boolean | null;
    termsAccepted?: boolean | null;
    /** @format int32 */
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    /** @format int32 */
    hubspotRoleId?: number | null;
    /** @format int32 */
    researchInterpretationConfidence?: number | null;
    /** @format int32 */
    researchSetupConfidence?: number | null;
    aiBatchRunCreatedByNavigations: AiBatchRun[];
    aiBatchRunDeletedByNavigations: AiBatchRun[];
    aiBatches: AiBatch[];
    aiConversations: AiConversation[];
    aiMessages: AiMessage[];
    aiProjectGroupSummaryDeletedByNavigations: AiProjectGroupSummary[];
    aiProjectGroupSummaryUsers: AiProjectGroupSummary[];
    aiProjectSummaryDeletedByNavigations: AiProjectSummary[];
    aiProjectSummaryUsers: AiProjectSummary[];
    aiThreads: AiThread[];
    apiKeys: ApiKey[];
    clientQuestionTemplateCreatedByNavigations: ClientQuestionTemplate[];
    clientQuestionTemplateDeletedByNavigations: ClientQuestionTemplate[];
    cognitoUsers: CognitoUser[];
    creditLogCreatedBies: CreditLog[];
    creditLogDeletedByNavigations: CreditLog[];
    dataEventsLogs: DataEventsLog[];
    documentVersions: DocumentVersion[];
    documents: Document[];
    hubspotCompanyCompanyOwnerNavigations: HubspotCompany[];
    hubspotCompanyCsmNavigations: HubspotCompany[];
    hubspotCompanyLeadResearcherNavigations: HubspotCompany[];
    hubspotRole?: HubspotRole;
    linkInvites: LinkInvite[];
    notifications: Notification[];
    products: Product[];
    projectCommentCreatedByNavigations: ProjectComment[];
    projectCommentDeletedByNavigations: ProjectComment[];
    projectCommentDismissedByNavigations: ProjectComment[];
    projectCreatedByNavigations: Project[];
    projectDeletedByNavigations: Project[];
    projectEmailSummaries: ProjectEmailSummary[];
    projectFiles: ProjectFile[];
    projectGroupCreatedByNavigations: ProjectGroup[];
    projectGroupDeletedByNavigations: ProjectGroup[];
    projectGroupProductCreatedByNavigations: ProjectGroupProduct[];
    projectGroupProductDeletedByNavigations: ProjectGroupProduct[];
    projectGroupSegments: ProjectGroupSegment[];
    projectLogs: ProjectLog[];
    projectNarrativeVersions: ProjectNarrativeVersion[];
    projectNarratives: ProjectNarrative[];
    projectObjectiveDeletedByNavigations: ProjectObjective[];
    projectObjectiveUsers: ProjectObjective[];
    projectSchedules: ProjectSchedule[];
    projectSubmittedByNavigations: Project[];
    projectWatcherCreatedByNavigations: ProjectWatcher[];
    projectWatcherDeletedByNavigations: ProjectWatcher[];
    promptVersionCreatedByNavigations: PromptVersion[];
    promptVersionDeletedByNavigations: PromptVersion[];
    promptVersionPublishedByNavigations: PromptVersion[];
    promptVersionUpdatedByNavigations: PromptVersion[];
    prompts: Prompt[];
    questions: Question[];
    researchBuilderThreadFiles: ResearchBuilderThreadFile[];
    role: UserRole;
    segments: Segment[];
    surveyRuns: SurveyRun[];
    surveySessions: SurveySession[];
    textResponses: TextResponse[];
    userAndClients: UserAndClient[];
    userDataExports: UserDataExport[];
    userInviteInvitedByNavigations: UserInvite[];
    userInviteUsers: UserInvite[];
    displayName: string;
    initials: string;
    curRole: UserRoleEnum;
    isIdeallyAdmin: boolean;
  }

  export interface UserAndClient {
    /** @format int32 */
    clientId: number;
    /** @format int32 */
    roleId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    /** @format int32 */
    userId: number;
    excludedAutoTeamWatches: number[];
    client: Client;
    projectWatchers: ProjectWatcher[];
    role: UserClientRole;
    user: User;
  }

  export interface UserAndClientSingleResult {
    queryable?: UserAndClient[] | null;
  }

  export interface UserAndClientsDto {
    /** @format int32 */
    roleId: number;
  }

  export interface UserChangeHubspotRoleDto {
    /** @format int32 */
    hubspotRoleId: number;
  }

  export interface UserChangeNameDto {
    firstName: string | null;
    lastName: string | null;
  }

  export interface UserChangePasswordDto {
    oldPassword: string;
    newPassword: string;
  }

  export interface UserChangeResearchInterpretationConfidenceDto {
    /**
     * @format int32
     * @min 1
     * @max 5
     */
    researchInterpretationConfidence: number;
  }

  export interface UserChangeResearchSetupConfidenceDto {
    /**
     * @format int32
     * @min 1
     * @max 5
     */
    researchSetupConfidence: number;
  }

  export interface UserClientRole {
    /** @format int32 */
    id: number;
    roleName: string;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    clients: Client[];
    userAndClients: UserAndClient[];
  }

  export interface UserClientRoleSingleResult {
    queryable?: UserClientRole[] | null;
  }

  export interface UserCreateDto {
    email: string;
    clients: Record<string, UserAndClientsDto>;
    redirectUri?: string | null;
  }

  export interface UserDataExport {
    /** @format int32 */
    id: number;
    /** @format int32 */
    s3FileId: number;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int32 */
    exportedBy: number;
    filters?: string | null;
    exportedByNavigation: User;
    project?: Project;
    projectGroup?: ProjectGroup;
    s3File: S3File;
  }

  export interface UserDataExportDto {
    /** @format int32 */
    id: number;
    /** @format int32 */
    s3FileId: number;
    /** @format int32 */
    projectId?: number | null;
    /** @format int32 */
    projectGroupId?: number | null;
    /** @format int32 */
    exportedBy: number;
    filters?: string | null;
    filtersMapped?: ResponsesFilters;
    exportedByNavigation: User;
    project?: Project;
    projectGroup?: ProjectGroup;
    s3File: S3File;
  }

  export interface UserDataExportDtoETag {
    isWellFormed: boolean;
    entityType?: Type;
    isAny: boolean;
    isIfNoneMatch: boolean;
  }

  export interface UserDto {
    firstName?: string | null;
    lastName?: string | null;
  }

  export interface UserInvite {
    /** @format int32 */
    id: number;
    /** @format int32 */
    userId: number;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    acceptedAt?: string | null;
    /** @format int32 */
    invitedBy: number;
    /** @format date-time */
    expiresAt?: string | null;
    invitedByNavigation: User;
    user: User;
  }

  export interface UserInviteDto {
    /** @format int32 */
    id: number;
    /** @format date-time */
    acceptedAt: string | null;
    /** @format date-time */
    exipresAt: string | null;
  }

  export interface UserRole {
    roleName?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    /** @format int32 */
    id: number;
    users: User[];
  }

  export type UserRoleEnum = "SuperAdmin" | "Research" | "Sales" | "Viewer" | "User";

  export interface UserRoleSingleResult {
    queryable?: UserRole[] | null;
  }

  export interface UserSingleResult {
    queryable?: User[] | null;
  }

  export interface UserUpdateDto {
    clients: Record<string, UserAndClientsDto>;
  }

  export interface ValidateStagedRespondentsCsvResultDto {
    valid: boolean;
    error?: string | null;
    /** @format int32 */
    rowCount: number;
  }

  export interface Verbatim {
    /** @format int32 */
    id: number;
    answerText: string;
    /** @format float */
    weight?: number | null;
    /** @format int32 */
    standardQuestionId: number | null;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format int32 */
    surveySessionId?: number | null;
    themes: VerbatimTheme[];
    systemQuestionOptions: VerbatimSystemQuestionOption[];
  }

  export interface VerbatimCount {
    /** @format int32 */
    count: number;
  }

  export interface VerbatimShort {
    /** @format int32 */
    id: number;
    answerText: string;
    ageAndGender?: string | null;
    gender?: string | null;
    ageRange?: string | null;
    /** @format int32 */
    testOptionId?: number | null;
  }

  export interface VerbatimSystemQuestionOption {
    /** @format int32 */
    systemQuestionId: number;
    /** @format int32 */
    regionId: number;
    answerLabel: string;
  }

  export interface VerbatimTheme {
    /** @format int32 */
    id?: number | null;
    themeLabel: string | null;
    /** @format int32 */
    sentimentScore?: number | null;
    themeGroupName?: string | null;
    /** @format int32 */
    themeGroupId?: number | null;
  }

  export interface VerifyRegistrationResult {
    session: string;
    hasExistingDemoCompany: boolean;
  }

  export interface VsTotalComparison {
    /** @format double */
    totalPercentage: number;
    /** @format int32 */
    totalSampleSize: number;
    /**
     * Percentage point difference vs the unfiltered total result (positive = above total)
     * @format double
     */
    diff: number;
    /** Whether the difference from the total is statistically significant (binomial test, p < 0.05) */
    isStatSig: boolean;
  }

  export interface WaitHandle {
    handle: IntPtr;
    safeWaitHandle: SafeWaitHandle;
  }

  export interface WaveDataResult {
    /** @format int32 */
    id: number;
    answerText?: string | null;
    /** @format int32 */
    projectId: number;
    /** @format double */
    sumWeight: number;
    /** @format date-time */
    respondedAt: string;
    /** @format int32 */
    count: number;
    /** @format int32 */
    standardQuestionId?: number | null;
  }

  export interface WaveDataWeightSum {
    /** @format double */
    weight: number;
    /** @format int32 */
    responsesTotal: number;
    /** @format int32 */
    testOptionId?: number | null;
    /** @format date-time */
    respondedAt: string;
  }

  export interface WebSocketManager {
    isWebSocketRequest: boolean;
    webSocketRequestedProtocols: string[];
  }

  export interface WeightSum {
    /** @format double */
    weight: number;
    /** @format int32 */
    responsesTotal: number;
    /** @format int32 */
    testOptionId?: number | null;
  }

  export interface WorkflowDto {
    agents: AgentDto[];
    useCodeInterpreter: boolean;
    typename: "WorkflowDto";
  }

  export interface WorkflowInfoDto {
    workflowDiagram: string;
    agentExecutors: AgentExecutorInfoDto[];
  }

  export interface WorkflowRunDto {
    runId: string;
    agentExecutions: AgentExecutionDto[];
  }

  export interface X500DistinguishedName {
    oid?: Oid;
    /** @format byte */
    rawData: string;
    name: string;
  }

  export interface X509Certificate2 {
    handle: IntPtr;
    issuer: string;
    subject: string;
    serialNumberBytes: ByteReadOnlyMemory;
    archived: boolean;
    extensions: X509Extension[];
    friendlyName: string;
    hasPrivateKey: boolean;
    privateKey?: AsymmetricAlgorithm;
    issuerName: X500DistinguishedName;
    /** @format date-time */
    notAfter: string;
    /** @format date-time */
    notBefore: string;
    publicKey: PublicKey;
    /** @format byte */
    rawData: string;
    rawDataMemory: ByteReadOnlyMemory;
    serialNumber: string;
    signatureAlgorithm: Oid;
    subjectName: X500DistinguishedName;
    thumbprint: string;
    /** @format int32 */
    version: number;
  }

  export interface X509Extension {
    oid?: Oid;
    /** @format byte */
    rawData: string;
    critical: boolean;
  }

  type BaseAiMessageMetadata = object;

  type BaseAiMessageMetadataTypenameMapping<Key, Type> = {
    typename: Key;
  } & Type;

  type BaseIPromptContent = object;

  type BaseIPromptContentTypenameMapping<Key, Type> = {
    typename: Key;
  } & Type;

  type BaseItem = object;

  type BaseItemTypenameMapping<Key, Type> = {
    typename: Key;
  } & Type;

  type BaseProjectFactMetadata = object;

  type BaseProjectFactMetadataTypenameMapping<Key, Type> = {
    typename: Key;
  } & Type;

  type BaseProjectFindingMetadata = object;

  type BaseProjectFindingMetadataTypenameMapping<Key, Type> = {
    typename: Key;
  } & Type;

  export interface ApiGetCountPathTypes {
    getAiBatchesCount: AiBatch;
    getAiBatchGroupsCount: AiBatchGroup;
    getAiBatchItemsCount: AiBatchItem;
    getAiBatchRunItemsCount: AiBatchRunItem;
    getAiBatchRunsCount: AiBatchRun;
    getAiConversationEvaluationsCount: AiConversationEvaluation;
    getAiConversationsCount: AiConversation;
    getAiMessagesCount: AiMessage;
    getAiModelDefinitionsCount: AiModelDefinition;
    getAiProjectGroupSummariesCount: AiProjectGroupSummary;
    getAiProjectSummariesCount: AiProjectSummary;
    getAiProvidersCount: AiProvider;
    getAiServicesCount: AiService;
    getAiThreadsCount: AiThread;
    getAmaThreadsCount: AmaThread;
    getApiKeysCount: ApiKey;
    getCategoriesCount: CategoriesView;
    getClientFeaturesCount: ClientFeature;
    getClientQuestionTemplatesCount: ClientQuestionTemplate;
    getClientsCount: Client;
    getCognitoIdpsCount: CognitoIdp;
    getCognitoUsersCount: CognitoUser;
    getCreditLogsCount: CreditLog;
    getCreditLogTypesCount: CreditLogType;
    getDataEventsLogCount: DataEventsLog;
    getDemandZoneCellsCount: DemandZoneCell;
    getDemandZonesCount: DemandZone;
    getDiagnoseScoreThemesCount: DiagnoseScoreThemeResponseCountsView;
    getDisplayScheduleExceptionsCount: DisplayScheduleException;
    getDisplaySchedulesCount: DisplaySchedule;
    getDocumentsCount: Document;
    getDocumentVersionsCount: DocumentVersion;
    getEnterprisesCount: Enterprise;
    getEstimatedProjectDurationCount: EstimatedProjectDurationView;
    getExtendedTeamsCount: ExtendedTeamsView;
    getExtrapolatedUserAndClientsCount: ExtrapolatedUserAndClient;
    getFeatureFlagsCount: FeatureFlag;
    getFrameworksCount: Framework;
    getHubspotRolesCount: HubspotRole;
    getLinkedClientsCount: ClientsView;
    getLinkInvitesCount: LinkInvite;
    getNotificationsCount: Notification;
    getNotificationTypesCount: NotificationType;
    getOrgsCount: Org;
    getProjectCommentsCount: ProjectComment;
    getProjectEmailSummariesCount: ProjectEmailSummary;
    getProjectFactsCount: ProjectFact;
    getProjectFilesCount: ProjectFile;
    getProjectFindingsCount: ProjectFinding;
    getProjectGroupQuestionsCount: ProjectGroupsQuestion;
    getProjectGroupsCount: ProjectGroup;
    getProjectGroupSegmentsCount: ProjectGroupSegment;
    getProjectGroupTagsCount: ProjectGroupTag;
    getProjectNarrativesCount: ProjectNarrative;
    getProjectNarrativeSectionsCount: ProjectNarrativeSection;
    getProjectNarrativeVersionExportsCount: ProjectNarrativeVersionExport;
    getProjectNarrativeVersionsCount: ProjectNarrativeVersion;
    getProjectObjectivesCount: ProjectObjective;
    getProjectQuestionsCount: ProjectQuestionDto;
    getProjectsCount: ProjectDto;
    getProjectsAiBatchGroupCount: ProjectsAiBatchGroup;
    getProjectSchedulesCount: ProjectSchedule;
    getProjectSharesCount: ProjectShare;
    getProjectsRegionsCount: ProjectsRegionsView;
    getProjectStatusesCount: ProjectStatus;
    getProjectSurveySessionsCount: ProjectSurveySessionsView;
    getProjectWatchersCount: ProjectWatcher;
    getProjectWeeksCount: ProjectWeeksView;
    getPromptEvaluationsCount: PromptEvaluation;
    getPromptsCount: Prompt;
    getPromptVersionsCount: PromptVersion;
    getQuestionOptionsCount: QuestionOption;
    getQuestionsCount: QuestionDto;
    getQuestionTemplatesCount: QuestionTemplateDto;
    getRegionsCount: Region;
    getRegressionScoresCount: RegressionScore;
    getResearchBuilderThreadsCount: ResearchBuilderThread;
    getResponsesCount: Response;
    getSegmentsCount: Segment;
    getStandardQuestionsCount: StandardQuestion;
    getSurveyRunRespondentsCsvEditThreadsCount: SurveyRunRespondentsCsvEditThread;
    getSurveyRunsCount: SurveyRun;
    getSurveySessionsCount: SurveySession;
    getSystemQuestionCount: SystemQuestion;
    getSystemQuestionOptionCount: SystemQuestionOption;
    getTargetsCount: Target;
    getTeamsCount: Team;
    getTestOptionsCount: TestOptionDto;
    getTextResponsesCount: TextResponse;
    getTextResponsesThemesCount: TextResponsesTheme;
    getThemesCount: Theme;
    getThemeSentimentsCount: ThemeSentiment;
    getTranslatedTextRegionsCount: TranslatedTextRegion;
    getuAndATypesCount: UAndAType;
    getUserAndClientsCount: UserAndClient;
    getUserClientRolesCount: UserClientRole;
    getUserDataExportsCount: UserDataExportDto;
    getUserRolesCount: UserRole;
    getUsersCount: User;
  }
  export interface ApiGetCountErrorTypes {
    getAiBatchesCount: any;
    getAiBatchGroupsCount: any;
    getAiBatchItemsCount: any;
    getAiBatchRunItemsCount: any;
    getAiBatchRunsCount: any;
    getAiConversationEvaluationsCount: any;
    getAiConversationsCount: any;
    getAiMessagesCount: any;
    getAiModelDefinitionsCount: any;
    getAiProjectGroupSummariesCount: any;
    getAiProjectSummariesCount: any;
    getAiProvidersCount: any;
    getAiServicesCount: any;
    getAiThreadsCount: any;
    getAmaThreadsCount: any;
    getApiKeysCount: any;
    getCategoriesCount: any;
    getClientFeaturesCount: any;
    getClientQuestionTemplatesCount: any;
    getClientsCount: any;
    getCognitoIdpsCount: any;
    getCognitoUsersCount: any;
    getCreditLogsCount: any;
    getCreditLogTypesCount: any;
    getDataEventsLogCount: any;
    getDemandZoneCellsCount: any;
    getDemandZonesCount: any;
    getDiagnoseScoreThemesCount: any;
    getDisplayScheduleExceptionsCount: any;
    getDisplaySchedulesCount: any;
    getDocumentsCount: any;
    getDocumentVersionsCount: any;
    getEnterprisesCount: any;
    getEstimatedProjectDurationCount: any;
    getExtendedTeamsCount: any;
    getExtrapolatedUserAndClientsCount: any;
    getFeatureFlagsCount: any;
    getFrameworksCount: any;
    getHubspotRolesCount: any;
    getLinkedClientsCount: any;
    getLinkInvitesCount: any;
    getNotificationsCount: any;
    getNotificationTypesCount: any;
    getOrgsCount: any;
    getProjectCommentsCount: any;
    getProjectEmailSummariesCount: any;
    getProjectFactsCount: any;
    getProjectFilesCount: any;
    getProjectFindingsCount: any;
    getProjectGroupQuestionsCount: any;
    getProjectGroupsCount: any;
    getProjectGroupSegmentsCount: any;
    getProjectGroupTagsCount: any;
    getProjectNarrativesCount: any;
    getProjectNarrativeSectionsCount: any;
    getProjectNarrativeVersionExportsCount: any;
    getProjectNarrativeVersionsCount: any;
    getProjectObjectivesCount: any;
    getProjectQuestionsCount: any;
    getProjectsCount: any;
    getProjectsAiBatchGroupCount: any;
    getProjectSchedulesCount: any;
    getProjectSharesCount: any;
    getProjectsRegionsCount: any;
    getProjectStatusesCount: any;
    getProjectSurveySessionsCount: any;
    getProjectWatchersCount: any;
    getProjectWeeksCount: any;
    getPromptEvaluationsCount: any;
    getPromptsCount: any;
    getPromptVersionsCount: any;
    getQuestionOptionsCount: any;
    getQuestionsCount: any;
    getQuestionTemplatesCount: any;
    getRegionsCount: any;
    getRegressionScoresCount: any;
    getResearchBuilderThreadsCount: any;
    getResponsesCount: any;
    getSegmentsCount: any;
    getStandardQuestionsCount: any;
    getSurveyRunRespondentsCsvEditThreadsCount: any;
    getSurveyRunsCount: any;
    getSurveySessionsCount: any;
    getSystemQuestionCount: any;
    getSystemQuestionOptionCount: any;
    getTargetsCount: any;
    getTeamsCount: any;
    getTestOptionsCount: any;
    getTextResponsesCount: any;
    getTextResponsesThemesCount: any;
    getThemesCount: any;
    getThemeSentimentsCount: any;
    getTranslatedTextRegionsCount: any;
    getuAndATypesCount: any;
    getUserAndClientsCount: any;
    getUserClientRolesCount: any;
    getUserDataExportsCount: any;
    getUserRolesCount: any;
    getUsersCount: any;
  }
  export const apiGetCountPaths: { [key in keyof ApiGetCountPathTypes]: string } = {
    getAiBatchesCount: "/api/v1/AiBatches/$count",
    getAiBatchGroupsCount: "/api/v1/AiBatchGroups/$count",
    getAiBatchItemsCount: "/api/v1/AiBatchItems/$count",
    getAiBatchRunItemsCount: "/api/v1/AiBatchRunItems/$count",
    getAiBatchRunsCount: "/api/v1/AiBatchRuns/$count",
    getAiConversationEvaluationsCount: "/api/v1/AiConversationEvaluations/$count",
    getAiConversationsCount: "/api/v1/AiConversations/$count",
    getAiMessagesCount: "/api/v1/AiMessages/$count",
    getAiModelDefinitionsCount: "/api/v1/AiModelDefinitions/$count",
    getAiProjectGroupSummariesCount: "/api/v1/AiProjectGroupSummaries/$count",
    getAiProjectSummariesCount: "/api/v1/AiProjectSummaries/$count",
    getAiProvidersCount: "/api/v1/AiProviders/$count",
    getAiServicesCount: "/api/v1/AiServices/$count",
    getAiThreadsCount: "/api/v1/AiThreads/$count",
    getAmaThreadsCount: "/api/v1/AmaThreads/$count",
    getApiKeysCount: "/api/v1/ApiKeys/$count",
    getCategoriesCount: "/api/v1/Categories/$count",
    getClientFeaturesCount: "/api/v1/ClientFeatures/$count",
    getClientQuestionTemplatesCount: "/api/v1/ClientQuestionTemplates/$count",
    getClientsCount: "/api/v1/Clients/$count",
    getCognitoIdpsCount: "/api/v1/CognitoIdps/$count",
    getCognitoUsersCount: "/api/v1/CognitoUsers/$count",
    getCreditLogsCount: "/api/v1/CreditLogs/$count",
    getCreditLogTypesCount: "/api/v1/CreditLogTypes/$count",
    getDataEventsLogCount: "/api/v1/DataEventsLog/$count",
    getDemandZoneCellsCount: "/api/v1/DemandZoneCells/$count",
    getDemandZonesCount: "/api/v1/DemandZones/$count",
    getDiagnoseScoreThemesCount: "/api/v1/DiagnoseScoreThemes/$count",
    getDisplayScheduleExceptionsCount: "/api/v1/DisplayScheduleExceptions/$count",
    getDisplaySchedulesCount: "/api/v1/DisplaySchedules/$count",
    getDocumentsCount: "/api/v1/Documents/$count",
    getDocumentVersionsCount: "/api/v1/DocumentVersions/$count",
    getEnterprisesCount: "/api/v1/Enterprises/$count",
    getEstimatedProjectDurationCount: "/api/v1/EstimatedProjectDuration/$count",
    getExtendedTeamsCount: "/api/v1/ExtendedTeams/$count",
    getExtrapolatedUserAndClientsCount: "/api/v1/ExtrapolatedUserAndClients/$count",
    getFeatureFlagsCount: "/api/v1/FeatureFlags/$count",
    getFrameworksCount: "/api/v1/Frameworks/$count",
    getHubspotRolesCount: "/api/v1/HubspotRoles/$count",
    getLinkedClientsCount: "/api/v1/LinkedClients/$count",
    getLinkInvitesCount: "/api/v1/LinkInvites/$count",
    getNotificationsCount: "/api/v1/Notifications/$count",
    getNotificationTypesCount: "/api/v1/NotificationTypes/$count",
    getOrgsCount: "/api/v1/Orgs/$count",
    getProjectCommentsCount: "/api/v1/ProjectComments/$count",
    getProjectEmailSummariesCount: "/api/v1/ProjectEmailSummaries/$count",
    getProjectFactsCount: "/api/v1/ProjectFacts/$count",
    getProjectFilesCount: "/api/v1/ProjectFiles/$count",
    getProjectFindingsCount: "/api/v1/ProjectFindings/$count",
    getProjectGroupQuestionsCount: "/api/v1/ProjectGroupQuestions/$count",
    getProjectGroupsCount: "/api/v1/ProjectGroups/$count",
    getProjectGroupSegmentsCount: "/api/v1/ProjectGroupSegments/$count",
    getProjectGroupTagsCount: "/api/v1/ProjectGroupTags/$count",
    getProjectNarrativesCount: "/api/v1/ProjectNarratives/$count",
    getProjectNarrativeSectionsCount: "/api/v1/ProjectNarrativeSections/$count",
    getProjectNarrativeVersionExportsCount: "/api/v1/ProjectNarrativeVersionExports/$count",
    getProjectNarrativeVersionsCount: "/api/v1/ProjectNarrativeVersions/$count",
    getProjectObjectivesCount: "/api/v1/ProjectObjectives/$count",
    getProjectQuestionsCount: "/api/v1/ProjectQuestions/$count",
    getProjectsCount: "/api/v1/Projects/$count",
    getProjectsAiBatchGroupCount: "/api/v1/ProjectsAiBatchGroup/$count",
    getProjectSchedulesCount: "/api/v1/ProjectSchedules/$count",
    getProjectSharesCount: "/api/v1/ProjectShares/$count",
    getProjectsRegionsCount: "/api/v1/ProjectsRegions/$count",
    getProjectStatusesCount: "/api/v1/ProjectStatuses/$count",
    getProjectSurveySessionsCount: "/api/v1/ProjectSurveySessions/$count",
    getProjectWatchersCount: "/api/v1/ProjectWatchers/$count",
    getProjectWeeksCount: "/api/v1/ProjectWeeks/$count",
    getPromptEvaluationsCount: "/api/v1/PromptEvaluations/$count",
    getPromptsCount: "/api/v1/Prompts/$count",
    getPromptVersionsCount: "/api/v1/PromptVersions/$count",
    getQuestionOptionsCount: "/api/v1/QuestionOptions/$count",
    getQuestionsCount: "/api/v1/Questions/$count",
    getQuestionTemplatesCount: "/api/v1/QuestionTemplates/$count",
    getRegionsCount: "/api/v1/Regions/$count",
    getRegressionScoresCount: "/api/v1/RegressionScores/$count",
    getResearchBuilderThreadsCount: "/api/v1/ResearchBuilderThreads/$count",
    getResponsesCount: "/api/v1/Responses/$count",
    getSegmentsCount: "/api/v1/Segments/$count",
    getStandardQuestionsCount: "/api/v1/StandardQuestions/$count",
    getSurveyRunRespondentsCsvEditThreadsCount: "/api/v1/SurveyRunRespondentsCsvEditThreads/$count",
    getSurveyRunsCount: "/api/v1/SurveyRuns/$count",
    getSurveySessionsCount: "/api/v1/SurveySessions/$count",
    getSystemQuestionCount: "/api/v1/SystemQuestion/$count",
    getSystemQuestionOptionCount: "/api/v1/SystemQuestionOption/$count",
    getTargetsCount: "/api/v1/Targets/$count",
    getTeamsCount: "/api/v1/Teams/$count",
    getTestOptionsCount: "/api/v1/TestOptions/$count",
    getTextResponsesCount: "/api/v1/TextResponses/$count",
    getTextResponsesThemesCount: "/api/v1/TextResponsesThemes/$count",
    getThemesCount: "/api/v1/Themes/$count",
    getThemeSentimentsCount: "/api/v1/ThemeSentiments/$count",
    getTranslatedTextRegionsCount: "/api/v1/TranslatedTextRegions/$count",
    getuAndATypesCount: "/api/v1/UAndATypes/$count",
    getUserAndClientsCount: "/api/v1/UserAndClients/$count",
    getUserClientRolesCount: "/api/v1/UserClientRoles/$count",
    getUserDataExportsCount: "/api/v1/UserDataExports/$count",
    getUserRolesCount: "/api/v1/UserRoles/$count",
    getUsersCount: "/api/v1/Users/$count",
  };
  export interface AuthGetCountPathTypes {}
  export interface AuthGetCountErrorTypes {}
  export const authGetCountPaths: { [key in keyof AuthGetCountPathTypes]: string } = {};

  export interface ApiGetPathTypes {
    getAiBatches: AiBatch;
    getAiBatchGroups: AiBatchGroup;
    getAiBatchItems: AiBatchItem;
    getAiBatchRunItems: AiBatchRunItem;
    getAiBatchRuns: AiBatchRun;
    getAiConversationEvaluations: AiConversationEvaluation;
    getAiConversations: AiConversation;
    getAiMessages: AiMessage;
    getAiModelDefinitions: AiModelDefinition;
    getAiProjectGroupSummaries: AiProjectGroupSummary;
    getAiProjectSummaries: AiProjectSummary;
    getAiProviders: AiProvider;
    getAiServices: AiService;
    getAiThreads: AiThread;
    getAmaThreads: AmaThread;
    getApiKeys: ApiKey;
    getCategories: CategoriesView;
    getClientFeatures: ClientFeature;
    getClientQuestionTemplates: ClientQuestionTemplate;
    getClients: Client;
    getCognitoIdps: CognitoIdp;
    getCognitoUsers: CognitoUser;
    getCreditLogs: CreditLog;
    getCreditLogTypes: CreditLogType;
    getDataEventsLog: DataEventsLog;
    getDemandZoneCells: DemandZoneCell;
    getDemandZones: DemandZone;
    getDiagnoseScoreThemes: DiagnoseScoreThemeResponseCountsView;
    getDisplayScheduleExceptions: DisplayScheduleException;
    getDisplaySchedules: DisplaySchedule;
    getDocuments: Document;
    getDocumentVersions: DocumentVersion;
    getEnterprises: Enterprise;
    getEstimatedProjectDuration: EstimatedProjectDurationView;
    getExtendedTeams: ExtendedTeamsView;
    getExtrapolatedUserAndClients: ExtrapolatedUserAndClient;
    getFeatureFlags: FeatureFlag;
    getFrameworks: Framework;
    getHubspotRoles: HubspotRole;
    getLinkedClients: ClientsView;
    getLinkInvites: LinkInvite;
    getNotifications: Notification;
    getNotificationTypes: NotificationType;
    getOrgs: Org;
    getProjectComments: ProjectComment;
    getProjectEmailSummaries: ProjectEmailSummary;
    getProjectFacts: ProjectFact;
    getProjectFiles: ProjectFile;
    getProjectFindings: ProjectFinding;
    getProjectGroupQuestions: ProjectGroupsQuestion;
    getProjectGroups: ProjectGroup;
    getProjectGroupSegments: ProjectGroupSegment;
    getProjectGroupTags: ProjectGroupTag;
    getProjectNarratives: ProjectNarrative;
    getProjectNarrativeSections: ProjectNarrativeSection;
    getProjectNarrativeVersionExports: ProjectNarrativeVersionExport;
    getProjectNarrativeVersions: ProjectNarrativeVersion;
    getProjectObjectives: ProjectObjective;
    getProjectQuestions: ProjectQuestionDto;
    getProjects: ProjectDto;
    getProjectsAiBatchGroup: ProjectsAiBatchGroup;
    getProjectSchedules: ProjectSchedule;
    getProjectShares: ProjectShare;
    getProjectsRegions: ProjectsRegionsView;
    getProjectStatuses: ProjectStatus;
    getProjectSurveySessions: ProjectSurveySessionsView;
    getProjectWatchers: ProjectWatcher;
    getProjectWeeks: ProjectWeeksView;
    getPromptEvaluations: PromptEvaluation;
    getPrompts: Prompt;
    getPromptVersions: PromptVersion;
    getQuestionOptions: QuestionOption;
    getQuestions: QuestionDto;
    getQuestionTemplates: QuestionTemplateDto;
    getRegions: Region;
    getRegressionScores: RegressionScore;
    getResearchBuilderThreads: ResearchBuilderThread;
    getResponses: Response;
    getSegments: Segment;
    getStandardQuestions: StandardQuestion;
    getSurveyRunRespondentsCsvEditThreads: SurveyRunRespondentsCsvEditThread;
    getSurveyRuns: SurveyRun;
    getSurveySessions: SurveySession;
    getSystemQuestion: SystemQuestion;
    getSystemQuestionOption: SystemQuestionOption;
    getTargets: Target;
    getTeams: Team;
    getTestOptions: TestOptionDto;
    getTextResponses: TextResponse;
    getTextResponsesThemes: TextResponsesTheme;
    getThemes: Theme;
    getThemeSentiments: ThemeSentiment;
    getTranslatedTextRegions: TranslatedTextRegion;
    getuAndATypes: UAndAType;
    getUserAndClients: UserAndClient;
    getUserClientRoles: UserClientRole;
    getUserDataExports: UserDataExportDto;
    getUserRoles: UserRole;
    getUsers: User;
  }
  export interface ApiGetErrorTypes {
    getAiBatches: any;
    getAiBatchGroups: any;
    getAiBatchItems: any;
    getAiBatchRunItems: any;
    getAiBatchRuns: any;
    getAiConversationEvaluations: any;
    getAiConversations: any;
    getAiMessages: any;
    getAiModelDefinitions: any;
    getAiProjectGroupSummaries: any;
    getAiProjectSummaries: any;
    getAiProviders: any;
    getAiServices: any;
    getAiThreads: any;
    getAmaThreads: any;
    getApiKeys: any;
    getCategories: any;
    getClientFeatures: any;
    getClientQuestionTemplates: any;
    getClients: any;
    getCognitoIdps: any;
    getCognitoUsers: any;
    getCreditLogs: any;
    getCreditLogTypes: any;
    getDataEventsLog: any;
    getDemandZoneCells: any;
    getDemandZones: any;
    getDiagnoseScoreThemes: any;
    getDisplayScheduleExceptions: any;
    getDisplaySchedules: any;
    getDocuments: any;
    getDocumentVersions: any;
    getEnterprises: any;
    getEstimatedProjectDuration: any;
    getExtendedTeams: any;
    getExtrapolatedUserAndClients: any;
    getFeatureFlags: any;
    getFrameworks: any;
    getHubspotRoles: any;
    getLinkedClients: any;
    getLinkInvites: any;
    getNotifications: any;
    getNotificationTypes: any;
    getOrgs: any;
    getProjectComments: any;
    getProjectEmailSummaries: any;
    getProjectFacts: any;
    getProjectFiles: any;
    getProjectFindings: any;
    getProjectGroupQuestions: any;
    getProjectGroups: any;
    getProjectGroupSegments: any;
    getProjectGroupTags: any;
    getProjectNarratives: any;
    getProjectNarrativeSections: any;
    getProjectNarrativeVersionExports: any;
    getProjectNarrativeVersions: any;
    getProjectObjectives: any;
    getProjectQuestions: any;
    getProjects: any;
    getProjectsAiBatchGroup: any;
    getProjectSchedules: any;
    getProjectShares: any;
    getProjectsRegions: any;
    getProjectStatuses: any;
    getProjectSurveySessions: any;
    getProjectWatchers: any;
    getProjectWeeks: any;
    getPromptEvaluations: any;
    getPrompts: any;
    getPromptVersions: any;
    getQuestionOptions: any;
    getQuestions: any;
    getQuestionTemplates: any;
    getRegions: any;
    getRegressionScores: any;
    getResearchBuilderThreads: any;
    getResponses: any;
    getSegments: any;
    getStandardQuestions: any;
    getSurveyRunRespondentsCsvEditThreads: any;
    getSurveyRuns: any;
    getSurveySessions: any;
    getSystemQuestion: any;
    getSystemQuestionOption: any;
    getTargets: any;
    getTeams: any;
    getTestOptions: any;
    getTextResponses: any;
    getTextResponsesThemes: any;
    getThemes: any;
    getThemeSentiments: any;
    getTranslatedTextRegions: any;
    getuAndATypes: any;
    getUserAndClients: any;
    getUserClientRoles: any;
    getUserDataExports: any;
    getUserRoles: any;
    getUsers: any;
  }
  export const apiGetPaths: { [key in keyof ApiGetPathTypes]: string } = {
    getAiBatches: "/api/v1/AiBatches",
    getAiBatchGroups: "/api/v1/AiBatchGroups",
    getAiBatchItems: "/api/v1/AiBatchItems",
    getAiBatchRunItems: "/api/v1/AiBatchRunItems",
    getAiBatchRuns: "/api/v1/AiBatchRuns",
    getAiConversationEvaluations: "/api/v1/AiConversationEvaluations",
    getAiConversations: "/api/v1/AiConversations",
    getAiMessages: "/api/v1/AiMessages",
    getAiModelDefinitions: "/api/v1/AiModelDefinitions",
    getAiProjectGroupSummaries: "/api/v1/AiProjectGroupSummaries",
    getAiProjectSummaries: "/api/v1/AiProjectSummaries",
    getAiProviders: "/api/v1/AiProviders",
    getAiServices: "/api/v1/AiServices",
    getAiThreads: "/api/v1/AiThreads",
    getAmaThreads: "/api/v1/AmaThreads",
    getApiKeys: "/api/v1/ApiKeys",
    getCategories: "/api/v1/Categories",
    getClientFeatures: "/api/v1/ClientFeatures",
    getClientQuestionTemplates: "/api/v1/ClientQuestionTemplates",
    getClients: "/api/v1/Clients",
    getCognitoIdps: "/api/v1/CognitoIdps",
    getCognitoUsers: "/api/v1/CognitoUsers",
    getCreditLogs: "/api/v1/CreditLogs",
    getCreditLogTypes: "/api/v1/CreditLogTypes",
    getDataEventsLog: "/api/v1/DataEventsLog",
    getDemandZoneCells: "/api/v1/DemandZoneCells",
    getDemandZones: "/api/v1/DemandZones",
    getDiagnoseScoreThemes: "/api/v1/DiagnoseScoreThemes",
    getDisplayScheduleExceptions: "/api/v1/DisplayScheduleExceptions",
    getDisplaySchedules: "/api/v1/DisplaySchedules",
    getDocuments: "/api/v1/Documents",
    getDocumentVersions: "/api/v1/DocumentVersions",
    getEnterprises: "/api/v1/Enterprises",
    getEstimatedProjectDuration: "/api/v1/EstimatedProjectDuration",
    getExtendedTeams: "/api/v1/ExtendedTeams",
    getExtrapolatedUserAndClients: "/api/v1/ExtrapolatedUserAndClients",
    getFeatureFlags: "/api/v1/FeatureFlags",
    getFrameworks: "/api/v1/Frameworks",
    getHubspotRoles: "/api/v1/HubspotRoles",
    getLinkedClients: "/api/v1/LinkedClients",
    getLinkInvites: "/api/v1/LinkInvites",
    getNotifications: "/api/v1/Notifications",
    getNotificationTypes: "/api/v1/NotificationTypes",
    getOrgs: "/api/v1/Orgs",
    getProjectComments: "/api/v1/ProjectComments",
    getProjectEmailSummaries: "/api/v1/ProjectEmailSummaries",
    getProjectFacts: "/api/v1/ProjectFacts",
    getProjectFiles: "/api/v1/ProjectFiles",
    getProjectFindings: "/api/v1/ProjectFindings",
    getProjectGroupQuestions: "/api/v1/ProjectGroupQuestions",
    getProjectGroups: "/api/v1/ProjectGroups",
    getProjectGroupSegments: "/api/v1/ProjectGroupSegments",
    getProjectGroupTags: "/api/v1/ProjectGroupTags",
    getProjectNarratives: "/api/v1/ProjectNarratives",
    getProjectNarrativeSections: "/api/v1/ProjectNarrativeSections",
    getProjectNarrativeVersionExports: "/api/v1/ProjectNarrativeVersionExports",
    getProjectNarrativeVersions: "/api/v1/ProjectNarrativeVersions",
    getProjectObjectives: "/api/v1/ProjectObjectives",
    getProjectQuestions: "/api/v1/ProjectQuestions",
    getProjects: "/api/v1/Projects",
    getProjectsAiBatchGroup: "/api/v1/ProjectsAiBatchGroup",
    getProjectSchedules: "/api/v1/ProjectSchedules",
    getProjectShares: "/api/v1/ProjectShares",
    getProjectsRegions: "/api/v1/ProjectsRegions",
    getProjectStatuses: "/api/v1/ProjectStatuses",
    getProjectSurveySessions: "/api/v1/ProjectSurveySessions",
    getProjectWatchers: "/api/v1/ProjectWatchers",
    getProjectWeeks: "/api/v1/ProjectWeeks",
    getPromptEvaluations: "/api/v1/PromptEvaluations",
    getPrompts: "/api/v1/Prompts",
    getPromptVersions: "/api/v1/PromptVersions",
    getQuestionOptions: "/api/v1/QuestionOptions",
    getQuestions: "/api/v1/Questions",
    getQuestionTemplates: "/api/v1/QuestionTemplates",
    getRegions: "/api/v1/Regions",
    getRegressionScores: "/api/v1/RegressionScores",
    getResearchBuilderThreads: "/api/v1/ResearchBuilderThreads",
    getResponses: "/api/v1/Responses",
    getSegments: "/api/v1/Segments",
    getStandardQuestions: "/api/v1/StandardQuestions",
    getSurveyRunRespondentsCsvEditThreads: "/api/v1/SurveyRunRespondentsCsvEditThreads",
    getSurveyRuns: "/api/v1/SurveyRuns",
    getSurveySessions: "/api/v1/SurveySessions",
    getSystemQuestion: "/api/v1/SystemQuestion",
    getSystemQuestionOption: "/api/v1/SystemQuestionOption",
    getTargets: "/api/v1/Targets",
    getTeams: "/api/v1/Teams",
    getTestOptions: "/api/v1/TestOptions",
    getTextResponses: "/api/v1/TextResponses",
    getTextResponsesThemes: "/api/v1/TextResponsesThemes",
    getThemes: "/api/v1/Themes",
    getThemeSentiments: "/api/v1/ThemeSentiments",
    getTranslatedTextRegions: "/api/v1/TranslatedTextRegions",
    getuAndATypes: "/api/v1/UAndATypes",
    getUserAndClients: "/api/v1/UserAndClients",
    getUserClientRoles: "/api/v1/UserClientRoles",
    getUserDataExports: "/api/v1/UserDataExports",
    getUserRoles: "/api/v1/UserRoles",
    getUsers: "/api/v1/Users",
  };
  export type ApiGetParams = {
    getAiBatches: {};
    getAiBatchGroups: {};
    getAiBatchItems: {};
    getAiBatchRunItems: {};
    getAiBatchRuns: {};
    getAiConversationEvaluations: {};
    getAiConversations: {};
    getAiMessages: {};
    getAiModelDefinitions: {};
    getAiProjectGroupSummaries: {};
    getAiProjectSummaries: {};
    getAiProviders: {};
    getAiServices: {};
    getAiThreads: {};
    getAmaThreads: {};
    getApiKeys: {};
    getCategories: {};
    getClientFeatures: {};
    getClientQuestionTemplates: {};
    getClients: {};
    getCognitoIdps: {};
    getCognitoUsers: {};
    getCreditLogs: {};
    getCreditLogTypes: {};
    getDataEventsLog: {};
    getDemandZoneCells: {};
    getDemandZones: {};
    getDiagnoseScoreThemes: {};
    getDisplayScheduleExceptions: {};
    getDisplaySchedules: {};
    getDocuments: {};
    getDocumentVersions: {};
    getEnterprises: {};
    getEstimatedProjectDuration: {};
    getExtendedTeams: {};
    getExtrapolatedUserAndClients: {};
    getFeatureFlags: {};
    getFrameworks: {};
    getHubspotRoles: {};
    getLinkedClients: {};
    getLinkInvites: {};
    getNotifications: {};
    getNotificationTypes: {};
    getOrgs: {};
    getProjectComments: {};
    getProjectEmailSummaries: {};
    getProjectFacts: {};
    getProjectFiles: {};
    getProjectFindings: {};
    getProjectGroupQuestions: {};
    getProjectGroups: {};
    getProjectGroupSegments: {};
    getProjectGroupTags: {};
    getProjectNarratives: {};
    getProjectNarrativeSections: {};
    getProjectNarrativeVersionExports: {};
    getProjectNarrativeVersions: {};
    getProjectObjectives: {};
    getProjectQuestions: {
      options?: any;
    };
    getProjects: {
      options?: any;
    };
    getProjectsAiBatchGroup: {};
    getProjectSchedules: {};
    getProjectShares: {};
    getProjectsRegions: {};
    getProjectStatuses: {};
    getProjectSurveySessions: {};
    getProjectWatchers: {};
    getProjectWeeks: {};
    getPromptEvaluations: {};
    getPrompts: {};
    getPromptVersions: {};
    getQuestionOptions: {};
    getQuestions: {
      options?: any;
    };
    getQuestionTemplates: {
      options?: any;
    };
    getRegions: {};
    getRegressionScores: {};
    getResearchBuilderThreads: {};
    getResponses: {};
    getSegments: {};
    getStandardQuestions: {};
    getSurveyRunRespondentsCsvEditThreads: {};
    getSurveyRuns: {};
    getSurveySessions: {};
    getSystemQuestion: {};
    getSystemQuestionOption: {};
    getTargets: {};
    getTeams: {};
    getTestOptions: {
      options?: any;
    };
    getTextResponses: {};
    getTextResponsesThemes: {};
    getThemes: {};
    getThemeSentiments: {};
    getTranslatedTextRegions: {};
    getuAndATypes: {};
    getUserAndClients: {};
    getUserClientRoles: {};
    getUserDataExports: {
      options?: any;
    };
    getUserRoles: {};
    getUsers: {};
  };

  export interface ApiGetOnePathTypes {
    getAiBatchesOne: AiBatch;
    getAiBatchGroupsOne: AiBatchGroup;
    getAiBatchItemsOne: AiBatchItem;
    getAiBatchRunItemsOne: AiBatchRunItem;
    getAiBatchRunsOne: AiBatchRun;
    getAiConversationEvaluationsOne: AiConversationEvaluation;
    getAiConversationsOne: AiConversation;
    getAiMessagesOne: AiMessage;
    getAiModelDefinitionsOne: AiModelDefinition;
    getAiProjectGroupSummariesOne: AiProjectGroupSummary;
    getAiProjectSummariesOne: AiProjectSummary;
    getAiProvidersOne: AiProvider;
    getAiServicesOne: AiService;
    getAiThreadsOne: AiThread;
    getAmaThreadsOne: AmaThread;
    getApiKeysOne: ApiKey;
    getCategoriesOne: CategoriesView;
    getClientFeaturesOne: ClientFeature;
    getClientQuestionTemplatesOne: ClientQuestionTemplate;
    getClientsOne: Client;
    getCognitoIdpsOne: CognitoIdp;
    getCognitoUsersOne: CognitoUser;
    getCreditLogsOne: CreditLog;
    getCreditLogTypesOne: CreditLogType;
    getDataEventsLogOne: DataEventsLog;
    getDemandZoneCellsOne: DemandZoneCell;
    getDemandZonesOne: DemandZone;
    getDiagnoseScoreThemesOne: DiagnoseScoreThemeResponseCountsView;
    getDisplayScheduleExceptionsOne: DisplayScheduleException;
    getDisplaySchedulesOne: DisplaySchedule;
    getDocumentsOne: Document;
    getDocumentVersionsOne: DocumentVersion;
    getEnterprisesOne: Enterprise;
    getEstimatedProjectDurationOne: EstimatedProjectDurationView;
    getExtendedTeamsOne: ExtendedTeamsView;
    getExtrapolatedUserAndClientsOne: ExtrapolatedUserAndClient;
    getFeatureFlagsOne: FeatureFlag;
    getFrameworksOne: Framework;
    getHubspotRolesOne: HubspotRole;
    getLinkedClientsOne: ClientsView;
    getLinkInvitesOne: LinkInvite;
    getNotificationsOne: Notification;
    getNotificationTypesOne: NotificationType;
    getOrgsOne: Org;
    getProjectCommentsOne: ProjectComment;
    getProjectEmailSummariesOne: ProjectEmailSummary;
    getProjectFactsOne: ProjectFact;
    getProjectFilesOne: ProjectFile;
    getProjectFindingsOne: ProjectFinding;
    getProjectGroupQuestionsOne: ProjectGroupsQuestion;
    getProjectGroupsOne: ProjectGroup;
    getProjectGroupSegmentsOne: ProjectGroupSegment;
    getProjectGroupTagsOne: ProjectGroupTag;
    getProjectNarrativesOne: ProjectNarrative;
    getProjectNarrativeSectionsOne: ProjectNarrativeSection;
    getProjectNarrativeVersionExportsOne: ProjectNarrativeVersionExport;
    getProjectNarrativeVersionsOne: ProjectNarrativeVersion;
    getProjectObjectivesOne: ProjectObjective;
    getProjectQuestionsOne: ProjectQuestionDto;
    getProjectsOne: ProjectDto;
    getProjectsAiBatchGroupOne: ProjectsAiBatchGroup;
    getProjectSchedulesOne: ProjectSchedule;
    getProjectSharesOne: ProjectShare;
    getProjectsRegionsOne: ProjectsRegionsView;
    getProjectStatusesOne: ProjectStatus;
    getProjectSurveySessionsOne: ProjectSurveySessionsView;
    getProjectWatchersOne: ProjectWatcher;
    getProjectWeeksOne: ProjectWeeksView;
    getPromptEvaluationsOne: PromptEvaluation;
    getPromptsOne: Prompt;
    getPromptVersionsOne: PromptVersion;
    getQuestionOptionsOne: QuestionOption;
    getQuestionsOne: QuestionDto;
    getQuestionTemplatesOne: QuestionTemplateDto;
    getRegionsOne: Region;
    getRegressionScoresOne: RegressionScore;
    getResearchBuilderThreadsOne: ResearchBuilderThread;
    getResponsesOne: Response;
    getSegmentsOne: Segment;
    getStandardQuestionsOne: StandardQuestion;
    getSurveyRunRespondentsCsvEditThreadsOne: SurveyRunRespondentsCsvEditThread;
    getSurveyRunsOne: SurveyRun;
    getSurveySessionsOne: SurveySession;
    getSystemQuestionOne: SystemQuestion;
    getSystemQuestionOptionOne: SystemQuestionOption;
    getTargetsOne: Target;
    getTeamsOne: Team;
    getTestOptionsOne: TestOptionDto;
    getTextResponsesOne: TextResponse;
    getTextResponsesThemesOne: TextResponsesTheme;
    getThemesOne: Theme;
    getThemeSentimentsOne: ThemeSentiment;
    getTranslatedTextRegionsOne: TranslatedTextRegion;
    getuAndATypesOne: UAndAType;
    getUserAndClientsOne: UserAndClient;
    getUserClientRolesOne: UserClientRole;
    getUserDataExportsOne: UserDataExportDto;
    getUserRolesOne: UserRole;
    getUsersOne: User;
  }
  export const apiGetOnePaths: { [key in keyof ApiGetOnePathTypes]: string } = {
    getAiBatchesOne: "/api/v1/AiBatches(${key})",
    getAiBatchGroupsOne: "/api/v1/AiBatchGroups(${key})",
    getAiBatchItemsOne: "/api/v1/AiBatchItems(${key})",
    getAiBatchRunItemsOne: "/api/v1/AiBatchRunItems(${key})",
    getAiBatchRunsOne: "/api/v1/AiBatchRuns(${key})",
    getAiConversationEvaluationsOne: "/api/v1/AiConversationEvaluations(${key})",
    getAiConversationsOne: "/api/v1/AiConversations(${key})",
    getAiMessagesOne: "/api/v1/AiMessages(${key})",
    getAiModelDefinitionsOne: "/api/v1/AiModelDefinitions(${key})",
    getAiProjectGroupSummariesOne: "/api/v1/AiProjectGroupSummaries(${key})",
    getAiProjectSummariesOne: "/api/v1/AiProjectSummaries(${key})",
    getAiProvidersOne: "/api/v1/AiProviders(${key})",
    getAiServicesOne: "/api/v1/AiServices(${key})",
    getAiThreadsOne: "/api/v1/AiThreads(${key})",
    getAmaThreadsOne: "/api/v1/AmaThreads(${key})",
    getApiKeysOne: "/api/v1/ApiKeys(${key})",
    getCategoriesOne: "/api/v1/Categories(${key})",
    getClientFeaturesOne: "/api/v1/ClientFeatures(${key})",
    getClientQuestionTemplatesOne: "/api/v1/ClientQuestionTemplates(${key})",
    getClientsOne: "/api/v1/Clients(${key})",
    getCognitoIdpsOne: "/api/v1/CognitoIdps(${key})",
    getCognitoUsersOne: "/api/v1/CognitoUsers(${key})",
    getCreditLogsOne: "/api/v1/CreditLogs(${key})",
    getCreditLogTypesOne: "/api/v1/CreditLogTypes(${key})",
    getDataEventsLogOne: "/api/v1/DataEventsLog(${key})",
    getDemandZoneCellsOne: "/api/v1/DemandZoneCells(${key})",
    getDemandZonesOne: "/api/v1/DemandZones(${key})",
    getDiagnoseScoreThemesOne: "/api/v1/DiagnoseScoreThemes(${key})",
    getDisplayScheduleExceptionsOne: "/api/v1/DisplayScheduleExceptions(${key})",
    getDisplaySchedulesOne: "/api/v1/DisplaySchedules(${key})",
    getDocumentsOne: "/api/v1/Documents(${key})",
    getDocumentVersionsOne: "/api/v1/DocumentVersions(${key})",
    getEnterprisesOne: "/api/v1/Enterprises(${key})",
    getEstimatedProjectDurationOne: "/api/v1/EstimatedProjectDuration(${key})",
    getExtendedTeamsOne: "/api/v1/ExtendedTeams(${key})",
    getExtrapolatedUserAndClientsOne: "/api/v1/ExtrapolatedUserAndClients(${key})",
    getFeatureFlagsOne: "/api/v1/FeatureFlags(${key})",
    getFrameworksOne: "/api/v1/Frameworks(${key})",
    getHubspotRolesOne: "/api/v1/HubspotRoles(${key})",
    getLinkedClientsOne: "/api/v1/LinkedClients(${key})",
    getLinkInvitesOne: "/api/v1/LinkInvites(${key})",
    getNotificationsOne: "/api/v1/Notifications(${key})",
    getNotificationTypesOne: "/api/v1/NotificationTypes(${key})",
    getOrgsOne: "/api/v1/Orgs(${key})",
    getProjectCommentsOne: "/api/v1/ProjectComments(${key})",
    getProjectEmailSummariesOne: "/api/v1/ProjectEmailSummaries(${key})",
    getProjectFactsOne: "/api/v1/ProjectFacts(${key})",
    getProjectFilesOne: "/api/v1/ProjectFiles(${key})",
    getProjectFindingsOne: "/api/v1/ProjectFindings(${key})",
    getProjectGroupQuestionsOne: "/api/v1/ProjectGroupQuestions(${key})",
    getProjectGroupsOne: "/api/v1/ProjectGroups(${key})",
    getProjectGroupSegmentsOne: "/api/v1/ProjectGroupSegments(${key})",
    getProjectGroupTagsOne: "/api/v1/ProjectGroupTags(${key})",
    getProjectNarrativesOne: "/api/v1/ProjectNarratives(${key})",
    getProjectNarrativeSectionsOne: "/api/v1/ProjectNarrativeSections(${key})",
    getProjectNarrativeVersionExportsOne: "/api/v1/ProjectNarrativeVersionExports(${key})",
    getProjectNarrativeVersionsOne: "/api/v1/ProjectNarrativeVersions(${key})",
    getProjectObjectivesOne: "/api/v1/ProjectObjectives(${key})",
    getProjectQuestionsOne: "/api/v1/ProjectQuestions(${key})",
    getProjectsOne: "/api/v1/Projects(${key})",
    getProjectsAiBatchGroupOne: "/api/v1/ProjectsAiBatchGroup(${key})",
    getProjectSchedulesOne: "/api/v1/ProjectSchedules(${key})",
    getProjectSharesOne: "/api/v1/ProjectShares(${key})",
    getProjectsRegionsOne: "/api/v1/ProjectsRegions(${key})",
    getProjectStatusesOne: "/api/v1/ProjectStatuses(${key})",
    getProjectSurveySessionsOne: "/api/v1/ProjectSurveySessions(${key})",
    getProjectWatchersOne: "/api/v1/ProjectWatchers(${key})",
    getProjectWeeksOne: "/api/v1/ProjectWeeks(${key})",
    getPromptEvaluationsOne: "/api/v1/PromptEvaluations(${key})",
    getPromptsOne: "/api/v1/Prompts(${key})",
    getPromptVersionsOne: "/api/v1/PromptVersions(${key})",
    getQuestionOptionsOne: "/api/v1/QuestionOptions(${key})",
    getQuestionsOne: "/api/v1/Questions(${key})",
    getQuestionTemplatesOne: "/api/v1/QuestionTemplates(${key})",
    getRegionsOne: "/api/v1/Regions(${key})",
    getRegressionScoresOne: "/api/v1/RegressionScores(${key})",
    getResearchBuilderThreadsOne: "/api/v1/ResearchBuilderThreads(${key})",
    getResponsesOne: "/api/v1/Responses(${key})",
    getSegmentsOne: "/api/v1/Segments(${key})",
    getStandardQuestionsOne: "/api/v1/StandardQuestions(${key})",
    getSurveyRunRespondentsCsvEditThreadsOne: "/api/v1/SurveyRunRespondentsCsvEditThreads(${key})",
    getSurveyRunsOne: "/api/v1/SurveyRuns(${key})",
    getSurveySessionsOne: "/api/v1/SurveySessions(${key})",
    getSystemQuestionOne: "/api/v1/SystemQuestion(${key})",
    getSystemQuestionOptionOne: "/api/v1/SystemQuestionOption(${key})",
    getTargetsOne: "/api/v1/Targets(${key})",
    getTeamsOne: "/api/v1/Teams(${key})",
    getTestOptionsOne: "/api/v1/TestOptions(${key})",
    getTextResponsesOne: "/api/v1/TextResponses(${key})",
    getTextResponsesThemesOne: "/api/v1/TextResponsesThemes(${key})",
    getThemesOne: "/api/v1/Themes(${key})",
    getThemeSentimentsOne: "/api/v1/ThemeSentiments(${key})",
    getTranslatedTextRegionsOne: "/api/v1/TranslatedTextRegions(${key})",
    getuAndATypesOne: "/api/v1/UAndATypes(${key})",
    getUserAndClientsOne: "/api/v1/UserAndClients(${key})",
    getUserClientRolesOne: "/api/v1/UserClientRoles(${key})",
    getUserDataExportsOne: "/api/v1/UserDataExports(${key})",
    getUserRolesOne: "/api/v1/UserRoles(${key})",
    getUsersOne: "/api/v1/Users(${key})",
  };
  export interface ApiGetOneErrorTypes {
    getAiBatchesOne: any;
    getAiBatchGroupsOne: any;
    getAiBatchItemsOne: any;
    getAiBatchRunItemsOne: any;
    getAiBatchRunsOne: any;
    getAiConversationEvaluationsOne: any;
    getAiConversationsOne: any;
    getAiMessagesOne: any;
    getAiModelDefinitionsOne: any;
    getAiProjectGroupSummariesOne: any;
    getAiProjectSummariesOne: any;
    getAiProvidersOne: any;
    getAiServicesOne: any;
    getAiThreadsOne: any;
    getAmaThreadsOne: any;
    getApiKeysOne: any;
    getCategoriesOne: any;
    getClientFeaturesOne: any;
    getClientQuestionTemplatesOne: any;
    getClientsOne: any;
    getCognitoIdpsOne: any;
    getCognitoUsersOne: any;
    getCreditLogsOne: any;
    getCreditLogTypesOne: any;
    getDataEventsLogOne: any;
    getDemandZoneCellsOne: any;
    getDemandZonesOne: any;
    getDiagnoseScoreThemesOne: any;
    getDisplayScheduleExceptionsOne: any;
    getDisplaySchedulesOne: any;
    getDocumentsOne: any;
    getDocumentVersionsOne: any;
    getEnterprisesOne: any;
    getEstimatedProjectDurationOne: any;
    getExtendedTeamsOne: any;
    getExtrapolatedUserAndClientsOne: any;
    getFeatureFlagsOne: any;
    getFrameworksOne: any;
    getHubspotRolesOne: any;
    getLinkedClientsOne: any;
    getLinkInvitesOne: any;
    getNotificationsOne: any;
    getNotificationTypesOne: any;
    getOrgsOne: any;
    getProjectCommentsOne: any;
    getProjectEmailSummariesOne: any;
    getProjectFactsOne: any;
    getProjectFilesOne: any;
    getProjectFindingsOne: any;
    getProjectGroupQuestionsOne: any;
    getProjectGroupsOne: any;
    getProjectGroupSegmentsOne: any;
    getProjectGroupTagsOne: any;
    getProjectNarrativesOne: any;
    getProjectNarrativeSectionsOne: any;
    getProjectNarrativeVersionExportsOne: any;
    getProjectNarrativeVersionsOne: any;
    getProjectObjectivesOne: any;
    getProjectQuestionsOne: any;
    getProjectsOne: any;
    getProjectsAiBatchGroupOne: any;
    getProjectSchedulesOne: any;
    getProjectSharesOne: any;
    getProjectsRegionsOne: any;
    getProjectStatusesOne: any;
    getProjectSurveySessionsOne: any;
    getProjectWatchersOne: any;
    getProjectWeeksOne: any;
    getPromptEvaluationsOne: any;
    getPromptsOne: any;
    getPromptVersionsOne: any;
    getQuestionOptionsOne: any;
    getQuestionsOne: any;
    getQuestionTemplatesOne: any;
    getRegionsOne: any;
    getRegressionScoresOne: any;
    getResearchBuilderThreadsOne: any;
    getResponsesOne: any;
    getSegmentsOne: any;
    getStandardQuestionsOne: any;
    getSurveyRunRespondentsCsvEditThreadsOne: any;
    getSurveyRunsOne: any;
    getSurveySessionsOne: any;
    getSystemQuestionOne: any;
    getSystemQuestionOptionOne: any;
    getTargetsOne: any;
    getTeamsOne: any;
    getTestOptionsOne: any;
    getTextResponsesOne: any;
    getTextResponsesThemesOne: any;
    getThemesOne: any;
    getThemeSentimentsOne: any;
    getTranslatedTextRegionsOne: any;
    getuAndATypesOne: any;
    getUserAndClientsOne: any;
    getUserClientRolesOne: any;
    getUserDataExportsOne: any;
    getUserRolesOne: any;
    getUsersOne: any;
  }
  export type ApiGetOneParams = {
    getAiBatchesOne: { key: number };
    getAiBatchGroupsOne: { key: number };
    getAiBatchItemsOne: { key: number };
    getAiBatchRunItemsOne: { key: number };
    getAiBatchRunsOne: { key: number };
    getAiConversationEvaluationsOne: { key: number };
    getAiConversationsOne: { key: number };
    getAiMessagesOne: { key: number };
    getAiModelDefinitionsOne: { key: number };
    getAiProjectGroupSummariesOne: { key: number };
    getAiProjectSummariesOne: { key: number };
    getAiProvidersOne: { key: number };
    getAiServicesOne: { key: number };
    getAiThreadsOne: { key: number };
    getAmaThreadsOne: { key: number };
    getApiKeysOne: { key: number };
    getCategoriesOne: { key: number };
    getClientFeaturesOne: { key: number };
    getClientQuestionTemplatesOne: { key: number };
    getClientsOne: { key: number };
    getCognitoIdpsOne: { key: number };
    getCognitoUsersOne: { key: number };
    getCreditLogsOne: { key: number };
    getCreditLogTypesOne: { key: number };
    getDataEventsLogOne: { key: number };
    getDemandZoneCellsOne: { key: number };
    getDemandZonesOne: { key: number };
    getDiagnoseScoreThemesOne: { key: number };
    getDisplayScheduleExceptionsOne: { key: number };
    getDisplaySchedulesOne: { key: number };
    getDocumentsOne: { key: number };
    getDocumentVersionsOne: { key: number };
    getEnterprisesOne: { key: number };
    getEstimatedProjectDurationOne: { key: number };
    getExtendedTeamsOne: { key: number };
    getExtrapolatedUserAndClientsOne: { key: number };
    getFeatureFlagsOne: { key: number };
    getFrameworksOne: { key: number };
    getHubspotRolesOne: { key: number };
    getLinkedClientsOne: { key: number };
    getLinkInvitesOne: { key: number };
    getNotificationsOne: { key: number };
    getNotificationTypesOne: { key: number };
    getOrgsOne: { key: number };
    getProjectCommentsOne: { key: number };
    getProjectEmailSummariesOne: { key: number };
    getProjectFactsOne: { key: number };
    getProjectFilesOne: { key: number };
    getProjectFindingsOne: { key: number };
    getProjectGroupQuestionsOne: { key: number };
    getProjectGroupsOne: { key: number };
    getProjectGroupSegmentsOne: { key: number };
    getProjectGroupTagsOne: { key: number };
    getProjectNarrativesOne: { key: number };
    getProjectNarrativeSectionsOne: { key: number };
    getProjectNarrativeVersionExportsOne: { key: number };
    getProjectNarrativeVersionsOne: { key: number };
    getProjectObjectivesOne: { key: number };
    getProjectQuestionsOne: {
      options?: any;
    } & { key: number };
    getProjectsOne: {
      options?: any;
    } & { key: number };
    getProjectsAiBatchGroupOne: { key: number };
    getProjectSchedulesOne: { key: number };
    getProjectSharesOne: { key: number };
    getProjectsRegionsOne: { key: number };
    getProjectStatusesOne: { key: number };
    getProjectSurveySessionsOne: { key: number };
    getProjectWatchersOne: { key: number };
    getProjectWeeksOne: { key: number };
    getPromptEvaluationsOne: { key: number };
    getPromptsOne: { key: number };
    getPromptVersionsOne: { key: number };
    getQuestionOptionsOne: { key: number };
    getQuestionsOne: {
      options?: any;
    } & { key: number };
    getQuestionTemplatesOne: {
      options?: any;
    } & { key: number };
    getRegionsOne: { key: number };
    getRegressionScoresOne: { key: number };
    getResearchBuilderThreadsOne: { key: number };
    getResponsesOne: { key: number };
    getSegmentsOne: { key: number };
    getStandardQuestionsOne: { key: number };
    getSurveyRunRespondentsCsvEditThreadsOne: { key: number };
    getSurveyRunsOne: { key: number };
    getSurveySessionsOne: { key: number };
    getSystemQuestionOne: { key: number };
    getSystemQuestionOptionOne: { key: number };
    getTargetsOne: { key: number };
    getTeamsOne: { key: number };
    getTestOptionsOne: {
      options?: any;
    } & { key: number };
    getTextResponsesOne: { key: number };
    getTextResponsesThemesOne: { key: number };
    getThemesOne: { key: number };
    getThemeSentimentsOne: { key: number };
    getTranslatedTextRegionsOne: { key: number };
    getuAndATypesOne: { key: number };
    getUserAndClientsOne: { key: number };
    getUserClientRolesOne: { key: number };
    getUserDataExportsOne: {
      options?: any;
    } & { key: number };
    getUserRolesOne: { key: number };
    getUsersOne: { key: number };
  };

  export interface AuthGetPathTypes {}
  export interface AuthGetErrorTypes {}
  export const authGetPaths: { [key in keyof AuthGetPathTypes]: string } = {};
  export type AuthGetParams = {};

  export interface AuthGetOnePathTypes {}
  export const authGetOnePaths: { [key in keyof AuthGetOnePathTypes]: string } = {};
  export interface AuthGetOneErrorTypes {}
  export type AuthGetOneParams = {};

  export type ApiPostRequestBody = {
    postAiBatches: CreateAiBatchDto;
    actAiBatchesAddItems: AddAiBatchItemsDto;
    actAiBatchesRun: RunAiBatchDto;
    actAiConversationsAddUserMessage: AddUserMessageDto;
    actAiConversationsContinueConversation: ContinueConversationDto;
    postAiMessages: CreateUserAiMessageDto;
    actAiMessagesSendFeedback: SetFeedbackAiMessageDto;
    actAiMessagesMarkActionTaken: MarkActionTakenAiMessageDto;
    postAiModelDefinitions: CreateAiModelDefinitionDto;
    postAiProjectGroupSummaries: CreateAiProjectGroupSummaryDto;
    postAiProjectSummaries: CreateAiProjectSummaryDto;
    postAmaThreads: CreateAmaThreadDto;
    postApiKeys: CreateApiKeyDto;
    postClientFeatures: ClientFeatureDto;
    actClientsAdminUpdate: AdminUpdateClientDto;
    actClientsSetupTrialAccount: GenerateTrialClientJobPayload;
    actClientsSaveLogo: SaveLogoRequest;
    actCognitoIdpsCreateSaml: CreateSamlCognitoIdpDto;
    actCognitoIdpsUpdateSaml: UpdateSamlCognitoIdpDto;
    postCreditLogs: CreateCreditLogDto;
    actCreditLogsMakeCreditTransfer: MakeCreditTransferDto;
    postDemandZoneCells: CreateDemandZoneCellJobPayload;
    postDemandZones: CreateDemandZoneJobPayload;
    actDemandZonesRegenerate: DemandZoneRegenerateDto;
    actDemandZonesRegenerateOccasionNet: DemandZoneRegenerateDto;
    actDemandZonesSetOccasionNet: SetOccasionNetsJobPayload;
    actDemandZonesSyncDemandZones: DemandZonesSyncDto;
    postDisplayScheduleExceptions: CreateEditDisplayScheduleExceptionDto;
    postDisplaySchedules: CreateEditDisplayScheduleDto;
    postDocuments: CreateDocumentDto;
    postDocumentVersions: CreateDocumentVersionDto;
    postEnterprises: CreateEnterpriseDto;
    actExportsExportToExcel: ExportTableToExcelRequest;
    postLinkInvites: CreateLinkInviteDto;
    actLinkInvitesAcceptShare: AcceptLinkInviteShareJobPayload;
    postNotifications: NotificationDelta;
    postOrgs: CreateOrgDto;
    actOrgsRename: RenameOrgDto;
    postProjectComments: CreateProjectCommentDto;
    postProjectFiles: CreateProjectFileDto;
    actProjectGroupQuestionsSortOrderChange: ProjectGroupQuestionOrders;
    postProjectGroups: ProjectGroupCreateDto;
    actProjectGroupsShare: ProjectGroupShareDto;
    actProjectGroupsUnshare: ProjectGroupShareDto;
    actProjectGroupsGenerateSummaries: ProjectGroupGenerateSummariesDto;
    actProjectGroupsDuplicate: DuplicateProjectGroupDto;
    postProjectGroupSegments: CreateProjectGroupSegmentDto;
    actProjectGroupSegmentsBulkUpdate: PatchProjectGroupSegmentDto[];
    postProjectGroupTags: ProjectGroupTagDto;
    actProjectNarrativeSectionsCreate: CreateProjectNarrativeSectionDto;
    actProjectNarrativeVersionsGenerateSlideDeck: GenerateSlideDeckRequestDto;
    postProjectObjectives: CreateProjectObjectiveDto;
    actProjectQuestionsSortOrderChange: QuestionOrders;
    actProjectsDuplicate: DuplicateDto;
    actProjectsShare: ShareProjectDto;
    postProjects: ProjectCreateDto;
    actProjectsAdminEdit: AdminEditProjectDto;
    actProjectsRemoveFromSurveyRun: RemoveFromSurveyRunDto;
    actProjectsChangeTargets: UpdateProjectTargetsDto;
    actProjectsUpsertSchedule: AddScheduleDto;
    actProjectsUpdatePriceSensitivities: UpdateProjectPriceSensitivitiesDto;
    actProjectsUpdateMarketReach: UpdateMarketReachDto;
    actProjectsUpdateProjectScheduling: UpdateProjectSchedulingDto;
    actProjectsCreatePriceSensitivities: CreateProjectPriceSensitivitiesDto;
    actProjectsDeletePriceSensitivities: DeleteProjectPriceSensitivitiesDto;
    actProjectsDeleteRegions: UpdateProjectRegionsDto;
    actProjectsIncidenceEstimate: UpdateProjectIncidenceEstimateDto;
    actProjectsDecline: ProjectDeclinedDto;
    actProjectsCloseProjectSurvey: CloseProjectSurveyDto;
    actProjectsPowerPointExport: ExportPowerPointDto;
    actProjectsExportPlanDocument: ExportPlanDocumentDto;
    actProjectsUpdateWatchers: UpdateProjectWatchersDto;
    actProjectsStartWatching: CreateProjectWatcherDto;
    actProjectsMove: MoveProjectDto;
    actProjectsCreateUsageAndAttitudeSeedProject: CreateUsageAndAttitudeSeedProjectJobPayload;
    actProjectsUpdateGroupTags: UpdateGroupTagsDto;
    actProjectsUpdateProjectOwner: UpdateProjectOwnerDto;
    actProjectsDocumentToProject: ProjectToDocumentDto;
    actProjectsReTheme: ReThemeProjectDto;
    actProjectsSetCustomMetrics: QuestionListDto;
    actProjectsRunFactsFindings: RunProjectFactsFindingsDto;
    actProjectsChangeFramework: ChangeProjectFrameworkDto;
    actProjectsSynthAssignProjectToGroup: SynthAssignProjectToGroupDto;
    actProjectsBackfillResearchObjectives: BackfillResearchObjectivesDto;
    actProjectsGenerateFilterSets: GenerateFilterSetsDto;
    postProjectSchedules: CreateProjectSchedulesDto;
    actProjectSchedulesSyncDates: SyncProjectScheduleDto;
    actProjectSchedulesSyncNpdDates: SyncProjectScheduleDto;
    actProjectSchedulesCreateManualSchedule: ManualSurveyScheduleDto;
    postProjectShares: CreateProjectShareDto;
    postPromptEvaluations: CreatePromptEvaluationDto;
    postPrompts: CreatePromptDto;
    actPromptsAssignEvaluations: AssignPromptEvaluationsDto;
    postPromptVersions: CreatePromptVersionDto;
    actPromptVersionsRun: RunPromptVersionDto;
    actPromptVersionsImportFromYml: ImportPromptVersionFromYmlDto;
    actPromptVersionsImportFromJson: ImportPromptVersionFromJsonDto;
    postQuestions: QuestionCreateDto;
    postQuestionTemplates: AddQuestionTemplateJobPayload;
    postResearchBuilderThreads: CreateResearchBuilderThreadDto;
    actResearchBuilderThreadsAcceptFrameworkAndBuild: AcceptFrameworkAndBuildDto;
    actResearchBuilderThreadsCreateFile: CreateResearchBuilderThreadFileDto;
    actResearchBuilderThreadsUpdatePreSelectedFramework: UpdatePreSelectedFrameworkDto;
    postSegments: CreateSegmentDto;
    actSurveyRunsCreateRespondentsCsvEditThread: CreateSurveyRunRespondentsCsvEditThreadDto;
    actSurveyRunsApplyRespondentsCsvEditProposal: ApplyRespondentsCsvEditProposalDto;
    actSurveyRunsRunSyntheticSurvey: RunSyntheticSurveyDto;
    actSurveyRunsCreateSurveys: CreateSurveysDto;
    actSurveyRunsForceCloseSurvey: ForceCloseSurveyDto;
    actSurveyRunsStartSurveyProcessing: StartSurveyProcessingDto;
    actSurveyRunsDecipherRespondents: FetchDecipherRespondentsDto;
    actSurveyRunsValidateStagedRespondentsCsv: StagedRespondentsCsvDto;
    actSurveyRunsReplaceRespondentsCsvFromStaging: StagedRespondentsCsvDto;
    actSurveyRunsRemoveUuidsFromSurvey: RemoveUuidsFromSurveyDto;
    actSurveyRunsRunSimulatedData: RunDecipherSimulatedDataDto;
    actSurveyRunsCreateManualRespondentsCsvProposal: CreateManualRespondentsCsvProposalDto;
    actSurveyRunsUpdateRespondentsCsvProposal: UpdateRespondentsCsvProposalDto;
    postTeams: CreateTeamDto;
    actTeamsRename: RenameTeamDto;
    actTeamsUpdateAutoProjectWatch: UpdateAutoProjectWatchDto;
    postTestOptions: TestOptionEditDto;
    actTextResponsesReassignThemes: ReassignThemesDto;
    actTranslatedTextRegionsAddDemographicTranslations: AdminAddDemographicTranslationsDto;
    postUsers: UserCreateDto;
    actUsersRemoveFromAccount: RemoveUserFromAccountDto;
    actUsersSetNames: UserChangeNameDto;
    actUsersSetPassword: UserChangePasswordDto;
    actUsersResendInvite: ResendInviteDto;
    actUsersSetHubspotRole: UserChangeHubspotRoleDto;
    actUsersSetResearchSetupConfidence: UserChangeResearchSetupConfidenceDto;
    actUsersSetResearchInterpretationConfidence: UserChangeResearchInterpretationConfidenceDto;
    actUsersSuperAdminUserCreate: AdminUserCreateDto;
    actUsersSuperAdminUserUpdate: AdminUserUpdateDto;
    actUsersBulkInvite: BulkInviteDto;
    actUsersParseInviteFile: ParseInviteFileDto;
  };

  export interface ApiPostPathTypes {
    postAiBatches: AiBatch;
    postAiMessages: AiMessage;
    postAiModelDefinitions: AiModelDefinition;
    postAiProjectGroupSummaries: boolean;
    postAiProjectSummaries: boolean;
    postAmaThreads: AmaThread;
    postApiKeys: ApiKeyCreationResultDto;
    postClientFeatures: ClientFeature;
    postCreditLogs: CreditLog;
    postDemandZoneCells: boolean;
    postDemandZones: boolean;
    postDisplayScheduleExceptions: DisplayScheduleException;
    postDisplaySchedules: DisplaySchedule;
    postDocuments: Document;
    postDocumentVersions: DocumentVersion;
    postEnterprises: Enterprise;
    postLinkInvites: LinkInvite;
    postNotifications: Notification;
    postOrgs: Org;
    postProjectComments: ProjectComment;
    postProjectFiles: ProjectFile;
    postProjectGroups: ProjectGroup;
    postProjectGroupSegments: ProjectGroupSegment;
    postProjectGroupTags: ProjectGroupTag;
    postProjectObjectives: ProjectObjective;
    postProjects: ProjectDto;
    postProjectSchedules: ProjectSchedule;
    postProjectShares: ProjectShare;
    postPromptEvaluations: PromptEvaluation;
    postPrompts: Prompt;
    postPromptVersions: PromptVersion;
    postQuestions: QuestionDto;
    postQuestionTemplates: QuestionTemplateDto;
    postResearchBuilderThreads: ResearchBuilderThread;
    postSegments: Segment;
    postTeams: Team;
    postTestOptions: TestOption;
    postUsers: User;
  }
  export interface ApiPostErrorTypes {
    postAiBatches: any;
    postAiMessages: any;
    postAiModelDefinitions: any;
    postAiProjectGroupSummaries: any;
    postAiProjectSummaries: any;
    postAmaThreads: any;
    postApiKeys: any;
    postClientFeatures: any;
    postCreditLogs: any;
    postDemandZoneCells: any;
    postDemandZones: any;
    postDisplayScheduleExceptions: any;
    postDisplaySchedules: any;
    postDocuments: any;
    postDocumentVersions: any;
    postEnterprises: any;
    postLinkInvites: any;
    postNotifications: any;
    postOrgs: any;
    postProjectComments: any;
    postProjectFiles: any;
    postProjectGroups: any;
    postProjectGroupSegments: any;
    postProjectGroupTags: any;
    postProjectObjectives: any;
    postProjects: any;
    postProjectSchedules: any;
    postProjectShares: any;
    postPromptEvaluations: any;
    postPrompts: any;
    postPromptVersions: any;
    postQuestions: any;
    postQuestionTemplates: any;
    postResearchBuilderThreads: any;
    postSegments: any;
    postTeams: any;
    postTestOptions: any;
    postUsers: any;
  }
  export const apiPostPaths: { [key in keyof ApiPostPathTypes]: string } = {
    postAiBatches: "/api/v1/AiBatches",
    postAiMessages: "/api/v1/AiMessages",
    postAiModelDefinitions: "/api/v1/AiModelDefinitions",
    postAiProjectGroupSummaries: "/api/v1/AiProjectGroupSummaries",
    postAiProjectSummaries: "/api/v1/AiProjectSummaries",
    postAmaThreads: "/api/v1/AmaThreads",
    postApiKeys: "/api/v1/ApiKeys",
    postClientFeatures: "/api/v1/ClientFeatures",
    postCreditLogs: "/api/v1/CreditLogs",
    postDemandZoneCells: "/api/v1/DemandZoneCells",
    postDemandZones: "/api/v1/DemandZones",
    postDisplayScheduleExceptions: "/api/v1/DisplayScheduleExceptions",
    postDisplaySchedules: "/api/v1/DisplaySchedules",
    postDocuments: "/api/v1/Documents",
    postDocumentVersions: "/api/v1/DocumentVersions",
    postEnterprises: "/api/v1/Enterprises",
    postLinkInvites: "/api/v1/LinkInvites",
    postNotifications: "/api/v1/Notifications",
    postOrgs: "/api/v1/Orgs",
    postProjectComments: "/api/v1/ProjectComments",
    postProjectFiles: "/api/v1/ProjectFiles",
    postProjectGroups: "/api/v1/ProjectGroups",
    postProjectGroupSegments: "/api/v1/ProjectGroupSegments",
    postProjectGroupTags: "/api/v1/ProjectGroupTags",
    postProjectObjectives: "/api/v1/ProjectObjectives",
    postProjects: "/api/v1/Projects",
    postProjectSchedules: "/api/v1/ProjectSchedules",
    postProjectShares: "/api/v1/ProjectShares",
    postPromptEvaluations: "/api/v1/PromptEvaluations",
    postPrompts: "/api/v1/Prompts",
    postPromptVersions: "/api/v1/PromptVersions",
    postQuestions: "/api/v1/Questions",
    postQuestionTemplates: "/api/v1/QuestionTemplates",
    postResearchBuilderThreads: "/api/v1/ResearchBuilderThreads",
    postSegments: "/api/v1/Segments",
    postTeams: "/api/v1/Teams",
    postTestOptions: "/api/v1/TestOptions",
    postUsers: "/api/v1/Users",
  };
  export type ApiPostParams = {
    postAiBatches: {};
    postAiMessages: {};
    postAiModelDefinitions: {};
    postAiProjectGroupSummaries: {};
    postAiProjectSummaries: {};
    postAmaThreads: {};
    postApiKeys: {};
    postClientFeatures: {};
    postCreditLogs: {};
    postDemandZoneCells: {};
    postDemandZones: {};
    postDisplayScheduleExceptions: {};
    postDisplaySchedules: {};
    postDocuments: {};
    postDocumentVersions: {};
    postEnterprises: {};
    postLinkInvites: {};
    postNotifications: {};
    postOrgs: {};
    postProjectComments: {};
    postProjectFiles: {};
    postProjectGroups: {};
    postProjectGroupSegments: {};
    postProjectGroupTags: {};
    postProjectObjectives: {};
    postProjects: {
      options?: any;
    };
    postProjectSchedules: {};
    postProjectShares: {};
    postPromptEvaluations: {};
    postPrompts: {};
    postPromptVersions: {};
    postQuestions: {
      options?: any;
    };
    postQuestionTemplates: {};
    postResearchBuilderThreads: {};
    postSegments: {};
    postTeams: {};
    postTestOptions: {
      options?: any;
    };
    postUsers: {};
  };

  export interface ApiPostOnePathTypes {}
  export const apiPostOnePaths: { [key in keyof ApiPostOnePathTypes]: string } = {};
  export interface ApiPostOneErrorTypes {}
  export type ApiPostOneParams = {};

  export type AuthPostRequestBody = {
    actLoginVerifyRegistrationEmail: ConfirmUserEmailJobPayload;
    actLoginAcceptInvitation: AcceptInvitationDto;
    actLoginPasswordLogin: PasswordLoginDto;
    actLoginNewPasswordRequired: NewPasswordRequiredDto;
    actLoginForgotPassword: ForgotPasswordDto;
    actLoginResetPassword: ResetPasswordDto;
  };

  export interface AuthPostPathTypes {}
  export interface AuthPostErrorTypes {}
  export const authPostPaths: { [key in keyof AuthPostPathTypes]: string } = {};
  export type AuthPostParams = {};

  export interface AuthPostOnePathTypes {}
  export const authPostOnePaths: { [key in keyof AuthPostOnePathTypes]: string } = {};
  export interface AuthPostOneErrorTypes {}
  export type AuthPostOneParams = {};

  export type ApiDeleteRequestBody = {};

  export interface ApiDeletePathTypes {}
  export interface ApiDeleteErrorTypes {}
  export const apiDeletePaths: { [key in keyof ApiDeletePathTypes]: string } = {};
  export type ApiDeleteParams = {};

  export interface ApiDeleteOnePathTypes {
    deleteAiBatchesOne: boolean;
    deleteAiBatchItemsOne: boolean;
    deleteAiBatchRunsOne: boolean;
    deleteApiKeysOne: boolean;
    deleteClientFeaturesOne: ClientFeature;
    deleteClientsOne: boolean;
    deleteCognitoIdpsOne: boolean;
    deleteCreditLogsOne: boolean;
    deleteDemandZoneCellsOne: boolean;
    deleteDemandZonesOne: boolean;
    deleteDisplayScheduleExceptionsOne: boolean;
    deleteDisplaySchedulesOne: boolean;
    deleteDocumentsOne: boolean;
    deleteDocumentVersionsOne: boolean;
    deleteLinkInvitesOne: boolean;
    deleteProjectCommentsOne: boolean;
    deleteProjectFilesOne: boolean;
    deleteProjectGroupQuestionsOne: boolean;
    deleteProjectGroupsOne: boolean;
    deleteProjectGroupSegmentsOne: ProjectGroupSegment;
    deleteProjectNarrativeSectionsOne: void;
    deleteProjectObjectivesOne: boolean;
    deleteProjectQuestionsOne: boolean;
    deleteProjectsOne: boolean;
    deleteProjectSchedulesOne: boolean;
    deleteProjectSharesOne: boolean;
    deletePromptsOne: boolean;
    deletePromptVersionsOne: boolean;
    deleteQuestionTemplatesOne: QuestionTemplateDto;
    deleteSegmentsOne: boolean;
    deleteSurveyRunsOne: boolean;
    deleteTestOptionsOne: Boolean;
    deleteTextResponsesOne: boolean;
    deleteUsersOne: User;
  }
  export const apiDeleteOnePaths: { [key in keyof ApiDeleteOnePathTypes]: string } = {
    deleteAiBatchesOne: "/api/v1/AiBatches(${key})",
    deleteAiBatchItemsOne: "/api/v1/AiBatchItems(${key})",
    deleteAiBatchRunsOne: "/api/v1/AiBatchRuns(${key})",
    deleteApiKeysOne: "/api/v1/ApiKeys(${key})",
    deleteClientFeaturesOne: "/api/v1/ClientFeatures(${key})",
    deleteClientsOne: "/api/v1/Clients(${key})",
    deleteCognitoIdpsOne: "/api/v1/CognitoIdps(${key})",
    deleteCreditLogsOne: "/api/v1/CreditLogs(${key})",
    deleteDemandZoneCellsOne: "/api/v1/DemandZoneCells(${key})",
    deleteDemandZonesOne: "/api/v1/DemandZones(${key})",
    deleteDisplayScheduleExceptionsOne: "/api/v1/DisplayScheduleExceptions(${key})",
    deleteDisplaySchedulesOne: "/api/v1/DisplaySchedules(${key})",
    deleteDocumentsOne: "/api/v1/Documents(${key})",
    deleteDocumentVersionsOne: "/api/v1/DocumentVersions(${key})",
    deleteLinkInvitesOne: "/api/v1/LinkInvites(${key})",
    deleteProjectCommentsOne: "/api/v1/ProjectComments(${key})",
    deleteProjectFilesOne: "/api/v1/ProjectFiles(${key})",
    deleteProjectGroupQuestionsOne: "/api/v1/ProjectGroupQuestions(${key})",
    deleteProjectGroupsOne: "/api/v1/ProjectGroups(${key})",
    deleteProjectGroupSegmentsOne: "/api/v1/ProjectGroupSegments(${key})",
    deleteProjectNarrativeSectionsOne: "/api/v1/ProjectNarrativeSections(${key})",
    deleteProjectObjectivesOne: "/api/v1/ProjectObjectives(${key})",
    deleteProjectQuestionsOne: "/api/v1/ProjectQuestions(${key})",
    deleteProjectsOne: "/api/v1/Projects(${key})",
    deleteProjectSchedulesOne: "/api/v1/ProjectSchedules(${key})",
    deleteProjectSharesOne: "/api/v1/ProjectShares(${key})",
    deletePromptsOne: "/api/v1/Prompts(${key})",
    deletePromptVersionsOne: "/api/v1/PromptVersions(${key})",
    deleteQuestionTemplatesOne: "/api/v1/QuestionTemplates(${key})",
    deleteSegmentsOne: "/api/v1/Segments(${key})",
    deleteSurveyRunsOne: "/api/v1/SurveyRuns(${key})",
    deleteTestOptionsOne: "/api/v1/TestOptions(${key})",
    deleteTextResponsesOne: "/api/v1/TextResponses(${key})",
    deleteUsersOne: "/api/v1/Users(${key})",
  };
  export interface ApiDeleteOneErrorTypes {
    deleteAiBatchesOne: any;
    deleteAiBatchItemsOne: any;
    deleteAiBatchRunsOne: any;
    deleteApiKeysOne: any;
    deleteClientFeaturesOne: any;
    deleteClientsOne: any;
    deleteCognitoIdpsOne: any;
    deleteCreditLogsOne: any;
    deleteDemandZoneCellsOne: any;
    deleteDemandZonesOne: any;
    deleteDisplayScheduleExceptionsOne: any;
    deleteDisplaySchedulesOne: any;
    deleteDocumentsOne: any;
    deleteDocumentVersionsOne: any;
    deleteLinkInvitesOne: any;
    deleteProjectCommentsOne: any;
    deleteProjectFilesOne: any;
    deleteProjectGroupQuestionsOne: any;
    deleteProjectGroupsOne: any;
    deleteProjectGroupSegmentsOne: any;
    deleteProjectNarrativeSectionsOne: any;
    deleteProjectObjectivesOne: any;
    deleteProjectQuestionsOne: any;
    deleteProjectsOne: any;
    deleteProjectSchedulesOne: any;
    deleteProjectSharesOne: any;
    deletePromptsOne: any;
    deletePromptVersionsOne: any;
    deleteQuestionTemplatesOne: any;
    deleteSegmentsOne: any;
    deleteSurveyRunsOne: any;
    deleteTestOptionsOne: any;
    deleteTextResponsesOne: any;
    deleteUsersOne: any;
  }
  export type ApiDeleteOneParams = {
    deleteAiBatchesOne: { key: number };
    deleteAiBatchItemsOne: { key: number };
    deleteAiBatchRunsOne: { key: number };
    deleteApiKeysOne: { key: number };
    deleteClientFeaturesOne: { key: number };
    deleteClientsOne: { key: number };
    deleteCognitoIdpsOne: { key: number };
    deleteCreditLogsOne: { key: number };
    deleteDemandZoneCellsOne: { key: number };
    deleteDemandZonesOne: { key: number };
    deleteDisplayScheduleExceptionsOne: { key: number };
    deleteDisplaySchedulesOne: { key: number };
    deleteDocumentsOne: { key: number };
    deleteDocumentVersionsOne: { key: number };
    deleteLinkInvitesOne: { key: number };
    deleteProjectCommentsOne: { key: number };
    deleteProjectFilesOne: { key: number };
    deleteProjectGroupQuestionsOne: { key: number };
    deleteProjectGroupsOne: { key: number };
    deleteProjectGroupSegmentsOne: { key: number };
    deleteProjectNarrativeSectionsOne: { key: number };
    deleteProjectObjectivesOne: { key: number };
    deleteProjectQuestionsOne: { key: number };
    deleteProjectsOne: { key: number };
    deleteProjectSchedulesOne: { key: number };
    deleteProjectSharesOne: { key: number };
    deletePromptsOne: { key: number };
    deletePromptVersionsOne: { key: number };
    deleteQuestionTemplatesOne: { key: number };
    deleteSegmentsOne: { key: number };
    deleteSurveyRunsOne: { key: number };
    deleteTestOptionsOne: { key: number };
    deleteTextResponsesOne: { key: number };
    deleteUsersOne: { key: number };
  };

  export type AuthDeleteRequestBody = {};

  export interface AuthDeletePathTypes {}
  export interface AuthDeleteErrorTypes {}
  export const authDeletePaths: { [key in keyof AuthDeletePathTypes]: string } = {};
  export type AuthDeleteParams = {};

  export interface AuthDeleteOnePathTypes {}
  export const authDeleteOnePaths: { [key in keyof AuthDeleteOnePathTypes]: string } = {};
  export interface AuthDeleteOneErrorTypes {}
  export type AuthDeleteOneParams = {};

  export type ApiPatchRequestBody = {
    patchAiBatchesOne: UpdateAiBatchDto;
    patchAiModelDefinitionsOne: UpdateAiModelDefinitionDto;
    patchAmaThreadsOne: UpdateAmaThreadDto;
    patchClientsOne: UpdateClientDto;
    patchCreditLogsOne: UpdateCreditLogDto;
    patchDemandZoneCellsOne: DemandZoneCellUpdateDto;
    patchDemandZonesOne: DemandZoneUpdateDto;
    patchDisplayScheduleExceptionsOne: CreateEditDisplayScheduleExceptionDto;
    patchDisplaySchedulesOne: CreateEditDisplayScheduleDto;
    patchDocumentVersionsOne: DocumentVersionDelta;
    patchFeatureFlagsOne: UpdateFeatureFlagDto;
    patchOrgsOne: UpdateOrgDto;
    patchProjectCommentsOne: EditProjectCommentDto;
    patchProjectGroupQuestionsOne: UpdateProjectGroupQuestionDto;
    patchProjectGroupsOne: ProjectGroupPatchDto;
    patchProjectGroupSegmentsOne: PatchProjectGroupSegmentDto;
    patchProjectGroupTagsOne: ProjectGroupTagDto;
    patchProjectNarrativesOne: PatchProjectNarrativeDto;
    patchProjectNarrativeSectionsOne: PatchProjectNarrativeSectionDto;
    patchProjectsOne: ProjectDtoDelta;
    patchProjectSchedulesOne: UpdateProjectScheduleDto;
    patchPromptEvaluationsOne: UpdatePromptEvaluationDto;
    patchPromptsOne: UpdatePromptDto;
    patchPromptVersionsOne: PromptVersionDelta;
    patchQuestionsOne: QuestionCreateDto;
    patchRegionsOne: RegionDelta;
    patchResearchBuilderThreadsOne: UpdateResearchBuilderThreadDto;
    patchSegmentsOne: PatchSegmentDto;
    patchTeamsOne: UpdateTeamDto;
    patchTestOptionsOne: TestOptionEditDto;
    patchTranslatedTextRegionsOne: UpdateTranslatedTextRegionDto;
    patchUsersOne: UserUpdateDto;
  };

  export interface ApiPatchPathTypes {}
  export interface ApiPatchErrorTypes {}
  export const apiPatchPaths: { [key in keyof ApiPatchPathTypes]: string } = {};
  export type ApiPatchParams = {};

  export interface ApiPatchOnePathTypes {
    patchAiBatchesOne: AiBatch;
    patchAiModelDefinitionsOne: AiModelDefinition;
    patchAmaThreadsOne: AmaThread;
    patchClientsOne: Client;
    patchCreditLogsOne: CreditLog;
    patchDemandZoneCellsOne: boolean;
    patchDemandZonesOne: boolean;
    patchDisplayScheduleExceptionsOne: DisplayScheduleException;
    patchDisplaySchedulesOne: DisplaySchedule;
    patchDocumentVersionsOne: DocumentVersion;
    patchFeatureFlagsOne: FeatureFlag;
    patchOrgsOne: Org;
    patchProjectCommentsOne: ProjectComment;
    patchProjectGroupQuestionsOne: ProjectGroupsQuestion;
    patchProjectGroupsOne: ProjectGroup;
    patchProjectGroupSegmentsOne: ProjectGroupSegment;
    patchProjectGroupTagsOne: ProjectGroupTag;
    patchProjectNarrativesOne: ProjectNarrative;
    patchProjectNarrativeSectionsOne: ProjectNarrativeSection;
    patchProjectsOne: ProjectDto;
    patchProjectSchedulesOne: ProjectSchedule;
    patchPromptEvaluationsOne: PromptEvaluation;
    patchPromptsOne: Prompt;
    patchPromptVersionsOne: PromptVersion;
    patchQuestionsOne: QuestionDto;
    patchRegionsOne: Region;
    patchResearchBuilderThreadsOne: ResearchBuilderThread;
    patchSegmentsOne: Segment;
    patchTeamsOne: Team;
    patchTestOptionsOne: TestOption;
    patchTranslatedTextRegionsOne: TranslatedTextRegion;
    patchUsersOne: User;
  }
  export const apiPatchOnePaths: { [key in keyof ApiPatchOnePathTypes]: string } = {
    patchAiBatchesOne: "/api/v1/AiBatches(${key})",
    patchAiModelDefinitionsOne: "/api/v1/AiModelDefinitions(${key})",
    patchAmaThreadsOne: "/api/v1/AmaThreads(${key})",
    patchClientsOne: "/api/v1/Clients(${key})",
    patchCreditLogsOne: "/api/v1/CreditLogs(${key})",
    patchDemandZoneCellsOne: "/api/v1/DemandZoneCells(${key})",
    patchDemandZonesOne: "/api/v1/DemandZones(${key})",
    patchDisplayScheduleExceptionsOne: "/api/v1/DisplayScheduleExceptions(${key})",
    patchDisplaySchedulesOne: "/api/v1/DisplaySchedules(${key})",
    patchDocumentVersionsOne: "/api/v1/DocumentVersions(${key})",
    patchFeatureFlagsOne: "/api/v1/FeatureFlags(${key})",
    patchOrgsOne: "/api/v1/Orgs(${key})",
    patchProjectCommentsOne: "/api/v1/ProjectComments(${key})",
    patchProjectGroupQuestionsOne: "/api/v1/ProjectGroupQuestions(${key})",
    patchProjectGroupsOne: "/api/v1/ProjectGroups(${key})",
    patchProjectGroupSegmentsOne: "/api/v1/ProjectGroupSegments(${key})",
    patchProjectGroupTagsOne: "/api/v1/ProjectGroupTags(${key})",
    patchProjectNarrativesOne: "/api/v1/ProjectNarratives(${key})",
    patchProjectNarrativeSectionsOne: "/api/v1/ProjectNarrativeSections(${key})",
    patchProjectsOne: "/api/v1/Projects(${key})",
    patchProjectSchedulesOne: "/api/v1/ProjectSchedules(${key})",
    patchPromptEvaluationsOne: "/api/v1/PromptEvaluations(${key})",
    patchPromptsOne: "/api/v1/Prompts(${key})",
    patchPromptVersionsOne: "/api/v1/PromptVersions(${key})",
    patchQuestionsOne: "/api/v1/Questions(${key})",
    patchRegionsOne: "/api/v1/Regions(${key})",
    patchResearchBuilderThreadsOne: "/api/v1/ResearchBuilderThreads(${key})",
    patchSegmentsOne: "/api/v1/Segments(${key})",
    patchTeamsOne: "/api/v1/Teams(${key})",
    patchTestOptionsOne: "/api/v1/TestOptions(${key})",
    patchTranslatedTextRegionsOne: "/api/v1/TranslatedTextRegions(${key})",
    patchUsersOne: "/api/v1/Users(${key})",
  };
  export interface ApiPatchOneErrorTypes {
    patchAiBatchesOne: any;
    patchAiModelDefinitionsOne: any;
    patchAmaThreadsOne: any;
    patchClientsOne: any;
    patchCreditLogsOne: any;
    patchDemandZoneCellsOne: any;
    patchDemandZonesOne: any;
    patchDisplayScheduleExceptionsOne: any;
    patchDisplaySchedulesOne: any;
    patchDocumentVersionsOne: any;
    patchFeatureFlagsOne: any;
    patchOrgsOne: any;
    patchProjectCommentsOne: any;
    patchProjectGroupQuestionsOne: any;
    patchProjectGroupsOne: any;
    patchProjectGroupSegmentsOne: any;
    patchProjectGroupTagsOne: any;
    patchProjectNarrativesOne: any;
    patchProjectNarrativeSectionsOne: any;
    patchProjectsOne: any;
    patchProjectSchedulesOne: any;
    patchPromptEvaluationsOne: any;
    patchPromptsOne: any;
    patchPromptVersionsOne: any;
    patchQuestionsOne: any;
    patchRegionsOne: any;
    patchResearchBuilderThreadsOne: any;
    patchSegmentsOne: any;
    patchTeamsOne: any;
    patchTestOptionsOne: any;
    patchTranslatedTextRegionsOne: any;
    patchUsersOne: any;
  }
  export type ApiPatchOneParams = {
    patchAiBatchesOne: { key: number };
    patchAiModelDefinitionsOne: { key: number };
    patchAmaThreadsOne: { key: number };
    patchClientsOne: { key: number };
    patchCreditLogsOne: { key: number };
    patchDemandZoneCellsOne: { key: number };
    patchDemandZonesOne: { key: number };
    patchDisplayScheduleExceptionsOne: { key: number };
    patchDisplaySchedulesOne: { key: number };
    patchDocumentVersionsOne: { key: number };
    patchFeatureFlagsOne: { key: number };
    patchOrgsOne: { key: number };
    patchProjectCommentsOne: { key: number };
    patchProjectGroupQuestionsOne: { key: number };
    patchProjectGroupsOne: { key: number };
    patchProjectGroupSegmentsOne: { key: number };
    patchProjectGroupTagsOne: { key: number };
    patchProjectNarrativesOne: { key: number };
    patchProjectNarrativeSectionsOne: { key: number };
    patchProjectsOne: { key: number };
    patchProjectSchedulesOne: { key: number };
    patchPromptEvaluationsOne: { key: number };
    patchPromptsOne: { key: number };
    patchPromptVersionsOne: { key: number };
    patchQuestionsOne: {
      options?: any;
    } & { key: number };
    patchRegionsOne: { key: number };
    patchResearchBuilderThreadsOne: { key: number };
    patchSegmentsOne: { key: number };
    patchTeamsOne: { key: number };
    patchTestOptionsOne: {
      options?: any;
    } & { key: number };
    patchTranslatedTextRegionsOne: { key: number };
    patchUsersOne: { key: number };
  };

  export type AuthPatchRequestBody = {};

  export interface AuthPatchPathTypes {}
  export interface AuthPatchErrorTypes {}
  export const authPatchPaths: { [key in keyof AuthPatchPathTypes]: string } = {};
  export type AuthPatchParams = {};

  export interface AuthPatchOnePathTypes {}
  export const authPatchOnePaths: { [key in keyof AuthPatchOnePathTypes]: string } = {};
  export interface AuthPatchOneErrorTypes {}
  export type AuthPatchOneParams = {};

  export interface ApiFuncPathTypes {
    funcAiBatchRunsGetChannelInfo: ChannelInfoDto;
    funcAiConversationsMyConversations: AiConversation;
    funcAiConversationsDownloadFile: string;
    funcAiConversationsGetChatContents: AiConversationContentsResponse;
    funcAiConversationsGetMessages: Message;
    funcAiConversationsGetChannelInfo: ChannelInfoDto;
    funcAiModelDefinitionsReasoningEfforts: ReasoningEffortDto[];
    funcClientsFileUploadUrl: string;
    funcClientsExportTransactionListCsv: void;
    funcClientsClientSubStats: ClientSubData[];
    funcClientsGetChannelInfo: ChannelInfoDto;
    funcClientsWithResolvedSettings: ResolvedClientSettingsDto;
    funcClientsBenchmarks: BenchmarkResult[];
    funcCommandRunnerRunHubspotClientSync: string;
    funcCommandRunnerRunHubspotUserSync: string;
    funcCommandRunnerRunHubspotProjectSyncSync: string;
    funcCommandRunnerRunHubspotClientCustomPropsSync: string;
    funcCommandRunnerSyncDemoData: string;
    funcCommandRunnerReGenerateThemes: string;
    funcCommandRunnerTestNotification: string;
    funcCommandRunnerTestNextSchedule: string;
    funcCommandRunnerRunThumbnailCron: string;
    funcCommandRunnerRunSyncHubspotDownJob: string;
    funcCommandRunnerTestCreateNextSchedule: string;
    funcCommandRunnerReGenerateTextResponsesQa: string;
    funcCommandRunnerReGenerateScores: string;
    funcDataEventsLogGetPromptVersionHistory: PromptVersionHistoryDto[];
    funcDemandZonesDemandLandscapeScores: DemandLandscapeWeightedDto[];
    funcDemandZonesSessionCounts: Record<string, number>;
    funcDemandZonesTopNeedsAndBrands: DemandZoneTopNeedsBrands[];
    funcDemandZonesTestOptionResults: DemandZoneTestOptionResult[];
    funcLinkInvitesGetDemoProjectByIdentifier: DemoProjectDto;
    funcNotificationsAll: Notification;
    funcProjectGroupsProjectGroupSegmentCounts: SegmentCounts[];
    funcProjectGroupsBenchmarks: BenchmarkResult[];
    funcProjectGroupsTemplates: ProjectGroup;
    funcProjectGroupsExportCsv: boolean;
    funcProjectGroupsExportExcel: boolean;
    funcProjectNarrativeVersionExportsDownload: string;
    funcProjectQuestionsGetTrashed: ProjectQuestionDto;
    funcProjectsGetChannelInfo: ChannelInfoDto;
    funcProjectsFileUploadUrl: string;
    funcProjectsProjectFileUrls: Record<string, string>;
    funcProjectsExportCsv: void;
    funcProjectsExportExcel: void;
    funcProjectsResponsesCount: RespondentCount[];
    funcProjectsDecipherCompletesCounts: DecipherCompletesCountDto[];
    funcProjectsCreditCostNow: CreditCostTotalDto;
    funcProjectsProjectScheduleEstimates: ProjectScheduleEstimate;
    funcProjectsSchedulingState: SchedulingState;
    funcProjectsBenchmarks: BenchmarkResult[];
    funcProjectsQueryFacts: ProjectFact[];
    funcProjectsGetTrashed: ProjectDto;
    funcProjectSchedulesToRun: ProjectSchedule[];
    funcPromptsPlaybookPluginOptions: PlaybookPluginOptionsDto;
    funcPromptsPendingWorkflowEvaluations: PendingWorkflowEvaluationInfo[];
    funcPromptVersionsContent: IPromptContent;
    funcPromptVersionsWorkflowInfo: WorkflowInfoDto;
    funcQuestionsTargetQuestionsWithCounts: ScreenerQuestionWithCount;
    funcQuestionsOrgTemplatesQuestions: QuestionDto[];
    funcQuestionsOrgTemplatesQuestion: QuestionDto;
    funcQuestionsGetTrashed: QuestionDto;
    funcQuestionTemplatesGetTrashed: QuestionTemplateDto;
    funcRegionsStats: RegionStat[];
    funcResearchBuilderThreadsFileUploadUrl: string;
    funcResponsesWeightSum: WeightSum;
    funcResponsesWaveDataWeightSum: WaveDataWeightSum;
    funcResponsesQualResults: QualResult;
    funcResponsesWeightSumGroup: WeightSum;
    funcResponsesQualResultsGroup: QualResultGroup;
    funcResponsesDemographicsResults: DemographicsResult;
    funcResponsesQualResultsTestOptions: QualResult;
    funcResponsesWaveData: WaveDataResult;
    funcResponsesPriceSensitivityResults: PriceSensitivityResult;
    funcResponsesMarketReachResults: MarketReachResult;
    funcResponsesCrosstabResults: CrosstabResult;
    funcStandardQuestionsStandardQuestionDescription: Record<string, string>;
    funcStandardQuestionsStandardQuestionTexts: Record<string, string>;
    funcSurveyRunsDownloadRespondentsCsvEditProposalUrl: string;
    funcSurveyRunsDownloadRespondentsCsvUrl: string;
    funcSurveyRunsUploadRespondentsCsvUrl: RespondentsCsvUploadUrlDto;
    funcSurveyRunsDecipherTranslationCounts: DecipherTranslationsCountDto;
    funcSystemQuestionOptionProjectsDemographics: ProjectSystemQuestionOption;
    funcSystemQuestionOptionProjectGroupDemographics: ProjectSystemQuestionOption;
    funcSystemQuestionOptionClientDemographics: ProjectSystemQuestionOption;
    funcTeamsExtrapolatedUsers: UserAndClient[];
    funcTestOptionsGetTrashed: TestOptionDto;
    funcTextResponsesVerbatim: Verbatim[];
    funcTextResponsesVerbatimCount: VerbatimCount[];
    funcTextResponsesVerbatimGroup: Verbatim[];
    funcTextResponsesVerbatimCountGroup: VerbatimCount[];
    funcTextResponsesVerbatimTestOptions: Verbatim[];
    funcTextResponsesVerbatimCountTestOptions: VerbatimCount[];
    funcTextResponsesVerbatimShort: VerbatimShort[];
    funcTextResponsesVerbatimShortCount: VerbatimCount[];
    funcTranslatedTextRegionsAdminFiltered: AdminFilteredTranslationResult;
    funcUserDataExportsGetTrashed: UserDataExportDto;
    funcUsersCognitoStatus: CognitoStatus;
    funcUsersMe: User;
    funcUsersHasPermission: boolean;
    funcUsersMyPermissions: {
      projectApproval?: boolean;
    };
    funcUsersMyPolicies: Policy;
    funcUsersInheritedUserCount: number;
    funcUsersHmacMe: string;
    funcUsersWebsocketConnection: string;
    funcUsersFileUploadUrl: string;
  }
  export interface ApiFuncErrorTypes {
    funcAiBatchRunsGetChannelInfo: any;
    funcAiConversationsMyConversations: any;
    funcAiConversationsDownloadFile: any;
    funcAiConversationsGetChatContents: any;
    funcAiConversationsGetMessages: any;
    funcAiConversationsGetChannelInfo: any;
    funcAiModelDefinitionsReasoningEfforts: any;
    funcClientsFileUploadUrl: any;
    funcClientsExportTransactionListCsv: any;
    funcClientsClientSubStats: any;
    funcClientsGetChannelInfo: any;
    funcClientsWithResolvedSettings: any;
    funcClientsBenchmarks: any;
    funcCommandRunnerRunHubspotClientSync: any;
    funcCommandRunnerRunHubspotUserSync: any;
    funcCommandRunnerRunHubspotProjectSyncSync: any;
    funcCommandRunnerRunHubspotClientCustomPropsSync: any;
    funcCommandRunnerSyncDemoData: any;
    funcCommandRunnerReGenerateThemes: any;
    funcCommandRunnerTestNotification: any;
    funcCommandRunnerTestNextSchedule: any;
    funcCommandRunnerRunThumbnailCron: any;
    funcCommandRunnerRunSyncHubspotDownJob: any;
    funcCommandRunnerTestCreateNextSchedule: any;
    funcCommandRunnerReGenerateTextResponsesQa: any;
    funcCommandRunnerReGenerateScores: any;
    funcDataEventsLogGetPromptVersionHistory: any;
    funcDemandZonesDemandLandscapeScores: any;
    funcDemandZonesSessionCounts: any;
    funcDemandZonesTopNeedsAndBrands: any;
    funcDemandZonesTestOptionResults: any;
    funcLinkInvitesGetDemoProjectByIdentifier: any;
    funcNotificationsAll: any;
    funcProjectGroupsProjectGroupSegmentCounts: any;
    funcProjectGroupsBenchmarks: any;
    funcProjectGroupsTemplates: any;
    funcProjectGroupsExportCsv: any;
    funcProjectGroupsExportExcel: any;
    funcProjectNarrativeVersionExportsDownload: any;
    funcProjectQuestionsGetTrashed: any;
    funcProjectsGetChannelInfo: any;
    funcProjectsFileUploadUrl: any;
    funcProjectsProjectFileUrls: any;
    funcProjectsExportCsv: any;
    funcProjectsExportExcel: any;
    funcProjectsResponsesCount: any;
    funcProjectsDecipherCompletesCounts: any;
    funcProjectsCreditCostNow: any;
    funcProjectsProjectScheduleEstimates: any;
    funcProjectsSchedulingState: any;
    funcProjectsBenchmarks: any;
    funcProjectsQueryFacts: any;
    funcProjectsGetTrashed: any;
    funcProjectSchedulesToRun: any;
    funcPromptsPlaybookPluginOptions: any;
    funcPromptsPendingWorkflowEvaluations: any;
    funcPromptVersionsContent: any;
    funcPromptVersionsWorkflowInfo: any;
    funcQuestionsTargetQuestionsWithCounts: any;
    funcQuestionsOrgTemplatesQuestions: any;
    funcQuestionsOrgTemplatesQuestion: any;
    funcQuestionsGetTrashed: any;
    funcQuestionTemplatesGetTrashed: any;
    funcRegionsStats: any;
    funcResearchBuilderThreadsFileUploadUrl: any;
    funcResponsesWeightSum: any;
    funcResponsesWaveDataWeightSum: any;
    funcResponsesQualResults: any;
    funcResponsesWeightSumGroup: any;
    funcResponsesQualResultsGroup: any;
    funcResponsesDemographicsResults: any;
    funcResponsesQualResultsTestOptions: any;
    funcResponsesWaveData: any;
    funcResponsesPriceSensitivityResults: any;
    funcResponsesMarketReachResults: any;
    funcResponsesCrosstabResults: any;
    funcStandardQuestionsStandardQuestionDescription: any;
    funcStandardQuestionsStandardQuestionTexts: any;
    funcSurveyRunsDownloadRespondentsCsvEditProposalUrl: any;
    funcSurveyRunsDownloadRespondentsCsvUrl: any;
    funcSurveyRunsUploadRespondentsCsvUrl: any;
    funcSurveyRunsDecipherTranslationCounts: any;
    funcSystemQuestionOptionProjectsDemographics: any;
    funcSystemQuestionOptionProjectGroupDemographics: any;
    funcSystemQuestionOptionClientDemographics: any;
    funcTeamsExtrapolatedUsers: any;
    funcTestOptionsGetTrashed: any;
    funcTextResponsesVerbatim: any;
    funcTextResponsesVerbatimCount: any;
    funcTextResponsesVerbatimGroup: any;
    funcTextResponsesVerbatimCountGroup: any;
    funcTextResponsesVerbatimTestOptions: any;
    funcTextResponsesVerbatimCountTestOptions: any;
    funcTextResponsesVerbatimShort: any;
    funcTextResponsesVerbatimShortCount: any;
    funcTranslatedTextRegionsAdminFiltered: any;
    funcUserDataExportsGetTrashed: any;
    funcUsersCognitoStatus: any;
    funcUsersMe: any;
    funcUsersHasPermission: any;
    funcUsersMyPermissions: any;
    funcUsersMyPolicies: any;
    funcUsersInheritedUserCount: any;
    funcUsersHmacMe: any;
    funcUsersWebsocketConnection: any;
    funcUsersFileUploadUrl: any;
  }
  export const apiFuncPaths: { [key in keyof ApiFuncPathTypes]: string } = {
    funcAiBatchRunsGetChannelInfo: "/api/v1/AiBatchRuns(${key})/GetChannelInfo()",
    funcAiConversationsMyConversations: "/api/v1/AiConversations/MyConversations()",
    funcAiConversationsDownloadFile:
      "/api/v1/AiConversations(${key})/DownloadFile(referenceId=${referenceId})",
    funcAiConversationsGetChatContents: "/api/v1/AiConversations(${key})/GetChatContents()",
    funcAiConversationsGetMessages: "/api/v1/AiConversations(${key})/GetMessages()",
    funcAiConversationsGetChannelInfo: "/api/v1/AiConversations(${key})/GetChannelInfo()",
    funcAiModelDefinitionsReasoningEfforts: "/api/v1/AiModelDefinitions/ReasoningEfforts()",
    funcClientsFileUploadUrl:
      "/api/v1/Clients(${key})/FileUploadUrl(fileName=${fileName},fileType=${fileType})",
    funcClientsExportTransactionListCsv: "/api/v1/Clients(${key})/ExportTransactionListCsv()",
    funcClientsClientSubStats: "/api/v1/Clients(${key})/ClientSubStats()",
    funcClientsGetChannelInfo: "/api/v1/Clients(${key})/GetChannelInfo()",
    funcClientsWithResolvedSettings: "/api/v1/Clients(${key})/WithResolvedSettings()",
    funcClientsBenchmarks: "/api/v1/Clients/Benchmarks(regionIds=${regionIds})",
    funcCommandRunnerRunHubspotClientSync: "/api/CommandRunner/RunHubspotClientSync",
    funcCommandRunnerRunHubspotUserSync: "/api/CommandRunner/RunHubspotUserSync",
    funcCommandRunnerRunHubspotProjectSyncSync: "/api/CommandRunner/RunHubspotProjectSync",
    funcCommandRunnerRunHubspotClientCustomPropsSync: "/api/CommandRunner/RunHubspotClientCustomPropsSync",
    funcCommandRunnerSyncDemoData: "/api/CommandRunner/SyncDemoData",
    funcCommandRunnerReGenerateThemes: "/api/CommandRunner/ReGenerateThemes",
    funcCommandRunnerTestNotification: "/api/CommandRunner/TestNotification",
    funcCommandRunnerTestNextSchedule: "/api/CommandRunner/TestNextSchedule",
    funcCommandRunnerRunThumbnailCron: "/api/CommandRunner/RunThumbnailCron",
    funcCommandRunnerRunSyncHubspotDownJob: "/api/CommandRunner/RunSyncHubspotDownJob",
    funcCommandRunnerTestCreateNextSchedule: "/api/CommandRunner/TestCreateNextSchedule",
    funcCommandRunnerReGenerateTextResponsesQa: "/api/CommandRunner/ReGenerateTextResponsesQa",
    funcCommandRunnerReGenerateScores: "/api/CommandRunner/ReGenerateScores",
    funcDataEventsLogGetPromptVersionHistory:
      "/api/v1/DataEventsLog/GetPromptVersionHistory(promptId=${promptId})",
    funcDemandZonesDemandLandscapeScores:
      "/api/v1/DemandZones/DemandLandscapeScores(projectGroupId=${projectGroupId},regionId=${regionId},demandZoneId=${demandZoneId})",
    funcDemandZonesSessionCounts:
      "/api/v1/DemandZones/SessionCounts(projectGroupId=${projectGroupId},regionId=${regionId})",
    funcDemandZonesTopNeedsAndBrands:
      "/api/v1/DemandZones/TopNeedsAndBrands(projectGroupId=${projectGroupId},regionId=${regionId})",
    funcDemandZonesTestOptionResults:
      "/api/v1/DemandZones/TestOptionResults(projectGroupId=${projectGroupId},filters=${filters})",
    funcLinkInvitesGetDemoProjectByIdentifier:
      "/api/v1/LinkInvites/GetDemoProjectByIdentifier(identifier=${identifier})",
    funcNotificationsAll: "/api/v1/Notifications/All()",
    funcProjectGroupsProjectGroupSegmentCounts:
      "/api/v1/ProjectGroups(${key})/ProjectGroupSegmentCounts(filters=${filters},breakdownBy=${breakdownBy},splitByIds=${splitByIds})",
    funcProjectGroupsBenchmarks: "/api/v1/ProjectGroups(${key})/Benchmarks(regionIds=${regionIds})",
    funcProjectGroupsTemplates: "/api/v1/ProjectGroups/Templates()",
    funcProjectGroupsExportCsv: "/api/v1/ProjectGroups(${key})/ExportCsv()",
    funcProjectGroupsExportExcel:
      "/api/v1/ProjectGroups(${key})/ExportExcel(filters=${filters},segmentId=${segmentId},includeAllSegments=${includeAllSegments})",
    funcProjectNarrativeVersionExportsDownload: "/api/v1/ProjectNarrativeVersionExports(${key})/Download()",
    funcProjectQuestionsGetTrashed: "/api/v1/ProjectQuestions/GetTrashed()",
    funcProjectsGetChannelInfo: "/api/v1/Projects(${key})/GetChannelInfo()",
    funcProjectsFileUploadUrl:
      "/api/v1/Projects(${key})/FileUploadUrl(fileName=${fileName},fileType=${fileType})",
    funcProjectsProjectFileUrls: "/api/v1/Projects(${key})/ProjectFileUrls()",
    funcProjectsExportCsv: "/api/v1/Projects(${key})/ExportCsv()",
    funcProjectsExportExcel:
      "/api/v1/Projects(${key})/ExportExcel(filters=${filters},segmentId=${segmentId},includeAllSegments=${includeAllSegments},includeGroupSegments=${includeGroupSegments},includeDemographics=${includeDemographics},benchmarkTypeId=${benchmarkTypeId})",
    funcProjectsResponsesCount:
      "/api/v1/Projects(${key})/ResponsesCount(filters=${filters},systemQuestionId=${systemQuestionId})",
    funcProjectsDecipherCompletesCounts: "/api/v1/Projects(${key})/DecipherCompletesCounts()",
    funcProjectsCreditCostNow: "/api/v1/Projects(${key})/CreditCostNow()",
    funcProjectsProjectScheduleEstimates: "/api/v1/Projects(${key})/ProjectScheduleEstimates()",
    funcProjectsSchedulingState: "/api/v1/Projects(${key})/SchedulingState()",
    funcProjectsBenchmarks: "/api/v1/Projects(${key})/Benchmarks(regionIds=${regionIds})",
    funcProjectsQueryFacts:
      "/api/v1/Projects(${key})/QueryFacts(query=${query},testOptionId=${testOptionId},factTypes=${factTypes},filterSetId=${filterSetId},hasStatSig=${hasStatSig},benchmarkType=${benchmarkType},regionId=${regionId},minSampleSize=${minSampleSize},demographicOptionIds=${demographicOptionIds})",
    funcProjectsGetTrashed: "/api/v1/Projects/GetTrashed()",
    funcProjectSchedulesToRun: "/api/v1/ProjectSchedules/ToRun(timezone=${timezone})",
    funcPromptsPlaybookPluginOptions: "/api/v1/Prompts/PlaybookPluginOptions()",
    funcPromptsPendingWorkflowEvaluations: "/api/v1/Prompts(${key})/PendingWorkflowEvaluations()",
    funcPromptVersionsContent: "/api/v1/PromptVersions(${key})/Content()",
    funcPromptVersionsWorkflowInfo: "/api/v1/PromptVersions(${key})/WorkflowInfo()",
    funcQuestionsTargetQuestionsWithCounts:
      "/api/v1/Questions/TargetQuestionsWithCounts(projectId=${projectId},projectQuestionId=${projectQuestionId},questionPosition=${questionPosition},filters=${filters})",
    funcQuestionsOrgTemplatesQuestions: "/api/v1/Questions/OrgTemplatesQuestions()",
    funcQuestionsOrgTemplatesQuestion: "/api/v1/Questions(${key})/OrgTemplatesQuestion()",
    funcQuestionsGetTrashed: "/api/v1/Questions/GetTrashed()",
    funcQuestionTemplatesGetTrashed: "/api/v1/QuestionTemplates/GetTrashed()",
    funcRegionsStats: "/api/v1/Regions/Stats()",
    funcResearchBuilderThreadsFileUploadUrl:
      "/api/v1/ResearchBuilderThreads(${key})/FileUploadUrl(fileName=${fileName},fileType=${fileType})",
    funcResponsesWeightSum:
      "/api/v1/Responses/WeightSum(projectId=${projectId},questionId=${questionId},filters=${filters},standardQuestionId=${standardQuestionId},byTestOptionId=${byTestOptionId})",
    funcResponsesWaveDataWeightSum:
      "/api/v1/Responses/WaveDataWeightSum(projectId=${projectId},questionId=${questionId},filters=${filters},standardQuestionId=${standardQuestionId},byTestOptionId=${byTestOptionId})",
    funcResponsesQualResults:
      "/api/v1/Responses/QualResults(projectId=${projectId},projectQuestionId=${projectQuestionId},filters=${filters},breakdownBy=${breakdownBy},splitByIds=${splitByIds},includeFullResults=${includeFullResults})",
    funcResponsesWeightSumGroup:
      "/api/v1/Responses/WeightSumGroup(projectGroupId=${projectGroupId},questionId=${questionId},filters=${filters},standardQuestionId=${standardQuestionId},byTestOptionId=${byTestOptionId},projectIds=${projectIds},seedProjectsOnly=${seedProjectsOnly})",
    funcResponsesQualResultsGroup:
      "/api/v1/Responses/QualResultsGroup(projectGroupId=${projectGroupId},filters=${filters},breakdownBy=${breakdownBy},splitByIds=${splitByIds},includeFullResults=${includeFullResults},projectIds=${projectIds},seedProjectsOnly=${seedProjectsOnly})",
    funcResponsesDemographicsResults:
      "/api/v1/Responses/DemographicsResults(projectId=${projectId},filters=${filters})",
    funcResponsesQualResultsTestOptions:
      "/api/v1/Responses/QualResultsTestOptions(projectQuestionId=${projectQuestionId},filters=${filters},breakdownBy=${breakdownBy},splitByIds=${splitByIds},includeFullResults=${includeFullResults})",
    funcResponsesWaveData:
      "/api/v1/Responses/WaveData(projectId=${projectId},questionId=${questionId},filters=${filters})",
    funcResponsesPriceSensitivityResults:
      "/api/v1/Responses/PriceSensitivityResults(projectId=${projectId},filters=${filters})",
    funcResponsesMarketReachResults:
      "/api/v1/Responses/MarketReachResults(projectId=${projectId},filters=${filters},questionOptionIds=${questionOptionIds},simulateWith=${simulateWith},lockInIds=${lockInIds},lockInMustIncludeCount=${lockInMustIncludeCount},limit=${limit},projectQuestionId=${projectQuestionId})",
    funcResponsesCrosstabResults:
      "/api/v1/Responses/CrosstabResults(projectGroupId=${projectGroupId},filters=${filters},crosstabBy=${crosstabBy},crosstabById=${crosstabById},questionIds=${questionIds})",
    funcStandardQuestionsStandardQuestionDescription:
      "/api/v1/StandardQuestions/StandardQuestionDescription(frameworkId=${frameworkId})",
    funcStandardQuestionsStandardQuestionTexts:
      "/api/v1/StandardQuestions/StandardQuestionTexts(projectId=${projectId})",
    funcSurveyRunsDownloadRespondentsCsvEditProposalUrl:
      "/api/v1/SurveyRuns(${key})/DownloadRespondentsCsvEditProposalUrl(referenceId=${referenceId})",
    funcSurveyRunsDownloadRespondentsCsvUrl: "/api/v1/SurveyRuns(${key})/DownloadRespondentsCsvUrl()",
    funcSurveyRunsUploadRespondentsCsvUrl:
      "/api/v1/SurveyRuns(${key})/UploadRespondentsCsvUrl(fileName=${fileName})",
    funcSurveyRunsDecipherTranslationCounts: "/api/v1/SurveyRuns(${key})/DecipherTranslationCounts()",
    funcSystemQuestionOptionProjectsDemographics:
      "/api/v1/SystemQuestionOption/ProjectsDemographics(projectIds=${projectIds},regionId=${regionId},surveyRunIds=${surveyRunIds})",
    funcSystemQuestionOptionProjectGroupDemographics:
      "/api/v1/SystemQuestionOption/ProjectGroupDemographics(projectGroupId=${projectGroupId},regionId=${regionId},surveyRunIds=${surveyRunIds})",
    funcSystemQuestionOptionClientDemographics:
      "/api/v1/SystemQuestionOption/ClientDemographics(regionId=${regionId},surveyRunIds=${surveyRunIds})",
    funcTeamsExtrapolatedUsers: "/api/v1/Teams(${key})/ExtrapolatedUsers()",
    funcTestOptionsGetTrashed: "/api/v1/TestOptions/GetTrashed()",
    funcTextResponsesVerbatim:
      "/api/v1/TextResponses/Verbatim(projectId=${projectId},page=${page},pageSize=${pageSize},filters=${filters})",
    funcTextResponsesVerbatimCount:
      "/api/v1/TextResponses/VerbatimCount(projectId=${projectId},filters=${filters})",
    funcTextResponsesVerbatimGroup:
      "/api/v1/TextResponses/VerbatimGroup(projectGroupId=${projectGroupId},page=${page},pageSize=${pageSize},filters=${filters})",
    funcTextResponsesVerbatimCountGroup:
      "/api/v1/TextResponses/VerbatimCountGroup(projectGroupId=${projectGroupId},filters=${filters})",
    funcTextResponsesVerbatimTestOptions:
      "/api/v1/TextResponses/VerbatimTestOptions(page=${page},pageSize=${pageSize},filters=${filters})",
    funcTextResponsesVerbatimCountTestOptions:
      "/api/v1/TextResponses/VerbatimCountTestOptions(filters=${filters})",
    funcTextResponsesVerbatimShort:
      "/api/v1/TextResponses/VerbatimShort(projectId=${projectId},page=${page},filters=${filters})",
    funcTextResponsesVerbatimShortCount:
      "/api/v1/TextResponses/VerbatimShortCount(projectId=${projectId},filters=${filters})",
    funcTranslatedTextRegionsAdminFiltered: "/api/v1/TranslatedTextRegions/AdminFiltered(filters=${filters})",
    funcUserDataExportsGetTrashed: "/api/v1/UserDataExports/GetTrashed()",
    funcUsersCognitoStatus: "/api/v1/Users(${key})/CognitoStatus()",
    funcUsersMe: "/api/v1/Users/Me()",
    funcUsersHasPermission: "/api/v1/Users/HasPermission(permission=${permission})",
    funcUsersMyPermissions: "/api/v1/Users/MyPermissions()",
    funcUsersMyPolicies: "/api/v1/Users/MyPolicies()",
    funcUsersInheritedUserCount: "/api/v1/Users/InheritedUserCount()",
    funcUsersHmacMe: "/api/v1/Users/HmacMe()",
    funcUsersWebsocketConnection: "/api/v1/Users/WebsocketConnection()",
    funcUsersFileUploadUrl: "/api/v1/Users/FileUploadUrl(fileName=${fileName},fileType=${fileType})",
  };
  export type ApiFuncParams = {
    funcAiBatchRunsGetChannelInfo: { key: number };
    funcAiConversationsMyConversations: {
      options?: any;
    };
    funcAiConversationsDownloadFile: { key: number; referenceId: string };
    funcAiConversationsGetChatContents: { key: number };
    funcAiConversationsGetMessages: { key: number };
    funcAiConversationsGetChannelInfo: { key: number };
    funcAiModelDefinitionsReasoningEfforts: {};
    funcClientsFileUploadUrl: { key: number; fileName: string; fileType: string };
    funcClientsExportTransactionListCsv: { key: number };
    funcClientsClientSubStats: { key: number };
    funcClientsGetChannelInfo: { key: number };
    funcClientsWithResolvedSettings: { key: number };
    funcClientsBenchmarks: {
      regionIds?: number[];
    };
    funcCommandRunnerRunHubspotClientSync: {};
    funcCommandRunnerRunHubspotUserSync: {};
    funcCommandRunnerRunHubspotProjectSyncSync: {
      /** @format int32 */
      projectId?: number;
    };
    funcCommandRunnerRunHubspotClientCustomPropsSync: {};
    funcCommandRunnerSyncDemoData: {
      /** @format int32 */
      teamId?: number;
    };
    funcCommandRunnerReGenerateThemes: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      regionId?: number;
    };
    funcCommandRunnerTestNotification: {
      /** @format int32 */
      projectId?: number;
    };
    funcCommandRunnerTestNextSchedule: {
      /** @format int32 */
      projectId?: number;
    };
    funcCommandRunnerRunThumbnailCron: {};
    funcCommandRunnerRunSyncHubspotDownJob: {};
    funcCommandRunnerTestCreateNextSchedule: {
      /** @format int32 */
      projectId?: number;
    };
    funcCommandRunnerReGenerateTextResponsesQa: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      surveyRunId?: number;
    };
    funcCommandRunnerReGenerateScores: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      surveyRunId?: number;
    };
    funcDataEventsLogGetPromptVersionHistory: {
      /** @format int32 */
      promptId?: number;
    };
    funcDemandZonesDemandLandscapeScores: {
      /** @format int32 */
      projectGroupId?: number;
      /** @format int32 */
      regionId?: number;
      /** @format int32 */
      demandZoneId?: number;
    };
    funcDemandZonesSessionCounts: {
      /** @format int32 */
      projectGroupId?: number;
      /** @format int32 */
      regionId?: number;
    };
    funcDemandZonesTopNeedsAndBrands: {
      /** @format int32 */
      projectGroupId?: number;
      /** @format int32 */
      regionId?: number;
    };
    funcDemandZonesTestOptionResults: {
      /** @format int32 */
      projectGroupId?: number;
      filters?: ResponsesFilters;
    };
    funcLinkInvitesGetDemoProjectByIdentifier: {
      /** @format uuid */
      identifier?: string;
    };
    funcNotificationsAll: {};
    funcProjectGroupsProjectGroupSegmentCounts: {
      filters?: ResponsesFilters;
      breakdownBy?: BreakdownBy[];
      splitByIds?: number[];
    } & { key: number };
    funcProjectGroupsBenchmarks: {
      regionIds?: number[];
    } & { key: number };
    funcProjectGroupsTemplates: {};
    funcProjectGroupsExportCsv: { key: number };
    funcProjectGroupsExportExcel: {
      filters?: GroupResponsesFilters;
      /** @format int32 */
      segmentId?: number;
      includeAllSegments?: boolean;
    } & { key: number };
    funcProjectNarrativeVersionExportsDownload: { key: number };
    funcProjectQuestionsGetTrashed: {
      options?: any;
    };
    funcProjectsGetChannelInfo: { key: number };
    funcProjectsFileUploadUrl: { key: number; fileName: string; fileType: string };
    funcProjectsProjectFileUrls: { key: number };
    funcProjectsExportCsv: { key: number };
    funcProjectsExportExcel: {
      filters?: ResponsesFilters;
      /** @format int32 */
      segmentId?: number;
      /** @format int32 */
      benchmarkTypeId?: number;
      includeAllSegments?: boolean;
      includeGroupSegments?: boolean;
      includeDemographics?: boolean;
    } & { key: number };
    funcProjectsResponsesCount: {
      filters?: ResponsesFilters;
      /** @format int32 */
      systemQuestionId?: number;
    } & { key: number };
    funcProjectsDecipherCompletesCounts: { key: number };
    funcProjectsCreditCostNow: { key: number };
    funcProjectsProjectScheduleEstimates: { key: number };
    funcProjectsSchedulingState: { key: number };
    funcProjectsBenchmarks: {
      regionIds?: number[];
    } & { key: number };
    funcProjectsQueryFacts: {
      /** @format int32 */
      regionId?: number;
      /** @default "" */
      query?: string;
      /** @format int32 */
      testOptionId?: number;
      factTypes?: ProjectFactTypes[];
      /** @format int32 */
      filterSetId?: number;
      /** @format int32 */
      projectGroupSegmentId?: number;
      /** @default false */
      hasStatSig?: boolean;
      benchmarkType?: BenchmarkTypes;
      /**
       * @format int32
       * @default 30
       */
      minSampleSize?: number;
      demographicOptionIds?: number[];
    } & { key: number };
    funcProjectsGetTrashed: {
      options?: any;
    };
    funcProjectSchedulesToRun: {
      timezone?: string;
    };
    funcPromptsPlaybookPluginOptions: {};
    funcPromptsPendingWorkflowEvaluations: { key: number };
    funcPromptVersionsContent: { key: number };
    funcPromptVersionsWorkflowInfo: { key: number };
    funcQuestionsTargetQuestionsWithCounts: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      projectQuestionId?: number;
      questionPosition?: QuestionPositions;
      filters?: ResponsesFilters;
    };
    funcQuestionsOrgTemplatesQuestions: {
      options?: any;
    };
    funcQuestionsOrgTemplatesQuestion: {
      options?: any;
    } & { key: number };
    funcQuestionsGetTrashed: {
      options?: any;
    };
    funcQuestionTemplatesGetTrashed: {
      options?: any;
    };
    funcRegionsStats: {};
    funcResearchBuilderThreadsFileUploadUrl: { key: number; fileName: string; fileType: string };
    funcResponsesWeightSum: {
      /** @format int32 */
      projectId?: number;
      filters?: ResponsesFilters;
      /** @format int32 */
      questionId?: number;
      /** @format int32 */
      standardQuestionId?: number;
      byTestOptionId?: boolean;
    };
    funcResponsesWaveDataWeightSum: {
      /** @format int32 */
      projectId?: number;
      filters?: ResponsesFilters;
      /** @format int32 */
      questionId?: number;
      /** @format int32 */
      standardQuestionId?: number;
      byTestOptionId?: boolean;
    };
    funcResponsesQualResults: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      projectQuestionId?: number;
      filters?: ResponsesFilters;
      breakdownBy?: BreakdownBy[];
      splitByIds?: number[];
      /** @default false */
      includeFullResults?: boolean;
    };
    funcResponsesWeightSumGroup: {
      /** @format int32 */
      projectGroupId?: number;
      filters?: GroupResponsesFilters;
      /** @format int32 */
      questionId?: number;
      /** @format int32 */
      standardQuestionId?: number;
      byTestOptionId?: boolean;
      projectIds?: number[];
      /** @default false */
      seedProjectsOnly?: boolean;
    };
    funcResponsesQualResultsGroup: {
      /** @format int32 */
      projectGroupId?: number;
      filters?: GroupResponsesFilters;
      breakdownBy?: BreakdownBy[];
      splitByIds?: number[];
      /** @default false */
      includeFullResults?: boolean;
      projectIds?: number[];
      /** @default false */
      seedProjectsOnly?: boolean;
    };
    funcResponsesDemographicsResults: {
      /** @format int32 */
      projectId?: number;
      filters?: DemographicResponsesFilters;
    };
    funcResponsesQualResultsTestOptions: {
      /** @format int32 */
      projectQuestionId?: number;
      filters?: ResponsesFilters;
      breakdownBy?: BreakdownBy[];
      splitByIds?: number[];
      /** @default false */
      includeFullResults?: boolean;
    };
    funcResponsesWaveData: {
      /** @format int32 */
      projectId?: number;
      filters?: ResponsesFilters;
      /** @format int32 */
      questionId?: number;
    };
    funcResponsesPriceSensitivityResults: {
      /** @format int32 */
      projectId?: number;
      filters?: ResponsesFilters;
    };
    funcResponsesMarketReachResults: {
      /** @format int32 */
      projectId?: number;
      filters?: ResponsesFilters;
      questionOptionIds?: number[];
      /** @format int32 */
      simulateWith?: number;
      lockInIds?: number[];
      /** @format int32 */
      lockInMustIncludeCount?: number;
      /** @format int32 */
      limit?: number;
      /** @format int32 */
      projectQuestionId?: number;
    };
    funcResponsesCrosstabResults: {
      /** @format int32 */
      projectGroupId?: number;
      filters?: GroupResponsesFilters;
      crosstabBy?: CrosstabBy;
      /** @format int32 */
      crosstabById?: number;
      questionIds?: number[];
    };
    funcStandardQuestionsStandardQuestionDescription: {
      /** @format int32 */
      frameworkId?: number;
    };
    funcStandardQuestionsStandardQuestionTexts: {
      /** @format int32 */
      projectId?: number;
    };
    funcSurveyRunsDownloadRespondentsCsvEditProposalUrl: { key: number; referenceId: string };
    funcSurveyRunsDownloadRespondentsCsvUrl: { key: number };
    funcSurveyRunsUploadRespondentsCsvUrl: { key: number; fileName: string };
    funcSurveyRunsDecipherTranslationCounts: { key: number };
    funcSystemQuestionOptionProjectsDemographics: {
      projectIds?: number[];
      /** @format int32 */
      regionId?: number;
      surveyRunIds?: number[];
    };
    funcSystemQuestionOptionProjectGroupDemographics: {
      /** @format int32 */
      projectGroupId?: number;
      /** @format int32 */
      regionId?: number;
      surveyRunIds?: number[];
    };
    funcSystemQuestionOptionClientDemographics: {
      /** @format int32 */
      regionId?: number;
      surveyRunIds?: number[];
    };
    funcTeamsExtrapolatedUsers: { key: number };
    funcTestOptionsGetTrashed: {
      options?: any;
    };
    funcTextResponsesVerbatim: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      page?: number;
      /** @format int32 */
      pageSize?: number;
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimCount: {
      /** @format int32 */
      projectId?: number;
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimGroup: {
      /** @format int32 */
      projectGroupId?: number;
      /** @format int32 */
      page?: number;
      /** @format int32 */
      pageSize?: number;
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimCountGroup: {
      /** @format int32 */
      projectGroupId?: number;
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimTestOptions: {
      /** @format int32 */
      page?: number;
      /** @format int32 */
      pageSize?: number;
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimCountTestOptions: {
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimShort: {
      /** @format int32 */
      projectId?: number;
      /** @format int32 */
      page?: number;
      filters?: TextResponsesFilters;
    };
    funcTextResponsesVerbatimShortCount: {
      /** @format int32 */
      projectId?: number;
      filters?: TextResponsesFilters;
    };
    funcTranslatedTextRegionsAdminFiltered: {
      filters?: AdminFilteredTranslationResultFilters;
    };
    funcUserDataExportsGetTrashed: {
      options?: any;
    };
    funcUsersCognitoStatus: { key: number };
    funcUsersMe: {};
    funcUsersHasPermission: {
      permission?: Permission;
    };
    funcUsersMyPermissions: {};
    funcUsersMyPolicies: {};
    funcUsersInheritedUserCount: {};
    funcUsersHmacMe: {};
    funcUsersWebsocketConnection: {};
    funcUsersFileUploadUrl: { fileName: string; fileType: string };
  };
  export interface AuthFuncPathTypes {
    funcLoginGetLoginMethods: LoginMethodDto[];
    funcLoginGetInvite: UserInviteDto[];
    funcLoginGetRegistrationInvite: LinkInviteDto;
    funcLoginGetRegistrationLoginMethods: LoginMethodDto[];
    funcSamlCode: boolean;
  }
  export interface AuthFuncErrorTypes {
    funcLoginGetLoginMethods: any;
    funcLoginGetInvite: any;
    funcLoginGetRegistrationInvite: any;
    funcLoginGetRegistrationLoginMethods: any;
    funcSamlCode: any;
  }
  export const authFuncPaths: { [key in keyof AuthFuncPathTypes]: string } = {
    funcLoginGetLoginMethods: "/auth/Login/GetLoginMethods/${email}",
    funcLoginGetInvite: "/auth/Login/GetInvite/${email}",
    funcLoginGetRegistrationInvite: "/auth/Login/GetRegistrationInvite/${inviteIdentifier}",
    funcLoginGetRegistrationLoginMethods:
      "/auth/Login/GetRegistrationLoginMethods?inviteIdentifier=${inviteIdentifier}&email=${email}",
    funcSamlCode: "/auth/Saml/Code?code=${code}&state=${state}",
  };
  export type AuthFuncParams = {
    funcLoginGetLoginMethods: { email: string };
    funcLoginGetInvite: { email: string };
    funcLoginGetRegistrationInvite: { inviteIdentifier: string };
    funcLoginGetRegistrationLoginMethods: {
      /** @format uuid */
      inviteIdentifier?: string;
      email?: string;
    };
    funcSamlCode: {
      code?: string;
      state?: string;
    };
  };

  export interface ApiActPathTypes {
    actAiBatchesAddItems: boolean;
    actAiBatchesRun: AiBatchRun;
    actAiConversationsAddUserMessage: AiConversation;
    actAiConversationsEvaluateConversation: boolean;
    actAiConversationsContinueConversation: AiConversation;
    actAiConversationsDownloadToYml: string;
    actAiMessagesSendFeedback: AiMessage;
    actAiMessagesMarkActionTaken: AiMessage;
    actAiProjectSummariesRegenerate: boolean;
    actClientsAdminUpdate: Client;
    actClientsValidateDomainRecord: boolean;
    actClientsSetupTrialAccount: TrialClientSetupResponseDto;
    actClientsRenewalPowerPointExport: boolean;
    actClientsSaveLogo: number;
    actCognitoIdpsCreateSaml: CognitoIdp;
    actCognitoIdpsUpdateSaml: CognitoIdp;
    actCognitoUsersAdminDelete: boolean;
    actCreditLogsMakeCreditTransfer: CreditLog[];
    actDemandZonesRegenerate: boolean;
    actDemandZonesRegenerateOccasionNet: boolean;
    actDemandZonesSetOccasionNet: boolean;
    actDemandZonesSyncDemandZones: boolean;
    actDocumentVersionsSetAllUsages: SetAllUsagesResultDto;
    actExportsExportToExcel: void;
    actFeatureFlagsEnableIdeally: boolean;
    actFeatureFlagsDisableIdeally: boolean;
    actLinkInvitesAcceptShare: number;
    actNotificationsMarkAsRead: boolean;
    actOrgsRename: Org;
    actProjectCommentsDismiss: boolean;
    actProjectCommentsUndismiss: boolean;
    actProjectGroupQuestionsSortOrderChange: boolean;
    actProjectGroupsSyncSegmentSurveySessions: boolean;
    actProjectGroupsGenerateSegments: AiConversation;
    actProjectGroupsDeleteSegments: number;
    actProjectGroupsCreateDynamicQuestions: boolean;
    actProjectGroupsShare: ProjectGroup;
    actProjectGroupsUnshare: boolean;
    actProjectGroupsGenerateSummaries: ProjectGroup;
    actProjectGroupsDuplicate: CloneProjectGroupResult;
    actProjectGroupSegmentsBulkUpdate: boolean;
    actProjectGroupSegmentsUpdateSessions: string;
    actProjectNarrativeSectionsCreate: ProjectNarrativeSection;
    actProjectNarrativeSectionsMoveUp: boolean;
    actProjectNarrativeSectionsMoveDown: boolean;
    actProjectNarrativeVersionsGenerateSlideDeck: ProjectNarrativeVersionExport;
    actProjectQuestionsSortOrderChange: boolean;
    actProjectsDuplicate: Project;
    actProjectsDuplicateWithData: boolean;
    actProjectsShare: Project;
    actProjectsUndelete: boolean;
    actProjectsAdminEdit: ProjectDto;
    actProjectsRemoveFromSurveyRun: boolean;
    actProjectsChangeTargets: ProjectDto;
    actProjectsUpsertSchedule: ProjectDto;
    actProjectsUpdatePriceSensitivities: ProjectDto;
    actProjectsUpdateMarketReach: ProjectDto;
    actProjectsUpdateProjectScheduling: ProjectDto;
    actProjectsStopProjectScheduling: boolean;
    actProjectsCreatePriceSensitivities: ProjectDto;
    actProjectsDeletePriceSensitivities: ProjectDto;
    actProjectsCreateMarketReach: ProjectDto;
    actProjectsDeleteMarketReach: ProjectDto;
    actProjectsDeleteRegions: ProjectDto;
    actProjectsIncidenceEstimate: ProjectDto;
    actProjectsUnsubmit: ProjectDto;
    actProjectsSubmit: ProjectDto;
    actProjectsDecline: ProjectDto;
    actProjectsApprove: ProjectDto;
    actProjectsSuperApprove: Project;
    actProjectsCloseProjectSurvey: ProjectDto;
    actProjectsPowerPointExport: boolean;
    actProjectsExportPlanDocument: boolean;
    actProjectsUpdateWatchers: boolean;
    actProjectsStopWatching: boolean;
    actProjectsStartWatching: boolean;
    actProjectsMarkAsDemo: boolean;
    actProjectsMove: ProjectDto;
    actProjectsCreateUsageAndAttitudeSeedProject: ProjectDto;
    actProjectsGenerateQuestionIr: boolean;
    actProjectsUpdateGroupTags: ProjectDto;
    actProjectsUpdateProjectOwner: ProjectDto;
    actProjectsDocumentToProject: boolean;
    actProjectsResyncScheduledProject: ProjectDto;
    actProjectsReTheme: boolean;
    actProjectsSetCustomMetrics: boolean;
    actProjectsRunEvaluations: RunProjectAiEvaluationsJobResult;
    actProjectsGenerateThumbnails: number;
    actProjectsRunFactsFindings: boolean;
    actProjectsChangeFramework: boolean;
    actProjectsSynthAssignProjectToGroup: boolean;
    actProjectsBackfillResearchObjectives: boolean;
    actProjectsGenerateFilterSets: boolean;
    actProjectSchedulesSyncDates: ProjectSchedule;
    actProjectSchedulesSyncNpdDates: ProjectSchedule;
    actProjectSchedulesCreateManualSchedule: ProjectSchedule[];
    actPromptsAssignEvaluations: boolean;
    actPromptsRunWorkflowEvaluations: RunWorkflowAiEvaluationsJobResult;
    actPromptVersionsRun: RunPromptVersionResponseDto;
    actPromptVersionsPublish: PromptVersion;
    actPromptVersionsImportFromYml: PromptVersion;
    actPromptVersionsImportFromJson: PromptVersion;
    actPromptVersionsDownloadToJson: string;
    actQuestionsDeleteTemplateQuestion: boolean;
    actResearchBuilderThreadsAcceptFrameworkAndBuild: AcceptFrameworkAndBuildResultDto;
    actResearchBuilderThreadsCreateFile: ResearchBuilderThreadFile;
    actResearchBuilderThreadsUpdatePreSelectedFramework: boolean;
    actSegmentsGenerateSummaries: Segment;
    actSurveyRunsCreateRespondentsCsvEditThread: SurveyRunRespondentsCsvEditThread;
    actSurveyRunsApplyRespondentsCsvEditProposal: ValidateStagedRespondentsCsvResultDto;
    actSurveyRunsRunSyntheticSurvey: SurveyRun;
    actSurveyRunsCreateSurveys: SurveyRun[];
    actSurveyRunsSyncDecipherSurvey: SurveyRun;
    actSurveyRunsForceCloseSurvey: SurveyRun;
    actSurveyRunsStartSurveyProcessing: SurveyRun;
    actSurveyRunsCreateOrUpdateSamplifyProject: SurveyRun;
    actSurveyRunsLaunchSurvey: SurveyRun;
    actSurveyRunsDecipherRespondents: DecipherRespondentDto[];
    actSurveyRunsRemoveRespondentsCsv: SurveyRun;
    actSurveyRunsValidateStagedRespondentsCsv: ValidateStagedRespondentsCsvResultDto;
    actSurveyRunsReplaceRespondentsCsvFromStaging: SurveyRun;
    actSurveyRunsRemoveUuidsFromSurvey: SurveyRun;
    actSurveyRunsReuploadTranslations: SurveyRun;
    actSurveyRunsRunSimulatedData: SurveyRun;
    actSurveyRunsCreateManualRespondentsCsvProposal: CreateManualRespondentsCsvProposalResultDto;
    actSurveyRunsUpdateRespondentsCsvProposal: UpdateRespondentsCsvProposalResultDto;
    actSurveyRunsBackwardsSync: SurveyRun;
    actTeamsRename: Team;
    actTeamsUpdateAutoProjectWatch: User;
    actTextResponsesReassignThemes: boolean;
    actTranslatedTextRegionsAddDemographicTranslations: TranslatedTextRegion;
    actUsersEnable: User;
    actUsersDisable: User;
    actUsersRemoveFromAccount: User;
    actUsersSetNames: boolean;
    actUsersSetPassword: boolean;
    actUsersResendInvite: boolean;
    actUsersSetHubspotRole: boolean;
    actUsersSetResearchSetupConfidence: boolean;
    actUsersSetResearchInterpretationConfidence: boolean;
    actUsersSuperAdminUserCreate: User;
    actUsersSuperAdminUserUpdate: User;
    actUsersBulkInvite: ChannelInfoDto;
    actUsersParseInviteFile: ChannelInfoDto;
  }
  export interface ApiActErrorTypes {
    actAiBatchesAddItems: any;
    actAiBatchesRun: any;
    actAiConversationsAddUserMessage: any;
    actAiConversationsEvaluateConversation: any;
    actAiConversationsContinueConversation: any;
    actAiConversationsDownloadToYml: any;
    actAiMessagesSendFeedback: any;
    actAiMessagesMarkActionTaken: any;
    actAiProjectSummariesRegenerate: any;
    actClientsAdminUpdate: any;
    actClientsValidateDomainRecord: any;
    actClientsSetupTrialAccount: any;
    actClientsRenewalPowerPointExport: any;
    actClientsSaveLogo: any;
    actCognitoIdpsCreateSaml: any;
    actCognitoIdpsUpdateSaml: any;
    actCognitoUsersAdminDelete: any;
    actCreditLogsMakeCreditTransfer: any;
    actDemandZonesRegenerate: any;
    actDemandZonesRegenerateOccasionNet: any;
    actDemandZonesSetOccasionNet: any;
    actDemandZonesSyncDemandZones: any;
    actDocumentVersionsSetAllUsages: any;
    actExportsExportToExcel: any;
    actFeatureFlagsEnableIdeally: any;
    actFeatureFlagsDisableIdeally: any;
    actLinkInvitesAcceptShare: any;
    actNotificationsMarkAsRead: any;
    actOrgsRename: any;
    actProjectCommentsDismiss: any;
    actProjectCommentsUndismiss: any;
    actProjectGroupQuestionsSortOrderChange: any;
    actProjectGroupsSyncSegmentSurveySessions: any;
    actProjectGroupsGenerateSegments: any;
    actProjectGroupsDeleteSegments: any;
    actProjectGroupsCreateDynamicQuestions: any;
    actProjectGroupsShare: any;
    actProjectGroupsUnshare: any;
    actProjectGroupsGenerateSummaries: any;
    actProjectGroupsDuplicate: any;
    actProjectGroupSegmentsBulkUpdate: any;
    actProjectGroupSegmentsUpdateSessions: any;
    actProjectNarrativeSectionsCreate: any;
    actProjectNarrativeSectionsMoveUp: any;
    actProjectNarrativeSectionsMoveDown: any;
    actProjectNarrativeVersionsGenerateSlideDeck: any;
    actProjectQuestionsSortOrderChange: any;
    actProjectsDuplicate: any;
    actProjectsDuplicateWithData: any;
    actProjectsShare: any;
    actProjectsUndelete: any;
    actProjectsAdminEdit: any;
    actProjectsRemoveFromSurveyRun: any;
    actProjectsChangeTargets: any;
    actProjectsUpsertSchedule: any;
    actProjectsUpdatePriceSensitivities: any;
    actProjectsUpdateMarketReach: any;
    actProjectsUpdateProjectScheduling: any;
    actProjectsStopProjectScheduling: any;
    actProjectsCreatePriceSensitivities: any;
    actProjectsDeletePriceSensitivities: any;
    actProjectsCreateMarketReach: any;
    actProjectsDeleteMarketReach: any;
    actProjectsDeleteRegions: any;
    actProjectsIncidenceEstimate: any;
    actProjectsUnsubmit: any;
    actProjectsSubmit: any;
    actProjectsDecline: any;
    actProjectsApprove: any;
    actProjectsSuperApprove: any;
    actProjectsCloseProjectSurvey: any;
    actProjectsPowerPointExport: any;
    actProjectsExportPlanDocument: any;
    actProjectsUpdateWatchers: any;
    actProjectsStopWatching: any;
    actProjectsStartWatching: any;
    actProjectsMarkAsDemo: any;
    actProjectsMove: any;
    actProjectsCreateUsageAndAttitudeSeedProject: any;
    actProjectsGenerateQuestionIr: any;
    actProjectsUpdateGroupTags: any;
    actProjectsUpdateProjectOwner: any;
    actProjectsDocumentToProject: any;
    actProjectsResyncScheduledProject: any;
    actProjectsReTheme: any;
    actProjectsSetCustomMetrics: any;
    actProjectsRunEvaluations: any;
    actProjectsGenerateThumbnails: any;
    actProjectsRunFactsFindings: any;
    actProjectsChangeFramework: any;
    actProjectsSynthAssignProjectToGroup: any;
    actProjectsBackfillResearchObjectives: any;
    actProjectsGenerateFilterSets: any;
    actProjectSchedulesSyncDates: any;
    actProjectSchedulesSyncNpdDates: any;
    actProjectSchedulesCreateManualSchedule: any;
    actPromptsAssignEvaluations: any;
    actPromptsRunWorkflowEvaluations: any;
    actPromptVersionsRun: any;
    actPromptVersionsPublish: any;
    actPromptVersionsImportFromYml: any;
    actPromptVersionsImportFromJson: any;
    actPromptVersionsDownloadToJson: any;
    actQuestionsDeleteTemplateQuestion: any;
    actResearchBuilderThreadsAcceptFrameworkAndBuild: any;
    actResearchBuilderThreadsCreateFile: any;
    actResearchBuilderThreadsUpdatePreSelectedFramework: any;
    actSegmentsGenerateSummaries: any;
    actSurveyRunsCreateRespondentsCsvEditThread: any;
    actSurveyRunsApplyRespondentsCsvEditProposal: any;
    actSurveyRunsRunSyntheticSurvey: any;
    actSurveyRunsCreateSurveys: any;
    actSurveyRunsSyncDecipherSurvey: any;
    actSurveyRunsForceCloseSurvey: any;
    actSurveyRunsStartSurveyProcessing: any;
    actSurveyRunsCreateOrUpdateSamplifyProject: any;
    actSurveyRunsLaunchSurvey: any;
    actSurveyRunsDecipherRespondents: any;
    actSurveyRunsRemoveRespondentsCsv: any;
    actSurveyRunsValidateStagedRespondentsCsv: any;
    actSurveyRunsReplaceRespondentsCsvFromStaging: any;
    actSurveyRunsRemoveUuidsFromSurvey: any;
    actSurveyRunsReuploadTranslations: any;
    actSurveyRunsRunSimulatedData: any;
    actSurveyRunsCreateManualRespondentsCsvProposal: any;
    actSurveyRunsUpdateRespondentsCsvProposal: any;
    actSurveyRunsBackwardsSync: any;
    actTeamsRename: any;
    actTeamsUpdateAutoProjectWatch: any;
    actTextResponsesReassignThemes: any;
    actTranslatedTextRegionsAddDemographicTranslations: any;
    actUsersEnable: any;
    actUsersDisable: any;
    actUsersRemoveFromAccount: any;
    actUsersSetNames: any;
    actUsersSetPassword: any;
    actUsersResendInvite: any;
    actUsersSetHubspotRole: any;
    actUsersSetResearchSetupConfidence: any;
    actUsersSetResearchInterpretationConfidence: any;
    actUsersSuperAdminUserCreate: any;
    actUsersSuperAdminUserUpdate: any;
    actUsersBulkInvite: any;
    actUsersParseInviteFile: any;
  }
  export const apiActPaths: { [key in keyof ApiActPathTypes]: string } = {
    actAiBatchesAddItems: "/api/v1/AiBatches(${key})/AddItems",
    actAiBatchesRun: "/api/v1/AiBatches(${key})/Run",
    actAiConversationsAddUserMessage: "/api/v1/AiConversations(${key})/AddUserMessage",
    actAiConversationsEvaluateConversation: "/api/v1/AiConversations(${key})/EvaluateConversation",
    actAiConversationsContinueConversation: "/api/v1/AiConversations(${key})/ContinueConversation",
    actAiConversationsDownloadToYml: "/api/v1/AiConversations(${key})/DownloadToYml",
    actAiMessagesSendFeedback: "/api/v1/AiMessages(${key})/SendFeedback",
    actAiMessagesMarkActionTaken: "/api/v1/AiMessages(${key})/MarkActionTaken",
    actAiProjectSummariesRegenerate: "/api/v1/AiProjectSummaries(${key})/Regenerate",
    actClientsAdminUpdate: "/api/v1/Clients(${key})/AdminUpdate",
    actClientsValidateDomainRecord: "/api/v1/Clients(${key})/ValidateDomainRecord",
    actClientsSetupTrialAccount: "/api/v1/Clients/SetupTrialAccount",
    actClientsRenewalPowerPointExport: "/api/v1/Clients(${key})/RenewalPowerPointExport",
    actClientsSaveLogo: "/api/v1/Clients(${key})/SaveLogo",
    actCognitoIdpsCreateSaml: "/api/v1/CognitoIdps/CreateSaml",
    actCognitoIdpsUpdateSaml: "/api/v1/CognitoIdps(${key})/UpdateSaml",
    actCognitoUsersAdminDelete: "/api/v1/CognitoUsers(${key})/AdminDelete",
    actCreditLogsMakeCreditTransfer: "/api/v1/CreditLogs/MakeCreditTransfer",
    actDemandZonesRegenerate: "/api/v1/DemandZones/Regenerate",
    actDemandZonesRegenerateOccasionNet: "/api/v1/DemandZones/RegenerateOccasionNet",
    actDemandZonesSetOccasionNet: "/api/v1/DemandZones/SetOccasionNet",
    actDemandZonesSyncDemandZones: "/api/v1/DemandZones/SyncDemandZones",
    actDocumentVersionsSetAllUsages: "/api/v1/DocumentVersions(${key})/SetAllUsages",
    actExportsExportToExcel: "/api/Exports/excel",
    actFeatureFlagsEnableIdeally: "/api/v1/FeatureFlags(${key})/EnableIdeally",
    actFeatureFlagsDisableIdeally: "/api/v1/FeatureFlags(${key})/DisableIdeally",
    actLinkInvitesAcceptShare: "/api/v1/LinkInvites/AcceptShare",
    actNotificationsMarkAsRead: "/api/v1/Notifications(${key})/MarkAsRead",
    actOrgsRename: "/api/v1/Orgs(${key})/Rename",
    actProjectCommentsDismiss: "/api/v1/ProjectComments(${key})/Dismiss",
    actProjectCommentsUndismiss: "/api/v1/ProjectComments(${key})/Undismiss",
    actProjectGroupQuestionsSortOrderChange: "/api/v1/ProjectGroupQuestions/SortOrderChange",
    actProjectGroupsSyncSegmentSurveySessions: "/api/v1/ProjectGroups(${key})/SyncSegmentSurveySessions",
    actProjectGroupsGenerateSegments: "/api/v1/ProjectGroups(${key})/GenerateSegments",
    actProjectGroupsDeleteSegments: "/api/v1/ProjectGroups(${key})/DeleteSegments",
    actProjectGroupsCreateDynamicQuestions: "/api/v1/ProjectGroups(${key})/CreateDynamicQuestions",
    actProjectGroupsShare: "/api/v1/ProjectGroups(${key})/Share",
    actProjectGroupsUnshare: "/api/v1/ProjectGroups(${key})/Unshare",
    actProjectGroupsGenerateSummaries: "/api/v1/ProjectGroups(${key})/GenerateSummaries",
    actProjectGroupsDuplicate: "/api/v1/ProjectGroups(${key})/Duplicate",
    actProjectGroupSegmentsBulkUpdate: "/api/v1/ProjectGroupSegments/BulkUpdate",
    actProjectGroupSegmentsUpdateSessions: "/api/v1/ProjectGroupSegments(${key})/UpdateSessions",
    actProjectNarrativeSectionsCreate: "/api/v1/ProjectNarrativeSections/Create",
    actProjectNarrativeSectionsMoveUp: "/api/v1/ProjectNarrativeSections(${key})/MoveUp",
    actProjectNarrativeSectionsMoveDown: "/api/v1/ProjectNarrativeSections(${key})/MoveDown",
    actProjectNarrativeVersionsGenerateSlideDeck:
      "/api/v1/ProjectNarrativeVersions(${key})/GenerateSlideDeck",
    actProjectQuestionsSortOrderChange: "/api/v1/ProjectQuestions/SortOrderChange",
    actProjectsDuplicate: "/api/v1/Projects(${key})/Duplicate",
    actProjectsDuplicateWithData: "/api/v1/Projects(${key})/DuplicateWithData",
    actProjectsShare: "/api/v1/Projects(${key})/Share",
    actProjectsUndelete: "/api/v1/Projects(${key})/Undelete",
    actProjectsAdminEdit: "/api/v1/Projects(${key})/AdminEdit",
    actProjectsRemoveFromSurveyRun: "/api/v1/Projects(${key})/RemoveFromSurveyRun",
    actProjectsChangeTargets: "/api/v1/Projects(${key})/ChangeTargets",
    actProjectsUpsertSchedule: "/api/v1/Projects(${key})/UpsertSchedule",
    actProjectsUpdatePriceSensitivities: "/api/v1/Projects(${key})/UpdatePriceSensitivities",
    actProjectsUpdateMarketReach: "/api/v1/Projects(${key})/UpdateMarketReach",
    actProjectsUpdateProjectScheduling: "/api/v1/Projects(${key})/UpdateProjectScheduling",
    actProjectsStopProjectScheduling: "/api/v1/Projects(${key})/StopProjectScheduling",
    actProjectsCreatePriceSensitivities: "/api/v1/Projects(${key})/CreatePriceSensitivities",
    actProjectsDeletePriceSensitivities: "/api/v1/Projects(${key})/DeletePriceSensitivities",
    actProjectsCreateMarketReach: "/api/v1/Projects(${key})/CreateMarketReach",
    actProjectsDeleteMarketReach: "/api/v1/Projects(${key})/DeleteMarketReach",
    actProjectsDeleteRegions: "/api/v1/Projects(${key})/DeleteRegions",
    actProjectsIncidenceEstimate: "/api/v1/Projects(${key})/IncidenceEstimate",
    actProjectsUnsubmit: "/api/v1/Projects(${key})/Unsubmit",
    actProjectsSubmit: "/api/v1/Projects(${key})/Submit",
    actProjectsDecline: "/api/v1/Projects(${key})/Decline",
    actProjectsApprove: "/api/v1/Projects(${key})/Approve",
    actProjectsSuperApprove: "/api/v1/Projects(${key})/SuperApprove",
    actProjectsCloseProjectSurvey: "/api/v1/Projects(${key})/CloseProjectSurvey",
    actProjectsPowerPointExport: "/api/v1/Projects(${key})/PowerPointExport",
    actProjectsExportPlanDocument: "/api/v1/Projects(${key})/ExportPlanDocument",
    actProjectsUpdateWatchers: "/api/v1/Projects(${key})/UpdateWatchers",
    actProjectsStopWatching: "/api/v1/Projects(${key})/StopWatching",
    actProjectsStartWatching: "/api/v1/Projects(${key})/StartWatching",
    actProjectsMarkAsDemo: "/api/v1/Projects(${key})/MarkAsDemo",
    actProjectsMove: "/api/v1/Projects(${key})/Move",
    actProjectsCreateUsageAndAttitudeSeedProject: "/api/v1/Projects/CreateUsageAndAttitudeSeedProject",
    actProjectsGenerateQuestionIr: "/api/v1/Projects(${key})/GenerateQuestionIr",
    actProjectsUpdateGroupTags: "/api/v1/Projects(${key})/UpdateGroupTags",
    actProjectsUpdateProjectOwner: "/api/v1/Projects(${key})/UpdateProjectOwner",
    actProjectsDocumentToProject: "/api/v1/Projects/DocumentToProject",
    actProjectsResyncScheduledProject: "/api/v1/Projects(${key})/ResyncScheduledProject",
    actProjectsReTheme: "/api/v1/Projects(${key})/ReTheme",
    actProjectsSetCustomMetrics: "/api/v1/Projects(${key})/SetCustomMetrics",
    actProjectsRunEvaluations: "/api/v1/Projects(${key})/RunEvaluations",
    actProjectsGenerateThumbnails: "/api/v1/Projects(${key})/GenerateThumbnails",
    actProjectsRunFactsFindings: "/api/v1/Projects(${key})/RunFactsFindings",
    actProjectsChangeFramework: "/api/v1/Projects(${key})/ChangeFramework",
    actProjectsSynthAssignProjectToGroup: "/api/v1/Projects(${key})/SynthAssignProjectToGroup",
    actProjectsBackfillResearchObjectives: "/api/v1/Projects(${key})/BackfillResearchObjectives",
    actProjectsGenerateFilterSets: "/api/v1/Projects(${key})/GenerateFilterSets",
    actProjectSchedulesSyncDates: "/api/v1/ProjectSchedules/SyncDates",
    actProjectSchedulesSyncNpdDates: "/api/v1/ProjectSchedules/SyncNpdDates",
    actProjectSchedulesCreateManualSchedule: "/api/v1/ProjectSchedules/CreateManualSchedule",
    actPromptsAssignEvaluations: "/api/v1/Prompts(${key})/AssignEvaluations",
    actPromptsRunWorkflowEvaluations: "/api/v1/Prompts(${key})/RunWorkflowEvaluations",
    actPromptVersionsRun: "/api/v1/PromptVersions(${key})/Run",
    actPromptVersionsPublish: "/api/v1/PromptVersions(${key})/Publish",
    actPromptVersionsImportFromYml: "/api/v1/PromptVersions/ImportFromYml",
    actPromptVersionsImportFromJson: "/api/v1/PromptVersions/ImportFromJson",
    actPromptVersionsDownloadToJson: "/api/v1/PromptVersions(${key})/DownloadToJson",
    actQuestionsDeleteTemplateQuestion: "/api/v1/Questions(${key})/DeleteTemplateQuestion",
    actResearchBuilderThreadsAcceptFrameworkAndBuild:
      "/api/v1/ResearchBuilderThreads(${key})/AcceptFrameworkAndBuild",
    actResearchBuilderThreadsCreateFile: "/api/v1/ResearchBuilderThreads(${key})/CreateFile",
    actResearchBuilderThreadsUpdatePreSelectedFramework:
      "/api/v1/ResearchBuilderThreads(${key})/UpdatePreSelectedFramework",
    actSegmentsGenerateSummaries: "/api/v1/Segments(${key})/GenerateSummaries",
    actSurveyRunsCreateRespondentsCsvEditThread: "/api/v1/SurveyRuns(${key})/CreateRespondentsCsvEditThread",
    actSurveyRunsApplyRespondentsCsvEditProposal:
      "/api/v1/SurveyRuns(${key})/ApplyRespondentsCsvEditProposal",
    actSurveyRunsRunSyntheticSurvey: "/api/v1/SurveyRuns/RunSyntheticSurvey",
    actSurveyRunsCreateSurveys: "/api/v1/SurveyRuns/CreateSurveys",
    actSurveyRunsSyncDecipherSurvey: "/api/v1/SurveyRuns(${key})/SyncDecipherSurvey",
    actSurveyRunsForceCloseSurvey: "/api/v1/SurveyRuns(${key})/ForceCloseSurvey",
    actSurveyRunsStartSurveyProcessing: "/api/v1/SurveyRuns(${key})/StartSurveyProcessing",
    actSurveyRunsCreateOrUpdateSamplifyProject: "/api/v1/SurveyRuns(${key})/CreateOrUpdateSamplifyProject",
    actSurveyRunsLaunchSurvey: "/api/v1/SurveyRuns(${key})/LaunchSurvey",
    actSurveyRunsDecipherRespondents: "/api/v1/SurveyRuns(${key})/DecipherRespondents",
    actSurveyRunsRemoveRespondentsCsv: "/api/v1/SurveyRuns(${key})/RemoveRespondentsCsv",
    actSurveyRunsValidateStagedRespondentsCsv: "/api/v1/SurveyRuns(${key})/ValidateStagedRespondentsCsv",
    actSurveyRunsReplaceRespondentsCsvFromStaging:
      "/api/v1/SurveyRuns(${key})/ReplaceRespondentsCsvFromStaging",
    actSurveyRunsRemoveUuidsFromSurvey: "/api/v1/SurveyRuns(${key})/RemoveUuidsFromSurvey",
    actSurveyRunsReuploadTranslations: "/api/v1/SurveyRuns(${key})/ReuploadTranslations",
    actSurveyRunsRunSimulatedData: "/api/v1/SurveyRuns(${key})/RunSimulatedData",
    actSurveyRunsCreateManualRespondentsCsvProposal:
      "/api/v1/SurveyRuns(${key})/CreateManualRespondentsCsvProposal",
    actSurveyRunsUpdateRespondentsCsvProposal: "/api/v1/SurveyRuns(${key})/UpdateRespondentsCsvProposal",
    actSurveyRunsBackwardsSync: "/api/v1/SurveyRuns(${key})/BackwardsSync",
    actTeamsRename: "/api/v1/Teams(${key})/Rename",
    actTeamsUpdateAutoProjectWatch: "/api/v1/Teams(${key})/UpdateAutoProjectWatch",
    actTextResponsesReassignThemes: "/api/v1/TextResponses(${key})/ReassignThemes",
    actTranslatedTextRegionsAddDemographicTranslations:
      "/api/v1/TranslatedTextRegions/AddDemographicTranslations",
    actUsersEnable: "/api/v1/Users(${key})/Enable",
    actUsersDisable: "/api/v1/Users(${key})/Disable",
    actUsersRemoveFromAccount: "/api/v1/Users(${key})/RemoveFromAccount",
    actUsersSetNames: "/api/v1/Users(${key})/SetNames",
    actUsersSetPassword: "/api/v1/Users(${key})/SetPassword",
    actUsersResendInvite: "/api/v1/Users(${key})/ResendInvite",
    actUsersSetHubspotRole: "/api/v1/Users(${key})/SetHubspotRole",
    actUsersSetResearchSetupConfidence: "/api/v1/Users(${key})/SetResearchSetupConfidence",
    actUsersSetResearchInterpretationConfidence: "/api/v1/Users(${key})/SetResearchInterpretationConfidence",
    actUsersSuperAdminUserCreate: "/api/v1/Users/SuperAdminUserCreate",
    actUsersSuperAdminUserUpdate: "/api/v1/Users(${key})/SuperAdminUserUpdate",
    actUsersBulkInvite: "/api/v1/Users/BulkInvite",
    actUsersParseInviteFile: "/api/v1/Users/ParseInviteFile",
  };
  export type ApiActParams = {
    actAiBatchesAddItems: { key: number };
    actAiBatchesRun: { key: number };
    actAiConversationsAddUserMessage: {
      options?: any;
    } & { key: number };
    actAiConversationsEvaluateConversation: { key: number };
    actAiConversationsContinueConversation: {
      options?: any;
    } & { key: number };
    actAiConversationsDownloadToYml: { key: number };
    actAiMessagesSendFeedback: { key: number };
    actAiMessagesMarkActionTaken: { key: number };
    actAiProjectSummariesRegenerate: { key: number };
    actClientsAdminUpdate: { key: number };
    actClientsValidateDomainRecord: { key: number };
    actClientsSetupTrialAccount: {};
    actClientsRenewalPowerPointExport: { key: number };
    actClientsSaveLogo: { key: number };
    actCognitoIdpsCreateSaml: {};
    actCognitoIdpsUpdateSaml: { key: number };
    actCognitoUsersAdminDelete: { key: number };
    actCreditLogsMakeCreditTransfer: {};
    actDemandZonesRegenerate: {};
    actDemandZonesRegenerateOccasionNet: {};
    actDemandZonesSetOccasionNet: {};
    actDemandZonesSyncDemandZones: {};
    actDocumentVersionsSetAllUsages: { key: number };
    actExportsExportToExcel: {};
    actFeatureFlagsEnableIdeally: { key: number };
    actFeatureFlagsDisableIdeally: { key: number };
    actLinkInvitesAcceptShare: {};
    actNotificationsMarkAsRead: { key: number };
    actOrgsRename: { key: number };
    actProjectCommentsDismiss: { key: number };
    actProjectCommentsUndismiss: { key: number };
    actProjectGroupQuestionsSortOrderChange: {};
    actProjectGroupsSyncSegmentSurveySessions: { key: number };
    actProjectGroupsGenerateSegments: { key: number };
    actProjectGroupsDeleteSegments: { key: number };
    actProjectGroupsCreateDynamicQuestions: { key: number };
    actProjectGroupsShare: { key: number };
    actProjectGroupsUnshare: { key: number };
    actProjectGroupsGenerateSummaries: { key: number };
    actProjectGroupsDuplicate: { key: number };
    actProjectGroupSegmentsBulkUpdate: {};
    actProjectGroupSegmentsUpdateSessions: { key: number };
    actProjectNarrativeSectionsCreate: {};
    actProjectNarrativeSectionsMoveUp: { key: number };
    actProjectNarrativeSectionsMoveDown: { key: number };
    actProjectNarrativeVersionsGenerateSlideDeck: { key: number };
    actProjectQuestionsSortOrderChange: {};
    actProjectsDuplicate: { key: number };
    actProjectsDuplicateWithData: { key: number };
    actProjectsShare: { key: number };
    actProjectsUndelete: { key: number };
    actProjectsAdminEdit: {
      options?: any;
    } & { key: number };
    actProjectsRemoveFromSurveyRun: { key: number };
    actProjectsChangeTargets: {
      options?: any;
    } & { key: number };
    actProjectsUpsertSchedule: {
      options?: any;
    } & { key: number };
    actProjectsUpdatePriceSensitivities: {
      options?: any;
    } & { key: number };
    actProjectsUpdateMarketReach: {
      options?: any;
    } & { key: number };
    actProjectsUpdateProjectScheduling: {
      options?: any;
    } & { key: number };
    actProjectsStopProjectScheduling: { key: number };
    actProjectsCreatePriceSensitivities: {
      options?: any;
    } & { key: number };
    actProjectsDeletePriceSensitivities: {
      options?: any;
    } & { key: number };
    actProjectsCreateMarketReach: {
      options?: any;
    } & { key: number };
    actProjectsDeleteMarketReach: {
      options?: any;
    } & { key: number };
    actProjectsDeleteRegions: {
      options?: any;
    } & { key: number };
    actProjectsIncidenceEstimate: { key: number };
    actProjectsUnsubmit: {
      options?: any;
    } & { key: number };
    actProjectsSubmit: {
      options?: any;
    } & { key: number };
    actProjectsDecline: {
      options?: any;
    } & { key: number };
    actProjectsApprove: {
      options?: any;
    } & { key: number };
    actProjectsSuperApprove: {
      options?: any;
    } & { key: number };
    actProjectsCloseProjectSurvey: {
      options?: any;
    } & { key: number };
    actProjectsPowerPointExport: { key: number };
    actProjectsExportPlanDocument: { key: number };
    actProjectsUpdateWatchers: { key: number };
    actProjectsStopWatching: { key: number };
    actProjectsStartWatching: { key: number };
    actProjectsMarkAsDemo: { key: number };
    actProjectsMove: {
      options?: any;
    } & { key: number };
    actProjectsCreateUsageAndAttitudeSeedProject: {
      options?: any;
    };
    actProjectsGenerateQuestionIr: { key: number };
    actProjectsUpdateGroupTags: { key: number };
    actProjectsUpdateProjectOwner: { key: number };
    actProjectsDocumentToProject: {};
    actProjectsResyncScheduledProject: { key: number };
    actProjectsReTheme: { key: number };
    actProjectsSetCustomMetrics: { key: number };
    actProjectsRunEvaluations: { key: number };
    actProjectsGenerateThumbnails: { key: number };
    actProjectsRunFactsFindings: { key: number };
    actProjectsChangeFramework: {
      options?: any;
    } & { key: number };
    actProjectsSynthAssignProjectToGroup: { key: number };
    actProjectsBackfillResearchObjectives: { key: number };
    actProjectsGenerateFilterSets: { key: number };
    actProjectSchedulesSyncDates: {};
    actProjectSchedulesSyncNpdDates: {};
    actProjectSchedulesCreateManualSchedule: {};
    actPromptsAssignEvaluations: { key: number };
    actPromptsRunWorkflowEvaluations: { key: number };
    actPromptVersionsRun: { key: number };
    actPromptVersionsPublish: { key: number };
    actPromptVersionsImportFromYml: {};
    actPromptVersionsImportFromJson: {};
    actPromptVersionsDownloadToJson: { key: number };
    actQuestionsDeleteTemplateQuestion: { key: number };
    actResearchBuilderThreadsAcceptFrameworkAndBuild: { key: number };
    actResearchBuilderThreadsCreateFile: { key: number };
    actResearchBuilderThreadsUpdatePreSelectedFramework: { key: number };
    actSegmentsGenerateSummaries: { key: number };
    actSurveyRunsCreateRespondentsCsvEditThread: { key: number };
    actSurveyRunsApplyRespondentsCsvEditProposal: { key: number };
    actSurveyRunsRunSyntheticSurvey: {};
    actSurveyRunsCreateSurveys: {};
    actSurveyRunsSyncDecipherSurvey: { key: number };
    actSurveyRunsForceCloseSurvey: { key: number };
    actSurveyRunsStartSurveyProcessing: { key: number };
    actSurveyRunsCreateOrUpdateSamplifyProject: { key: number };
    actSurveyRunsLaunchSurvey: { key: number };
    actSurveyRunsDecipherRespondents: { key: number };
    actSurveyRunsRemoveRespondentsCsv: { key: number };
    actSurveyRunsValidateStagedRespondentsCsv: { key: number };
    actSurveyRunsReplaceRespondentsCsvFromStaging: { key: number };
    actSurveyRunsRemoveUuidsFromSurvey: { key: number };
    actSurveyRunsReuploadTranslations: { key: number };
    actSurveyRunsRunSimulatedData: { key: number };
    actSurveyRunsCreateManualRespondentsCsvProposal: { key: number };
    actSurveyRunsUpdateRespondentsCsvProposal: { key: number };
    actSurveyRunsBackwardsSync: { key: number };
    actTeamsRename: { key: number };
    actTeamsUpdateAutoProjectWatch: { key: number };
    actTextResponsesReassignThemes: { key: number };
    actTranslatedTextRegionsAddDemographicTranslations: {};
    actUsersEnable: { key: number };
    actUsersDisable: { key: number };
    actUsersRemoveFromAccount: { key: number };
    actUsersSetNames: { key: number };
    actUsersSetPassword: { key: number };
    actUsersResendInvite: { key: number };
    actUsersSetHubspotRole: { key: number };
    actUsersSetResearchSetupConfidence: { key: number };
    actUsersSetResearchInterpretationConfidence: { key: number };
    actUsersSuperAdminUserCreate: {};
    actUsersSuperAdminUserUpdate: { key: number };
    actUsersBulkInvite: {};
    actUsersParseInviteFile: {};
  };
  export interface AuthActPathTypes {
    actLoginRefreshLogin: AccessTokenDto;
    actLoginLogout: boolean;
    actLoginVerifyRegistrationEmail: VerifyRegistrationResult;
    actLoginAcceptInvitation: AcceptInvitationResponse;
    actLoginPasswordLogin: AccessTokenDto;
    actLoginNewPasswordRequired: AccessTokenDto;
    actLoginForgotPassword: boolean;
    actLoginResetPassword: boolean;
  }
  export interface AuthActErrorTypes {
    actLoginRefreshLogin: AuthFailureDto | AuthChallengeDto;
    actLoginLogout: any;
    actLoginVerifyRegistrationEmail: any;
    actLoginAcceptInvitation: AuthFailureDto | LinkInvalidDto;
    actLoginPasswordLogin: AuthFailureDto | AuthChallengeDto;
    actLoginNewPasswordRequired: AuthFailureDto;
    actLoginForgotPassword: AuthFailureDto;
    actLoginResetPassword: AuthFailureDto | LinkInvalidDto | LinkExpiredDto;
  }
  export const authActPaths: { [key in keyof AuthActPathTypes]: string } = {
    actLoginRefreshLogin: "/auth/Login/Refresh",
    actLoginLogout: "/auth/Login/Logout",
    actLoginVerifyRegistrationEmail: "/auth/Login/VerifyRegistrationEmail",
    actLoginAcceptInvitation: "/auth/Login/AcceptInvitation",
    actLoginPasswordLogin: "/auth/Login/PasswordLogin",
    actLoginNewPasswordRequired: "/auth/Login/NewPasswordRequired",
    actLoginForgotPassword: "/auth/Login/ForgotPassword",
    actLoginResetPassword: "/auth/Login/ResetPassword",
  };
  export type AuthActParams = {
    actLoginRefreshLogin: {};
    actLoginLogout: {};
    actLoginVerifyRegistrationEmail: {};
    actLoginAcceptInvitation: {};
    actLoginPasswordLogin: {};
    actLoginNewPasswordRequired: {};
    actLoginForgotPassword: {};
    actLoginResetPassword: {};
  };
}
